// src/i18n.js
import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        questionBank: 'Question Bank',
        searchQuestions: 'Search questions...',
        confirmDelete: 'Confirm Delete',
        deletePrompt: 'Are you sure you want to delete this question?',
        cancel: 'Cancel',
        delete: 'Delete',
        deleted: 'Deleted',
        questionDeleted: 'Question deleted successfully',
        error: 'Error',
        failedToDelete: 'Failed to delete question',
        topic: 'Topic',
        subTopic: 'Sub Topic',
        actions: 'Actions',
        question: 'Question',
        createNewQuestion: 'Create New Question',
        editQuestion: "Edit Question",
        questionType: 'Question Type',
        multipleChoice: 'Multiple Choice',
        questionText: 'Question Text',
        enterQuestion: 'Enter your question...',
        topic: 'Topic',
        enterTopic: 'Enter topic...',
        subTopic: 'Sub topic',
        enterSubTopic: 'Enter sub topic...',
        answerOptions: 'Answer Options',
        addOption: '+ Add Option',
        selectCorrectAnswer: 'Select Correct Answer',
        option: 'Option',
        submit: 'Submit',
        error: 'Error',
        pleaseFill: 'Please fill all required fields.',
        failedToAdd: 'Failed to add question.',
        success: 'Success',
        questionAdded: 'Question added successfully!',
        somethingWrong: 'Something went wrong.',
        createQuizBasic: 'Create Quiz',
        createDailyQuiz: 'Create Daily Quiz',
        updateDailyQuiz: 'Update Daily Quiz',
        updateQuestions: 'Update Questions',
        editQuiz: 'Edit Quiz',
        questionType: 'Question Type',
        multipleChoice: 'Multiple Choice',
        openQuiz: 'Open Quiz',
        quizTitle: 'Quiz Title',
        quizTitlePlaceholder: 'Enter quiz title',
        quizTitleRequired: 'Quiz title is required.',
        quizDescription: 'Quiz Description',
        quizDescriptionRequired: 'Quiz description is required.',
        topic: 'Topic',
        topicPlaceholder: 'Enter topic',
        subTopic: 'Sub Topic',
        subTopicPlaceholder: 'Enter sub topic',
        startDate: 'Start Date',
        endDate: 'End Date',
        startTime: 'Start Time',
        endTime: 'End Time',
        quizVisibility: 'Quiz Visibility',
        selectVisibility: 'Select visibility',
        public: 'Public',
        private: 'Private',
        save: 'Save',
        cancel: 'Cancel',
        editQuestions: 'Edit Questions',
        addQuestions: 'Add Questions',
        quizUpdated: 'Quiz Updated',
        quizCreated: 'Quiz Created',
        quizUpdatedDetail: 'The quiz has been successfully updated.',
        quizCreatedDetail: 'The quiz has been successfully created.',
        error: 'Error',
        saveQuizError: 'An error occurred while saving the quiz. Please try again.',
        createQuizError: 'An error occurred while creating the quiz. Please try again.',
        noQuizSelected: 'No Quiz Selected',
        saveQuizBeforeEdit: 'Please save the quiz before editing questions.',
        toJoinGoTo: 'To join, go to',
        quizAppName: 'JainDirect Quiz',
        preview: 'Preview',
        addQuestionPlaceholder: 'Click to add question',
        addImageForQuestion: 'Add image for your question',
        addAudioForQuestion: 'Add audio for your question',
        addBackgroundImage: 'Add Background image',
        addAudioForBackground: 'Add audio for background',
        questionImage: 'Question Image',
        option: 'Option',
        save: 'Save',
        question: 'Question',
        yourQuestion: 'Your Question',
        addFromQuestionBank: 'ADD QUESTION FROM QUESTION-BANK',
        yourQuestionPlaceholder: 'Your question...',
        pickAnswer: 'Pick Answer',
        shortAnswer: 'Short Answer',
        addOption: '+ Add Option',
        shortAnswerPlaceholder: 'Enter your short answer here...',
        points: 'Points',
        fasterAnswersGetMorePoints: 'Faster answers get more points',
        timeLimit: 'Time limit',
        seconds: 'seconds',
        leaderboard: 'Leaderboard',
        generalQuizzes: 'General Quizzes',
        dailyQuizLeaderboard: 'Daily Quiz Leaderboard',
        sansthaQuizLeaderboard: 'Sanstha Quiz Leaderboard',
        generalQuizSettings: 'General quiz settings',
        type: 'Type',
        back: 'Back',
        next: 'Next',
        confirmSave: 'Confirm Save',
        confirmSaveMessage: 'Are you sure want to save this question for in quiz?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        questionBank: 'Question Bank',
        selectAll: 'Select All',
        noQuestionsInBank: 'No questions available in the bank.',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
        of: 'of',
        cancel: 'Cancel',
        addQuiz: 'ADD QUIZ',
        join_instruction: 'To join, go to:',
        add_image: 'Add image for your question',
        add_audio: 'Add audio for your question',
        add_bg_image: 'Add Background image',
        add_bg_audio: 'Add audio for background',
        save: 'Save',
        your_question: 'Your Question',
        add_from_bank: 'ADD QUESTION FROM QUESTION-BANK',
        placeholder_question: 'Your question...',
        add_option: '+ Add Option',
        short_answer_placeholder: 'Enter your short answer here...',
        points: 'Points',
        faster_points: 'Faster answers get more points',
        time_limit: 'Time limit',
        seconds: 'seconds',
        leaderboard: 'Leaderboard',
        settings: 'General quiz settings',
        pick_answer: 'Pick Answer',
        short_answer: 'Short Answer',
        back: 'Back',
        next: 'Next',
        confirm_save_title: 'Confirm Save',
        confirm_save_text: 'Are you sure want to save this question for in quiz?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        question_bank: 'Question Bank',
        select_all: 'Select All',
        no_questions: 'No questions available in the bank.',
        previous: 'Previous',
        page: 'Page',
        of: 'of',
        next_page: 'Next',
        add_quiz: 'ADD QUIZ',
        untitled_question: 'Untitled Question',
        questionBank: 'Question Bank',
        selectAll: 'Select All',
        noQuestions: 'No questions available in the bank.',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
        of: 'of',
        cancel: 'Cancel',
        addQuiz: 'ADD QUIZ',
        questionBank: 'Question Bank',
        searchQuestions: 'Search questions...',
        question: 'Question',
        actions: 'Actions',
        confirmDelete: 'Confirm Delete',
        confirmDeleteMsg: 'Are you sure you want to delete this quiz?',
        cancel: 'Cancel',
        delete: 'Delete',
        deleted: 'Deleted',
        deleteSuccess: 'Question deleted successfully',
        deleteError: 'Failed to delete question',
        back: 'Back',
        createTitle: 'Create Sanstha Quiz',
        editTitle: 'Edit Quiz',
        sansthaName: 'Sanstha Name',
        quizDescription: 'Quiz Description',
        uploadImage: 'Upload Image for quiz',
        topic: 'Topic',
        timedQuiz: 'Timed Quiz',
        enabled: 'Enabled',
        disabled: 'Disabled',
        visibility: 'Quiz Visibility',
        selectVisibility: 'Select visibility',
        public: 'Public',
        private: 'Private',
        save: 'Save',
        cancel: 'Cancel',
        addQuestions: 'Add Questions',
        editQuestions: 'Edit Questions',
        dragDrop: 'Drag and drop or click to select an image',
        required: '{field} is required',
        successSave: 'Quiz saved successfully!',
        errorSave: 'Failed to save quiz.',
        imageSelected: 'Image Selected',
        sansthaQuizzes: 'Sanstha Quizzes',
        createSansthaQuiz: 'Create Sanstha Quiz',
        quizTitle: 'Sanstha Name',
        quizDescription: 'Quiz Description',
        uploadQuizImage: 'Upload Image for quiz',
        topic: 'Topic',
        timedQuiz: 'Timed Quiz',
        enabled: 'Enabled',
        disabled: 'Disabled',
        quizVisibility: 'Quiz Visibility',
        public: 'Public',
        private: 'Private',
        save: 'Save',
        cancel: 'Cancel',
        editQuestions: 'Edit Questions',
        addQuestions: 'Add Questions',
        successQuizSaved: 'Quiz saved successfully!',
        errorQuizSave: 'Failed to save quiz.',
        successCopy: 'Quiz link copied to clipboard!',
        copyQuizLink: 'Copy Quiz Link',
        educatorDashboard: 'Educator Dashboard',
        createQuizBasic: 'Create Quiz',
        totalQuizzes: 'Total Quizzes',
        totalAttempts: 'Total Attempts',
        totalRegisteredUsers: 'Total Registered Users',
        averageScore: 'Average Score',
        completionRate: 'Completion Rate',
        thisWeek: 'this week',
        addedThisWeek: '+3',
        scoreIncrease: '+2.5%',
        completionIncrease: '+4%',
        recentQuizzes: 'Recent Quizzes',
        quizTitle: 'Quiz Title',
        dateCreated: 'Date Created',
        attempts: 'Attempts',
        status: 'Status',
        action: 'Action',
        selectOne: 'Select One',
        viewAllQuizzes: 'View All Quizzes',
        viewAllQuizzesDesc: 'Access and manage all your quizzes.',
        quizAnalytics: 'Quiz Analytics',
        quizAnalyticsDesc: 'Detailed performance insights.',
        studentReports: 'Student Reports',
        studentReportsDesc: 'Track individual student progress.',
        viewReports: 'View Reports',
        myQuizzes: 'My Quizzes',
        manageAndOrganize: 'Manage and organize your assessments',
        createNewQuiz: '+ Create New Quiz',
        searchPlaceholder: 'Search quizzes...',
        allQuizzes: 'All Quizzes',
        active: 'Active',
        inactive: 'Inactive',
        completed: 'Completed',
        loading: 'Loading...',
        questions: 'Questions',
        aboutThisQuiz: 'About this quiz',
        editQuiz: 'Edit Quiz',
        copyLink: 'Copy Link',
        viewQuestions: 'View Questions',
        deleteQuiz: 'Delete Quiz',
        delete: 'Delete',
        showingQuizzes: 'Showing {count} quizzes',
        pageOf: 'Page {current} of {total}',
        noQuizzesFoundTitle: 'No quizzes found',
        tryAdjustingSearch: 'Try adjusting your search or filters',
        confirmDelete: 'Confirm Delete',
        areYouSureDelete: 'Are you sure you want to delete',
        cancel: 'Cancel',
        deleting: 'Deleting...',
        chooseReportType: 'Choose Report Type',
        quizReport: 'Quiz report',
        userReport: 'User report',
        quizReportDesc: 'View report for this quiz (per-question user attempts)',
        userReportDesc: 'View per-user question results (right/wrong)',
        previous: 'Previous',
        next: 'Next',
        noQuizzesFound: 'No quizzes found.',
        quizQuestions: 'Quiz Questions',
        noQuestionsFound: 'No questions found for this quiz.',
        points: 'Points',
        date: 'Date',
        close: 'Close',
        showQuizInstruction: 'Show Quiz Instruction',
        hideQuizInstruction: 'Hide Quiz Instruction',
        howToCreateQuiz: 'How to Create a Quiz',
        quizTip1: 'Enter a clear and short Quiz Title.',
        quizTip2: 'Select a suitable Category like Multiple Choice.',
        quizTip3: 'Provide a short Description for learners.',
        quizTip4: 'Choose how many days the quiz will run and set start/end dates.',
        quizTip5: 'Mark holidays (if any) to skip quiz questions on those days.',
        quizTip6: 'Set how many questions will appear daily.',
        quizTip7: 'Pick a difficulty level (Easy / Medium / Hard).',
        createQuiz: 'Create Quiz',
        quizTitle: 'Quiz Title',
        enterQuizTitle: 'Enter quiz title',
        category: 'Category',
        multipleChoice: 'Multiple Choice',
        quizDescription: 'Quiz Description',
        startDate: 'Start Date',
        endDate: 'End Date',
        startTime: 'Start Time',
        endTime: 'End Time',
        selectHolidayDays: 'Select Holiday Days',
        dailyQuestionCount: 'How many questions do you set in one day',
        selectNumber: 'Select a number',
        difficultyLevel: 'Difficulty Level',
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        createQuiz: 'Create Quiz',
        updateQuiz: 'Update Quiz',
        createQuestions: 'Create Questions',
        saveQuestions: 'Save Questions',
        back: 'Back',
        show: 'Show',
        hide: 'Hide',
        quizInstruction: 'Quiz Instruction',
        howToCreateQuestion: '📘 How to Create a Question',
        quizTitle: 'Quiz Title',
        category: 'Category',
        multipleChoice: 'Multiple Choice',
        description: 'Description',
        daysQuizRun: 'Choose how many days the quiz will run and set start/end dates.',
        markHolidays: 'Mark holidays (if any) to skip quiz questions on those days.',
        questionsPerDay: 'Set how many questions will appear daily.',
        difficultyLevel: 'Pick a difficulty level (Easy / Medium / Hard).',
        questionBuilder: 'Question Builder',
        addFromQuestionBank: '+ Add from Question Bank',
        question: 'Question',
        removeQuestion: 'Remove Question',
        enterQuestion: 'Enter your question here...',
        addImageOfQuestion: 'Add Image of Question',
        addAudioOfQuestion: 'Add Audio of Question',
        addVideoOfQuestion: 'Add Video of Question',
        options: 'Options',
        option: 'Option',
        addAnotherOption: '+ Add another option',
        correctAnswer: 'Correct Answer',
        questionDate: 'Question Date',
        selectQuestionDate: 'Select Question Date',
        addNewQuestion: '+ Add New Question',
        questionBank: 'Question Bank',
        selectQuestionsFromBank: 'Select Questions from Bank',
        noQuestionsAvailable: 'No questions available in the bank.',
        addSelected: 'Add Selected',
        cancel: 'Cancel',
        added: 'Added',
        selectedQuestionsAdded: 'Selected questions added to the quiz builder.',
        error: 'Error',
        failedToLoadBank: 'Failed to load questions from the bank.',
        noData: 'No Data',
        noQuestionsFound: 'No questions found for this quiz.',
        failedToLoadQuizQuestions: 'Failed to load quiz questions.',
        remove: '✖',
        selectAll: 'Select All',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
        of: 'of',
        addQuiz: 'ADD QUIZ',
        noAvailableQuizzes: 'No Available Quizzes',
        quizzesWillAppear: 'New quizzes will appear here once available. Stay tuned!',
        noDetailsAvailable: 'No details available',
        questions: 'Questions',
        marks: 'Marks',
        start: 'Start',
        end: 'End',
        comingSoon: 'Coming Soon',
        startQuiz: 'Start Quiz',
        failedToLoadQuizzes: 'Failed to load quizzes. Please try again.',
        daily_quiz_challenges: 'Daily Quiz Challenges',
        test_your_knowledge: 'Test your knowledge with our daily curated quizzes',
        search_placeholder: 'Search for quizzes...',
        todays_special: "Today's Special",
        start_quiz: 'Start Quiz',
        all: 'All',
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        sort_by_latest: 'Sort by: Latest',
        sort_by_popular: 'Sort by: Popular',
        questions: 'Questions',
        no_quizzes_found: 'No quizzes found!',
        prev: 'Prev',
        next: 'Next',
        active_users: 'Active Users',
        daily_winners: 'Daily Winners',
        success_rate: 'Success Rate',
        quizzes_available: 'Quizzes Available',
        sansthaName: 'Jain Ahir Sanstha',
        topicName: 'Topic Name',
        addQuestionImage: 'Add Question Image',
        addQuestionAudio: 'Add Question Audio',
        defaultQuestion: 'Click to add your awesome question',
        quizQuestion: 'Quiz Question',
        option: 'Option',
        addOption: '+ Add Option',
        points: 'Points',
        timer: 'Timer (sec)',
        bonus: 'Faster answers get more points',
        confirmSave: 'Confirm Save',
        confirmMsg: 'Are you sure want to save this question for in quiz?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        mcq: 'MCQ',
        save: 'Save',
        quizzes: 'Quizzes',
        quizTitle: 'Quiz Title',
        topic: 'Topic',
        subTopic: 'Sub topic',
        sansthaName: 'Sanstha name',
        startDate: 'Start Date',
        endDate: 'End Date',
        quizDetail: 'Quiz Detail',
        action: 'Action',
        noQuizzes: 'No quizzes are available.',
        confirmDelete: 'Confirm Delete',
        deleteMsg: 'Are you sure you want to delete this quiz?',
        cancel: 'Cancel',
        delete: 'Delete',
        viewQuestions: 'Questions for',
        close: 'Close',
        linkCopied: 'Quiz link copied to clipboard.',
        copyError: 'Could not copy the link.',
        quizDeleted: 'The quiz and its associated data have been deleted successfully.',
        deleteError: 'Failed to delete the quiz or its associated data.',
        // menu: {
        home: 'Home',
        pages: 'Pages',
        userDashboard: 'User Dashboard',
        educatorDashboard: 'Educator Dashboard',
        quizDashboard: 'Quiz Dashboard',
        questionBank: 'Question Bank',
        sansthaQuiz: 'Sanstha Quiz',
        sansthaQuizzes: 'Sanstha Quizzes',
        dailyQuizzes: 'Daily Quizzes',
        quizes: 'Quizzes',
        adminDashboard: 'Admin Dashboard',
        addBrandOrSponsorImage: 'Add Brand or Sponsor Image',
        analyticsOverview: 'Analytics Overview',
        overallAnalytics: 'Overall Analytics',
        settings: 'Settings',
        leaderboardPublishing: 'Leaderboard Publishing',
        profile: 'Profile',
        managedByMe: 'Managed By Me',
        dailyQuizCreation: 'Daily Quiz Creation',
        switchToEducator: 'Switch to Educator',
        switchToParticipant: 'Switch to Participant',
        language: 'Language',
        switchToHindi: 'Switch to Hindi',
        switchToEnglish: 'Switch to English',
        // },
        weeklyQuizCompletion: 'Weekly Quiz Completion',
        quizCompletionStatus: 'Quiz Completion Status',
        completed: 'Completed',
        inProgress: 'In Progress',
        notStarted: 'Not Started',
        completions: 'Completions',
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        leaderboard: 'Leaderboard',
        sendMessages: 'Send Messages',
        manageUsers: 'Manage Users',
        roles: 'Roles',
        assignLuckyWinners: 'Assign Lucky Winners',
        // Question bank toast
        errorFillFields: 'Please fill all required fields.',
        errorInsert: 'Failed to add question.',
        errorUnexpected: 'Something went wrong.',
        successInsert: 'Question added successfully!',
        successUpdate: 'Question Updated Successfully!',
        confirmEdit: 'Confirm Edit',
        editPrompt: 'Do you want to edit this question?',
        yes: 'Yes',

        // daily quiz question
        enterClearQuestionText: 'Enter a clear and complete question',
        addOptions: 'Add answer options',
        minimumTwoRequired: 'at least 2 required',
        markCorrectAnswer: 'Select the correct answer',
        addImageOrAudioOptional: 'Optionally upload an image or audio',
        setQuestionDateWithinQuizRange: 'Set the question date within the quiz schedule',
        assignPoints: 'Assign points for this question',
        useSimpleLanguage: 'Use simple and clear language for better understanding',
        points: 'Points',
        durationInDays: 'Duration (in Days)',
        enterDays: 'Enter number of days',

        // Lucky winner
        luckyWinnersManagement: 'Lucky Winners Management',
        dailyWinners: 'Daily Winners',
        weeklyWinners: 'Weekly Winners',
        selectDate: 'Select date',
        searchParticipants: 'Search participants by name or ID',
        quizName: 'Quiz Name',
        participantId: 'Participant ID',
        name: 'Name',
        quizType: 'Quiz Type',
        score: 'Score',
        participationDate: 'Participation Date',
        performance: 'Performance',
        winnerStatus: 'Winner Status',
        alreadyWinner: 'Already Winner',
        gold: 'Gold',
        silver: 'Silver',
        bronze: 'Bronze',
        sendNotifications: 'Send Notifications',
        clearSelection: 'Clear Selection',
        saveWinners: 'Save Winners',
        noParticipantsFound: 'No participants found for',
        noWinnersSelected: 'Please select at least one winner.',
        noNewWinners: 'Please select at least one new winner.',
        winnersSaved: 'Lucky winners have been saved successfully!',
        saveFailed: 'Save Failed',
        success: 'Success',
        error: 'Error',
        whatsappError: 'WhatsApp Error',
        excellent: 'Excellent',
        good: 'Good',
        average: 'Average',
        saveWeeklyWinners: 'Save Weekly Winners',
        weeklyWinnersSaved: 'Weekly winners saved successfully!',
        saveError: 'Error saving weekly winners',
        fetchError: 'Error fetching participants',
        noParticipantsSelected: 'Please select at least one participant',

        // role management
        roleManagement: 'Role Management',
        roleManagementDesc: 'Manage and create roles for your quiz system',
        addNewRole: 'Add New Role',
        roleName: 'Role Name',
        enterRoleName: 'Enter role name',
        description: 'Description',
        enterDescription: 'Enter role description',
        permissions: 'Permissions',
        createRole: 'Create Role',
        currentRoles: 'Current Roles',
        searchRoles: 'Search roles...',
        createdDate: 'Created Date',
        updatedDate: 'Updated Date',
        validationError: 'Please fill all fields.',
        roleCreationFailed: 'Role Creation Failed',
        permissionMappingFailed: 'Permission Mapping Failed',
        roleCreated: 'Role created successfully!',

        // manage users
        quizAccessControl: 'Quiz Management Access Control',
        quizAccessControlDesc: 'Manage users who can create and edit quizzes',
        addNewUser: 'Add New User',
        quizManagerRole: 'Quiz Manager Role',
        quizManagerRoleDesc: 'Users with this role can create, edit, and delete quizzes',
        createQuizzes: 'Create new quizzes',
        editQuizzes: 'Edit existing quizzes',
        deleteQuizzes: 'Delete quizzes',
        manageSettings: 'Manage quiz settings',
        viewAnalytics: 'View analytics',
        assignPermissions: 'Assign permissions',
        currentManagers: 'Current Quiz Managers',
        noManagers: 'No quiz managers available',
        noEducatorsInSoftware: 'There is no educator in your software',
        userName: 'User Name',
        email: 'Email',
        mobile: 'Mobile Number',
        role: 'Role',
        accessLevel: 'Access Level',
        dateAdded: 'Date Added',
        actions: 'Actions',
        confirmAddManager: 'Confirm Manager Addition',
        confirmAddText: 'Are you sure you want to add manager?',
        yes: 'Yes',
        cancel: 'Cancel',
        editManagerRole: 'Edit Manager Role',
        selectRole: 'Select Role',
        save: 'Save',
        confirmDeletion: 'Confirm Deletion',
        confirmDeleteText: 'Are you sure you want to delete this manager?',
        yesDelete: 'Yes, Delete',
        error: 'Error',
        invalidManager: 'Invalid manager selected',
        deleteFailed: 'Failed to delete manager',
        deleteSuccess: '{name} removed from quiz managers',
        roleUpdateFailed: 'Failed to update role',
        roleUpdated: 'Manager role updated successfully',

        // get leadershipboard
        selectQuizAndDate: 'Select Quiz & Date',
        selectDate: 'Select Date',
        chooseQuiz: 'Choose Quiz',
        selectAQuiz: 'Select a quiz',
        viewLeaderboard: 'View Leaderboard',
        seeHowYouRank: 'See how you rank against others and challenge yourself 💡',
        userNotLoggedIn: 'User not logged in',
        noScoresFound: '❌ No scores found for this date.',
        noQuizzesFound: '❌ No Quizzes Available!',

        // create sanstha quiz
        organizationQuizUrl: 'Organization Quiz URL',
        active: 'Active',
        quickAccess: 'Quick Access',
        scanQrCode: 'Scan QR code to access quiz portal',
        createNewQuiz: 'Create New Quiz',
        quizTitle: 'Quiz Title',
        enterQuizTitle: 'Enter quiz title',
        organization: 'Organization',
        description: 'Description',
        enterDescription: 'Enter quiz description',
        quizDurationType: 'Quiz Duration Type',
        singleDay: 'Single Day',
        multiDay: 'Multi Day',
        topic: 'Topic',
        enterTopic: 'Enter topic',
        subtopic: 'Subtopic',
        enterSubtopic: 'Enter subtopic',
        startDate: 'Start Date',
        startTime: 'Start Time',
        endDate: 'End Date',
        endTime: 'End Time',
        releaseResult: 'Release Result',
        instant: 'Instant',
        scheduled: 'Scheduled',
        resultReleaseDate: 'Result Release Date',
        resultReleaseTime: 'Result Release Time',
        createQuizBtn: 'Create Quiz',

        // Validation / Toasts
        validationQuizTitle: 'Please enter Quiz Title',
        validationTopic: 'Please enter Topic',
        validationDuration: 'Please select Quiz Duration Type',
        validationStartDate: 'Please select Start Date',
        validationStartTime: 'Please select Start Time',
        validationEndDate: 'Please select End Date',
        validationEndTime: 'Please select End Time',
        validationReleaseResult: 'Please select Release Result option',
        validationResultReleaseDate: 'Please select Result Release Date',
        validationResultReleaseTime: 'Please select Result Release Time',
        quizCreated: 'Quiz created successfully',
        quizCreateFailed: 'Failed to create quiz',

        // sanstha quiz educator
        header: 'Sanstha Quizzes',
        subHeader: 'Browse through our collection of institutional quizzes',
        createSansthaQuiz: '+ Create Sanstha Quiz',
        copyLink: 'Copy Link',
        edit: 'Edit',
        noDescription: 'No description available',
        totalQuestions: 'Qs',
        totalTime: 'mins',
        quizLinkCopied: 'Quiz link copied to clipboard!',

        // sanstha quiz participant
        sansthaQuizLists: 'Sanstha Quiz Lists',
        header: 'Sanstha Quizzes',
        subHeader: 'Browse through our collection of institutional quizzes',
        sanstha: 'Sanstha',
        noDescription: 'No description available',
        totalQuestions: 'Qs',
        totalTime: 'mins',
        quizNotFinished: 'Quiz Not Finished Yet',
        leaderboardNotAvailable: 'Leaderboard is not available yet!',
        quizStillRunning: 'This quiz is still running. Please come back after it ends.',
        endsOn: 'Ends On:',
        stayTuned: 'Stay tuned! Results will be available soon after the quiz ends.',
        gotIt: 'Got it',

        // daily quiz participant
        dailyQuizLists: 'Daily Quiz Lists',
        dailyQuizChallenge: 'Daily Quiz Challenge',
        dailyQuizSubHeader: 'Test your knowledge with our daily curated quizzes',
        noDataAvailable: 'No data available',
        allDifficulties: 'All Difficulties',
        questions: 'Questions',
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        allCategories: 'All Categories',
        beginChallenge: 'Begin Challenge',
        nextQuestion: 'Next Question',
        noMoreQuestions: 'No more questions',
        startTime: 'Start Time',
        startQuiz: 'Start Quiz',
        prev: 'Prev',
        next: 'Next',
        noQuizzesAvailable: 'No quizzes are available at the moment.',
        dailyKnowledgeChallenge: 'Daily Quiz',
        generalKnowledgeQuiz: 'General Knowledge Quiz',
        noDetailAvailable: 'No Detail Available!',
        startQuizNow: 'Start Quiz Now',
        quizEnded: 'This quiz has ended.',
        exploreMoreQuizzes: 'Please explore and attend more quizzes!',
        viewMoreQuizzes: 'View More Quizzes',
        noQuestionToday: 'No question available for today!',
        refresh: 'Refresh',
        alreadyCompletedToday: 'You have already completed today\'s quiz',
        viewRules: 'View Rules',
        quizDetails: 'Quiz Details',
        topicLabel: 'Topic',
        generalKnowledge: 'General Knowledge',
        difficultyLabel: 'Difficulty',
        availableUntil: 'Available Until',
        notSet: 'Not Set',
        rulesAndRegulations: 'Rules & Regulations',
        rule1: 'Read each question carefully before answering.',
        rule2: 'Select the best possible answer for each question.',
        rule3: 'Submit your answers before the quiz ends.',
        rule4: 'Points are awarded only for correct answers.',
        rule5: 'Consecutive correct answers increase your streak bonus.',
        rule6: 'Cheating or using external help may disqualify you.',
        completeProfile: 'Complete Profile',
        completeProfileToContinue: 'Please complete your profile to continue.',
        goToProfile: 'Go to Profile',
        firstQuestionOnDate: 'First question will appear on {date} at {time}',
        firstQuestionTomorrow: 'First question will appear tomorrow at {time}',
        firstQuestionToday: 'First question will appear today at {time}',
        quizEndedMessage: 'This quiz has ended.',
        noQuestionTodayMessage: 'No question available today.',
        quizEndingToday: 'Today\'s quiz is about to end.',
        nextQuestionOnDate: 'Next question will appear on {date} at {time}',
        nextQuestionTomorrow: 'Next question will appear tomorrow at {time}',
        nextQuestionToday: 'Next question will appear today at {time}',
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        night: 'Night',
        startsIn: 'Starts in',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        importantNotice: 'Important Notice',
        readBeforeStarting: 'Read Before Starting',
        ensureStableConnection: 'Please ensure stable internet connection. Once started, the timer cannot be paused.',
        completeAllQuestions: 'Complete all questions before time runs out',
        noExternalResources: 'No external resources allowed during exam',
        submitBeforeExpiry: 'Submit answers before timer expires',
        details: 'Details',
        rules: 'Rules',
        results: 'Results',
        quizInformation: "Quiz Information",
        subjectCategory: 'Subject Category',
        quizType: "Quiz Type",
        quizRules: "Quiz Rules",
        quizTips: "Quiz Tips",
        difficultyLevel: 'Difficulty Level',
        totalQuestions: 'Total Questions',
        availableDate: 'Quiz Expires on',
        time: 'Time',
        dq_start_time: "Daily Quiz Start Time",
        readAllOptions: 'Read all options carefully',
        focusTimeManagement: 'Focus on time management',
        solveEasyFirst: 'Solve easy questions first',
        resultsComingSoon: 'Results Coming Soon',
        resultsWillBeAvailable: 'Results will be available after the quiz ends.',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
        adminTitle: 'JainDirect Quiz - Admin Dashboard',
        totalSanstha: 'Total Sansthas',
        totalQuizzes: 'Total Quizzes Created',
        activeQuizzes: 'Active Quizzes',
        totalParticipants: 'Total Participants',
        userEngagement: 'User Engagement Growth',
        engagementChannels: 'Engagement Channels Overview',
        whatsappMessages: 'WhatsApp Messages Sent',
        emailMessages: 'Emails Sent',
        avgScore: 'Average Score',
        dailyActiveUsers: 'Daily Active Quiz Takers',
        topQuizzes: 'Top 5 Quizzes by Attempts',
        platformUsageDistribution: 'Platform Usage Distribution',
        activeUsers: 'Active Users',
        mostPopularQuizzes: 'Most popular quizzes recently',
        totalParticipants: 'Total Participants',
        newParticipants: 'New Participants',
        totalEducators: 'Educators',
        attempts: 'Attempts',
        viewDetails: 'View Details',
        noDescription: 'No description',
        allSansthas: 'All Sansthas',
        searchPlaceholder: 'Search...',
        noLocation: 'No location',
        report: 'Report',

        profile: 'Profile',
        messages: 'Messages',
        logout: 'Logout',

        shortAppName: 'JD Quiz',
        fullAppName: 'JainDirect Quiz',

        // particular sanstha quiz

        title: 'Quiz',
        organization: 'Organization Name',
        description: 'Description',
        statistics: 'Quiz Statistics',
        total_questions: 'Total Questions',
        total_points: 'Total Points',
        total_time: 'Total Time',
        duration: 'Duration',
        dates: 'Dates',
        start_date: 'Start Date',
        end_date: 'End Date',
        time: 'Time',
        start: 'Start',
        end: 'End',
        additional_info: 'Additional Information',
        participants_limit: 'Participants Limit',
        unlimited: 'Unlimited',
        difficulty: 'Difficulty Level',
        intermediate: 'Intermediate',
        quiz_not_started: 'Quiz not yet started',
        quiz_live: 'Start Quiz',
        quiz_ended: 'Quiz ended',
        quizNotAvailable: 'Quiz not available for users ',
        noQuestionsInQuiz: 'This quiz does not contain any questions',

        leaderboardPublishMode: 'Leaderboard Publish Mode',
        selectOption: 'Select an option',
        autoPublish: 'Auto Publish',
        manualPublish: 'Manual Publish',
        autoPublishHint: 'Leaderboard will be published automatically after the quiz ends.',
        manualPublishHint: 'Leaderboard will be published manually by the admin.',
        manualPublishBadge: 'Leaderboard will require manual publish',

        enterPointsForRank: 'Enter the points for rank {rank}',
        scoringManagement: 'Quiz Ranking & Scoring Management',
        scoringManagementSubtitle: 'Configure rankings, answers, and scoring parameters',
        rankBonusPoints: 'Rank Bonus Points',
        rankBonusPointsDescription: 'These are extra bonus points awarded to users based on their final rank in the quiz. Higher rank will receive higher bonus points.',
        addMoreRank: '+ Add More Rank',
        bonusPoints: 'Bonus Points (Extra Rewards)',
        bonusPointsDescription: 'Enable bonus rules to reward users with extra points based on special conditions during the quiz.',
        fastestAnswer: 'Fastest Answer (within 5 sec)',
        allAnswersCorrect: 'All Answers Correct',
        consecutiveParticipation: 'Consecutive Quiz Participation (3+ days)',
        firstAttemptDay: 'First Quiz Attempt of the Day',
        comingSoon: '(Coming soon)',
        negativeMarking: 'Negative Marking (Penalty Points)',
        negativeMarkingDescription: 'Deduct points from the user\'s score for each wrong answer.',
        wrongAnswer: 'Wrong Answer',
        saveConfiguration: 'Save Configuration',
        confirmNotification: 'Confirm Notification',
        whatsappNotifyQuestion: 'Do you want to send a WhatsApp message to notify users about this quiz?',
        no: 'NO',
        yes: 'Yes',

        quizTitle: 'Quiz Title',
        totalParticipants: 'Total Participants',
        averageScore: 'Average Score',
        yourRank: 'Your Rank',
        date: 'Date',
        dateRange: 'Date Range',
        dailyWinner: 'Daily Winner',
        weeklyWinner: 'Weekly Winner',
        monthlyWinner: 'Monthly Winner',
        finalWinner: 'Final Winner',
        fastFinger: 'Fast Finger',
        top5: 'Top 5',
        top10: 'Top 10',
        luckyWinner: 'Lucky Winner',
        queAnsHistory: 'Que & Ans History',
        ourSponsors: 'Our Sponsors',
        sponsoredBy: 'Sponsored by',
        quizQuestions: 'Quiz Questions',
        dailyQuiz: 'Daily Quiz',
        correctAnswer: 'Correct Answer',
        participantName: 'Participant Name',
        location: 'Location',
        totalScore: 'Total Score',
        totalTime: 'Total Time',
        mobile: 'Mobile',
        resultsNotPublished: 'Results Not Published',
        leaderboardNotAvailable: 'Leaderboard Not Available',
        backToDashboard: 'Back To Dashboard',
        noParticipantsFound: 'No participants found',
        firstRank: '1st rank',
        secondRank: '2nd rank',
        thirdRank: '3rd rank',
        searchByParticipantName: 'Search by participant name',
        fastestFingerFirstResult: 'Fastest Finger First Result',
        top10Result: 'Top 10 Result',
        top5Result: 'Top 5 Result',
        luckyWinnerResult: 'Lucky Winner Result',
        luckyWinnersNotAvailable: 'Lucky winners not available',
        top5WinnersNotAvailable: 'Top 5 winners not available',
        top10WinnersNotAvailable: 'Top 10 winners not available',
        resultsWillBeAnnounced: 'Results will be announced soon. Please check back later.',
        resultsNotPublishedYet: 'The results for this period have not been published yet.',

        // EduLeadership translations
        downloadExcel: 'Download Excel',
        downloadPDF: 'Download PDF',
        viewQuizQuestions: 'View Quiz Questions',
        publishResults: 'Publish Results',
        quizQuestions: 'Quiz Questions',
        dailyQuiz: 'Daily Quiz',
        correctAnswer: 'Correct Answer',
        firstRank: '1st rank',
        secondRank: '2nd rank',
        thirdRank: '3rd rank',
        fastestFingerFirstResult: 'Fastest Finger First Result',
        top10Result: 'Top 10 Result',
        top5Result: 'Top 5 Result',
        luckyWinnerResult: 'Lucky Winner Result',
        searchByParticipantName: 'Search by participant name',
        participantName: 'Participant Name',
        location: 'Location',
        totalScore: 'Total Score',
        totalTime: 'Total Time',
        mobile: 'Mobile',
        trueFalse: "True / False",
        showingEntries: 'Showing {first} to {last} of {totalRecords} entries',
        weekStillRunning: 'This week is still running, so publishing is disabled.',
        weekCanPublish: "This week's results can be published.",
        monthStillRunning: 'This month is still running, so publishing is disabled.',
        monthCanPublish: "This month's results can be published.",
        matchPair: "Match The Pair",
        rulesAndRegulation: "Rules and Regulations",
        addNewRule: 'Add New Rule',
        minimumRulesRequired: 'Minimum 4 rules required',
        todaysParticipants: "Today's Participants",
        weeklyParticipants: 'Weekly Participants',
        monthlyParticipants: 'Monthly Participants',
        totalParticipants: 'Total Participants',
    },
    hi: {
        questionBank: 'प्रश्न बैंक',
        searchQuestions: 'प्रश्न खोजें...',
        noQuestions: 'कोई प्रश्न उपलब्ध नहीं है',
        confirmDelete: 'हटाने की पुष्टि करें',
        deletePrompt: 'क्या आप वाकई इस प्रश्नोत्तरी को हटाना चाहते हैं?',
        cancel: 'रद्द करें',
        delete: 'हटाएं',
        deleted: 'हटा दिया गया',
        questionDeleted: 'प्रश्न सफलतापूर्वक हटाया गया',
        error: 'त्रुटि',
        failedToDelete: 'प्रश्न हटाने में विफल',
        topic: 'विषय',
        subTopic: 'उप विषय',
        actions: 'क्रियाएँ',
        question: 'प्रश्न',
        createNewQuestion: 'नया प्रश्न बनाएं',
        editQuestion: "प्रश्न संपादित करें",
        questionType: 'प्रश्न प्रकार',
        multipleChoice: 'बहुविकल्पी',
        questionText: 'प्रश्न',
        enterQuestion: 'अपना प्रश्न दर्ज करें...',
        topic: 'विषय',
        enterTopic: 'विषय दर्ज करें...',
        subTopic: 'उप विषय',
        enterSubTopic: 'उप विषय दर्ज करें...',
        answerOptions: 'उत्तर विकल्प',
        addOption: '+ विकल्प जोड़ें',
        selectCorrectAnswer: 'सही उत्तर चुनें',
        option: 'विकल्प',
        submit: 'जमा करें',
        error: 'त्रुटि',
        pleaseFill: 'कृपया सभी आवश्यक फ़ील्ड भरें।',
        failedToAdd: 'प्रश्न जोड़ने में विफल।',
        success: 'सफलता',
        questionAdded: 'प्रश्न सफलतापूर्वक जोड़ा गया!',
        somethingWrong: 'कुछ गलत हो गया।',
        createQuizBasic: 'क्विज़ बनाएं',
        createDailyQuiz: 'दैनिक क्विज़ बनाएं',
        updateDailyQuiz: 'दैनिक क्विज़ अपडेट करें',
        updateQuestions: 'प्रश्न अपडेट करें',
        editQuiz: 'क्विज़ संपादित करें',
        questionType: 'प्रश्न प्रकार',
        multipleChoice: 'बहुविकल्पी',
        openQuiz: 'ओपन क्विज़',
        quizTitle: 'क्विज़ शीर्षक',
        quizTitlePlaceholder: 'क्विज़ शीर्षक दर्ज करें',
        quizTitleRequired: 'क्विज़ शीर्षक आवश्यक है।',
        quizDescription: 'क्विज़ विवरण',
        quizDescriptionRequired: 'क्विज़ विवरण आवश्यक है।',
        topic: 'विषय',
        topicPlaceholder: 'विषय दर्ज करें',
        subTopic: 'उप विषय',
        subTopicPlaceholder: 'उप विषय दर्ज करें',
        startDate: 'प्रारंभ तिथि',
        endDate: 'समाप्ति तिथि',
        startTime: 'प्रारंभ समय',
        endTime: 'समाप्ति समय',
        quizVisibility: 'क्विज़ दृश्यता',
        selectVisibility: 'दृश्यता चुनें',
        public: 'सार्वजनिक',
        private: 'निजी',
        save: 'सहेजें',
        cancel: 'रद्द करें',
        editQuestions: 'प्रश्न संपादित करें',
        addQuestions: 'प्रश्न जोड़ें',
        quizUpdated: 'क्विज़ अपडेट हुआ',
        quizCreated: 'क्विज़ बनाया गया',
        quizUpdatedDetail: 'क्विज़ सफलतापूर्वक अपडेट किया गया।',
        quizCreatedDetail: 'क्विज़ सफलतापूर्वक बनाया गया।',
        error: 'त्रुटि',
        saveQuizError: 'क्विज़ सहेजते समय त्रुटि हुई। कृपया पुनः प्रयास करें।',
        createQuizError: 'क्विज़ बनाते समय त्रुटि हुई। कृपया पुनः प्रयास करें।',
        noQuizSelected: 'कोई क्विज़ चयनित नहीं',
        saveQuizBeforeEdit: 'प्रश्न संपादित करने से पहले क्विज़ सहेजें।',
        toJoinGoTo: 'शामिल होने के लिए जाएं',
        quizAppName: 'जैनडायरेक्ट क्विज़',
        preview: 'पूर्वावलोकन',
        addQuestionPlaceholder: 'प्रश्न जोड़ने के लिए क्लिक करें',
        addImageForQuestion: 'अपने प्रश्न के लिए छवि जोड़ें',
        addAudioForQuestion: 'अपने प्रश्न के लिए ऑडियो जोड़ें',
        addBackgroundImage: 'पृष्ठभूमि छवि जोड़ें',
        addAudioForBackground: 'पृष्ठभूमि के लिए ऑडियो जोड़ें',
        questionImage: 'प्रश्न छवि',
        option: 'विकल्प',
        save: 'सहेजें',
        question: 'प्रश्न',
        yourQuestion: 'आपका प्रश्न',
        addFromQuestionBank: 'प्रश्न बैंक से प्रश्न जोड़ें',
        yourQuestionPlaceholder: 'आपका प्रश्न...',
        pickAnswer: 'उत्तर चुनें',
        shortAnswer: 'संक्षिप्त उत्तर',
        addOption: '+ विकल्प जोड़ें',
        shortAnswerPlaceholder: 'यहाँ अपना संक्षिप्त उत्तर दर्ज करें...',
        points: 'अंक',
        fasterAnswersGetMorePoints: 'तेज़ उत्तरों को अधिक अंक मिलते हैं',
        timeLimit: 'समय सीमा',
        seconds: 'सेकंड',
        leaderboard: 'लीडरबोर्ड',
        generalQuizzes: 'सामान्य क्विज़',
        dailyQuizLeaderboard: 'डेली क्विज़ लीडरबोर्ड',
        sansthaQuizLeaderboard: 'संस्था क्विज़ लीडरबोर्ड',
        generalQuizSettings: 'सामान्य क्विज़ सेटिंग्स',
        type: 'प्रकार',
        back: 'वापस',
        next: 'आगे',
        confirmSave: 'सहेजने की पुष्टि करें',
        confirmSaveMessage: 'क्या आप वाकई इस प्रश्न को क्विज़ में सहेजना चाहते हैं?',
        cancel: 'रद्द करें',
        confirm: 'पुष्टि करें',
        questionBank: 'प्रश्न बैंक',
        selectAll: 'सभी चुनें',
        noQuestionsInBank: 'बैंक में कोई प्रश्न उपलब्ध नहीं है।',
        previous: 'पिछला',
        next: 'आगे',
        page: 'पृष्ठ',
        of: 'में से',
        cancel: 'रद्द करें',
        addQuiz: 'क्विज़ जोड़ें',
        join_instruction: 'जुड़ने के लिए जाएं:',
        add_image: 'प्रश्न के लिए छवि जोड़ें',
        add_audio: 'प्रश्न के लिए ऑडियो जोड़ें',
        add_bg_image: 'पृष्ठभूमि छवि जोड़ें',
        add_bg_audio: 'पृष्ठभूमि के लिए ऑडियो जोड़ें',
        save: 'सहेजें',
        your_question: 'आपका प्रश्न',
        add_from_bank: 'प्रश्न बैंक से जोड़ें',
        placeholder_question: 'आपका प्रश्न...',
        add_option: '+ विकल्प जोड़ें',
        short_answer_placeholder: 'अपना संक्षिप्त उत्तर यहां दर्ज करें...',
        points: 'अंक',
        faster_points: 'तेज़ उत्तरों को अधिक अंक मिलते हैं',
        time_limit: 'समय सीमा',
        seconds: 'सेकंड',
        leaderboard: 'लीडरबोर्ड',
        settings: 'सामान्य क्विज़ सेटिंग्स',
        pick_answer: 'उत्तर चुनें',
        short_answer: 'संक्षिप्त उत्तर',
        back: 'वापस',
        next: 'आगे',
        confirm_save_title: 'सहेजने की पुष्टि करें',
        confirm_save_text: 'क्या आप वाकई इस प्रश्न को क्विज़ में सहेजना चाहते हैं?',
        cancel: 'रद्द करें',
        confirm: 'पुष्टि करें',
        question_bank: 'प्रश्न बैंक',
        select_all: 'सभी का चयन करें',
        no_questions: 'बैंक में कोई प्रश्न उपलब्ध नहीं हैं।',
        previous: 'पिछला',
        page: 'पृष्ठ',
        of: 'का',
        next_page: 'अगला',
        add_quiz: 'क्विज़ जोड़ें',
        untitled_question: 'शीर्षकहीन प्रश्न',
        questionBank: 'प्रश्न बैंक',
        selectAll: 'सभी चुनें',
        noQuestions: 'बैंक में कोई प्रश्न उपलब्ध नहीं है।',
        previous: 'पिछला',
        next: 'अगला',
        page: 'पृष्ठ',
        of: 'का',
        cancel: 'रद्द करें',
        addQuiz: 'प्रश्न जोड़ें',
        questionBank: 'प्रश्न बैंक',
        searchQuestions: 'प्रश्न खोजें...',
        question: 'प्रश्न',
        actions: 'क्रियाएँ',
        noQuestions: 'कोई प्रश्न उपलब्ध नहीं',
        confirmDelete: 'हटाने की पुष्टि करें',
        confirmDeleteMsg: 'क्या आप वाकई इस प्रश्न को हटाना चाहते हैं?',
        cancel: 'रद्द करें',
        delete: 'हटाएं',
        deleted: 'हटा दिया गया',
        deleteSuccess: 'प्रश्न सफलतापूर्वक हटाया गया',
        deleteError: 'प्रश्न हटाने में विफल',
        back: 'वापस',
        createTitle: 'संस्था क्विज़ बनाएं',
        editTitle: 'क्विज़ संपादित करें',
        sansthaName: 'संस्था का नाम',
        quizDescription: 'क्विज़ विवरण',
        uploadImage: 'क्विज़ के लिए छवि अपलोड करें',
        topic: 'विषय',
        timedQuiz: 'समयबद्ध क्विज़',
        enabled: 'सक्रिय',
        disabled: 'निष्क्रिय',
        visibility: 'क्विज़ दृश्यता',
        selectVisibility: 'दृश्यता चुनें',
        public: 'सार्वजनिक',
        private: 'निजी',
        save: 'सहेजें',
        cancel: 'रद्द करें',
        addQuestions: 'प्रश्न जोड़ें',
        editQuestions: 'प्रश्न संपादित करें',
        dragDrop: 'खींचें और छोड़ें या छवि चुनने के लिए क्लिक करें',
        required: '{field} आवश्यक है',
        successSave: 'क्विज़ सफलतापूर्वक सहेजा गया!',
        errorSave: 'क्विज़ सहेजने में विफल।',
        imageSelected: 'छवि चुनी गई',
        sansthaQuizzes: 'संस्था क्विज़',
        createSansthaQuiz: 'नई संस्था क्विज़ बनाएं',
        quizTitle: 'संस्था का नाम',
        quizDescription: 'क्विज़ विवरण',
        uploadQuizImage: 'क्विज़ के लिए चित्र अपलोड करें',
        topic: 'विषय',
        timedQuiz: 'समयबद्ध क्विज़',
        enabled: 'सक्रिय',
        disabled: 'अक्रिय',
        quizVisibility: 'क्विज़ दृश्यता',
        public: 'सार्वजनिक',
        private: 'निजी',
        save: 'सहेजें',
        cancel: 'रद्द करें',
        editQuestions: 'प्रश्न संपादित करें',
        addQuestions: 'प्रश्न जोड़ें',
        successQuizSaved: 'क्विज़ सफलतापूर्वक सहेजा गया!',
        errorQuizSave: 'क्विज़ सहेजने में विफल!',
        successCopy: 'क्विज़ लिंक क्लिपबोर्ड में कॉपी किया गया!',
        copyQuizLink: 'क्विज़ लिंक कॉपी करें',
        educatorDashboard: 'शिक्षक डैशबोर्ड',
        createQuizBasic: 'क्विज़ बनाएं',
        totalQuizzes: 'कुल क्विज़',
        totalAttempts: 'कुल प्रयास',
        totalRegisteredUsers: 'कुल पंजीकृत उपयोगकर्ता',
        averageScore: 'औसत स्कोर',
        completionRate: 'पूर्णता दर',
        thisWeek: 'इस सप्ताह',
        addedThisWeek: '+3',
        scoreIncrease: '+2.5%',
        completionIncrease: '+4%',
        recentQuizzes: 'हाल की क्विज़',
        quizTitle: 'क्विज़ शीर्षक',
        dateCreated: 'निर्माण की तिथि',
        attempts: 'प्रयास',
        status: 'स्थिति',
        action: 'क्रिया',
        selectOne: 'एक चुनें',
        viewAllQuizzes: 'सभी क्विज़ देखें',
        viewAllQuizzesDesc: 'अपने सभी क्विज़ एक्सेस करें और प्रबंधित करें।',
        quizAnalytics: 'क्विज़ विश्लेषण',
        quizAnalyticsDesc: 'विस्तृत प्रदर्शन विश्लेषण।',
        studentReports: 'छात्र रिपोर्ट',
        studentReportsDesc: 'व्यक्तिगत छात्र प्रगति को ट्रैक करें।',
        viewReports: 'रिपोर्ट देखें',
        myQuizzes: 'मेरे क्विज़',
        manageAndOrganize: 'अपने मूल्यांकन प्रबंधित करें और व्यवस्थित करें',
        createNewQuiz: '+ नया क्विज़ बनाएं',
        searchPlaceholder: 'क्विज़ खोजें...',
        allQuizzes: 'सभी क्विज़',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
        completed: 'पूर्ण',
        loading: 'लोड हो रहा है...',
        questions: 'प्रश्न',
        aboutThisQuiz: 'इस क्विज़ के बारे में',
        editQuiz: 'क्विज़ संपादित करें',
        copyLink: 'लिंक कॉपी करें',
        viewQuestions: 'प्रश्न देखें',
        deleteQuiz: 'क्विज़ हटाएं',
        delete: 'हटाएं',
        showingQuizzes: '{count} क्विज़ दिखा रहे हैं',
        pageOf: 'पृष्ठ {current} का {total}',
        noQuizzesFoundTitle: 'कोई क्विज़ नहीं मिला',
        tryAdjustingSearch: 'अपनी खोज या फिल्टर समायोजित करने का प्रयास करें',
        confirmDelete: 'हटाने की पुष्टि करें',
        areYouSureDelete: 'क्या आप वाकई हटाना चाहते हैं',
        cancel: 'रद्द करें',
        deleting: 'हटाया जा रहा है...',
        chooseReportType: 'रिपोर्ट प्रकार चुनें',
        quizReport: 'क्विज़ रिपोर्ट',
        userReport: 'उपयोगकर्ता रिपोर्ट',
        quizReportDesc: 'इस क्विज़ की रिपोर्ट देखें (प्रति-प्रश्न उपयोगकर्ता प्रयास)',
        userReportDesc: 'प्रति-उपयोगकर्ता प्रश्न परिणाम देखें (सही/गलत)',
        previous: 'पिछला',
        next: 'अगला',
        noQuizzesFound: 'कोई क्विज़ नहीं मिला।',
        quizQuestions: 'क्विज़ प्रश्न',
        noQuestionsFound: 'इस क्विज़ के लिए कोई प्रश्न नहीं मिला।',
        points: 'अंक',
        date: 'तारीख',
        close: 'बंद करें',
        showQuizInstruction: 'क्विज़ निर्देश दिखाएं',
        hideQuizInstruction: 'क्विज़ निर्देश छिपाएं',
        howToCreateQuiz: 'क्विज़ कैसे बनाएं',
        quizTip1: 'एक स्पष्ट और छोटा क्विज़ शीर्षक दर्ज करें।',
        quizTip2: 'मल्टीपल चॉइस जैसे उपयुक्त श्रेणी चुनें।',
        quizTip3: 'सीखने वालों के लिए एक संक्षिप्त विवरण दें।',
        quizTip4: 'क्विज़ कितने दिनों तक चलेगा और प्रारंभ/समाप्ति तिथि सेट करें।',
        quizTip5: 'यदि कोई छुट्टियाँ हैं, तो उन दिनों के लिए प्रश्नों को छोड़ने के लिए चिह्नित करें।',
        quizTip6: 'हर दिन कितने प्रश्न दिखाए जाएंगे, यह सेट करें।',
        quizTip7: 'कठिनाई स्तर चुनें (आसान / मध्यम / कठिन)।',
        createQuiz: 'क्विज़ बनाएं',
        quizTitle: 'क्विज़ शीर्षक',
        enterQuizTitle: 'क्विज़ शीर्षक दर्ज करें',
        category: 'श्रेणी',
        multipleChoice: 'वैकल्पिक प्रश्न',
        quizDescription: 'क्विज़ विवरण',
        startDate: 'प्रारंभ तिथि',
        endDate: 'समाप्ति तिथि',
        startTime: 'प्रारंभ समय',
        endTime: 'समाप्ति समय',
        selectHolidayDays: 'छुट्टियों के दिन चुनें',
        dailyQuestionCount: 'हर दिन आप कितने प्रश्न सेट करना चाहते हैं',
        selectNumber: 'संख्या चुनें',
        difficultyLevel: 'कठिनाई स्तर',
        easy: 'आसान',
        medium: 'मध्यम',
        hard: 'कठिन',
        createQuiz: 'क्विज़ बनाएं',
        updateQuiz: 'क्विज़ अपडेट करें',
        createQuestions: 'प्रश्न बनाएं',
        saveQuestions: 'प्रश्न सहेजें',
        back: 'वापस जाएं',
        show: 'दिखाएँ',
        hide: 'छिपाएँ',
        quizInstruction: 'क्विज़ निर्देश',
        howToCreateQuestion: '📘 प्रश्न कैसे बनाएं',
        quizTitle: 'क्विज़ शीर्षक',
        category: 'श्रेणी',
        multipleChoice: 'बहुविकल्पी',
        description: 'विवरण',
        daysQuizRun: 'क्विज़ कितने दिन चलेगा और प्रारंभ/समाप्ति तिथि सेट करें।',
        markHolidays: 'यदि कोई छुट्टियाँ हैं तो उन्हें चिह्नित करें ताकि उन दिनों प्रश्न न आएं।',
        questionsPerDay: 'हर दिन कितने प्रश्न दिखेंगे, यह सेट करें।',
        difficultyLevel: 'कठिनाई स्तर चुनें (आसान / मध्यम / कठिन)।',
        questionBuilder: 'प्रश्न बिल्डर',
        addFromQuestionBank: '+ प्रश्न बैंक से जोड़ें',
        question: 'प्रश्न',
        removeQuestion: 'प्रश्न हटाएँ',
        enterQuestion: 'यहाँ अपना प्रश्न दर्ज करें...',
        addImageOfQuestion: 'प्रश्न की छवि जोड़ें',
        addAudioOfQuestion: 'प्रश्न का ऑडियो जोड़ें',
        addVideoOfQuestion: 'प्रश्न का वीडियो जोड़ें',
        options: 'विकल्प',
        option: 'विकल्प',
        addAnotherOption: '+ एक और विकल्प जोड़ें',
        correctAnswer: 'सही उत्तर',
        questionDate: 'प्रश्न तिथि',
        selectQuestionDate: 'प्रश्न तिथि चुनें',
        addNewQuestion: '+ नया प्रश्न जोड़ें',
        questionBank: 'प्रश्न बैंक',
        selectQuestionsFromBank: 'बैंक से प्रश्न चुनें',
        noQuestionsAvailable: 'बैंक में कोई प्रश्न उपलब्ध नहीं है।',
        addSelected: 'चयनित जोड़ें',
        cancel: 'रद्द करें',
        added: 'जोड़ा गया',
        selectedQuestionsAdded: 'चयनित प्रश्न क्विज़ बिल्डर में जोड़ दिए गए हैं।',
        error: 'त्रुटि',
        failedToLoadBank: 'बैंक से प्रश्न लोड करने में विफल।',
        noData: 'कोई डेटा नहीं',
        noQuestionsFound: 'इस क्विज़ के लिए कोई प्रश्न नहीं मिले।',
        failedToLoadQuizQuestions: 'क्विज़ प्रश्न लोड करने में विफल।',
        remove: '✖',
        selectAll: 'सभी चुनें',
        previous: 'पिछला',
        next: 'आगे',
        page: 'पृष्ठ',
        of: 'में से',
        addQuiz: 'क्विज़ जोड़ें',
        noAvailableQuizzes: 'कोई उपलब्ध क्विज़ नहीं',
        quizzesWillAppear: 'नई क्विज़ उपलब्ध होने पर यहाँ दिखाई देंगी। कृपया प्रतीक्षा करें!',
        noDetailsAvailable: 'कोई विवरण उपलब्ध नहीं',
        questions: 'प्रश्न',
        marks: 'अंक',
        start: 'प्रारंभ',
        end: 'समाप्ति',
        comingSoon: 'जल्द आ रहा है',
        startQuiz: 'क्विज़ प्रारंभ करें',
        failedToLoadQuizzes: 'क्विज़ लोड करने में विफल। कृपया पुनः प्रयास करें।',
        daily_quiz_challenges: 'दैनिक क्विज़ चुनौतियाँ',
        test_your_knowledge: 'हमारे दैनिक तैयार किए गए क्विज़ के साथ अपने ज्ञान का परीक्षण करें',
        search_placeholder: 'क्विज़ खोजें...',
        todays_special: 'आज का विशेष',
        start_quiz: 'क्विज़ शुरू करें',
        all: 'सभी',
        easy: 'आसान',
        medium: 'मध्यम',
        hard: 'कठिन',
        sort_by_latest: 'क्रमबद्ध करें: नवीनतम',
        sort_by_popular: 'क्रमबद्ध करें: लोकप्रिय',
        questions: 'प्रश्न',
        no_quizzes_found: 'कोई क्विज़ नहीं मिली!',
        prev: 'पिछला',
        next: 'अगला',
        active_users: 'सक्रिय उपयोगकर्ता',
        daily_winners: 'दैनिक विजेता',
        success_rate: 'सफलता दर',
        quizzes_available: 'उपलब्ध क्विज़',
        sansthaName: 'जैन अहीर संस्था',
        topicName: 'विषय का नाम',
        addQuestionImage: 'प्रश्न छवि जोड़ें',
        addQuestionAudio: 'प्रश्न ऑडियो जोड़ें',
        defaultQuestion: 'अपना शानदार प्रश्न जोड़ने के लिए क्लिक करें',
        quizQuestion: 'प्रश्न',
        option: 'विकल्प',
        addOption: '+ विकल्प जोड़ें',
        points: 'अंक',
        timer: 'समय सीमा (सेकंड)',
        bonus: 'तेज़ उत्तरों को अधिक अंक मिलते हैं',
        confirmSave: 'सहेजने की पुष्टि करें',
        confirmMsg: 'क्या आप वाकई इस प्रश्न को क्विज़ में सहेजना चाहते हैं?',
        cancel: 'रद्द करें',
        confirm: 'पुष्टि करें',
        back: 'पिछला',
        next: 'अगला',
        mcq: 'बहुविकल्पीय प्रश्न',
        save: 'सहेजें',
        quizzes: 'प्रश्नोत्तरी',
        quizTitle: 'प्रश्नोत्तरी शीर्षक',
        topic: 'विषय',
        subTopic: 'उप विषय',
        sansthaName: 'संस्था नाम',
        startDate: 'प्रारंभ दिनांक',
        endDate: 'अंतिम दिनांक',
        quizDetail: 'प्रश्नोत्तरी विवरण',
        action: 'क्रिया',
        noQuizzes: 'कोई प्रश्नोत्तरी उपलब्ध नहीं है।',
        confirmDelete: 'हटाना सुनिश्चित करें',
        deleteMsg: 'क्या आप वाकई इस प्रश्नोत्तरी को हटाना चाहते हैं?',
        cancel: 'रद्द करें',
        delete: 'हटाएं',
        viewQuestions: 'के लिए प्रश्न',
        noQuestions: 'इस प्रश्नोत्तरी के लिए कोई प्रश्न उपलब्ध नहीं हैं।',
        close: 'बंद करें',
        linkCopied: 'प्रश्नोत्तरी लिंक क्लिपबोर्ड पर कॉपी किया गया।',
        copyError: 'लिंक कॉपी नहीं किया जा सका।',
        quizDeleted: 'प्रश्नोत्तरी और संबंधित डेटा सफलतापूर्वक हटा दिया गया।',
        deleteError: 'प्रश्नोत्तरी या संबंधित डेटा को हटाने में विफल।',

        // Menu
        home: 'होम',
        pages: 'पृष्ठ',
        userDashboard: 'उपयोगकर्ता डैशबोर्ड',
        educatorDashboard: 'शिक्षक डैशबोर्ड',
        quizDashboard: 'क्विज़ डैशबोर्ड',
        questionBank: 'प्रश्न बैंक',
        sansthaQuiz: 'संस्था क्विज़',
        sansthaQuizzes: 'संस्था क्विज़',
        dailyQuizzes: 'दैनिक क्विज़',
        quizes: 'क्विज़',
        adminDashboard: 'एडमिन डैशबोर्ड',
        addBrandOrSponsorImage: 'ब्रांड या प्रायोजक छवि जोड़ें',
        analyticsOverview: 'विश्लेषण अवलोकन',
        overallAnalytics: 'समग्र विश्लेषण',
        settings: 'सेटिंग्स',
        leaderboardPublishing: 'लीडरबोर्ड प्रकाशन',
        profile: 'प्रोफाइल',
        managedByMe: 'मेरे द्वारा प्रबंधित',
        dailyQuizCreation: 'दैनिक क्विज़ निर्माण',
        switchToEducator: 'शिक्षक के रूप में स्विच करें',
        switchToParticipant: 'प्रतिभागी के रूप में स्विच करें',
        language: 'भाषा',
        switchToHindi: 'हिंदी में बदलें',
        switchToEnglish: 'अंग्रेज़ी में बदलें',
        weeklyQuizCompletion: 'साप्ताहिक क्विज़ पूर्णता',
        quizCompletionStatus: 'क्विज़ पूर्णता स्थिति',
        completed: 'पूर्ण',
        inProgress: 'प्रगति पर',
        notStarted: 'शुरू नहीं हुआ',
        completions: 'पूर्णताएं',
        january: 'जनवरी',
        february: 'फ़रवरी',
        march: 'मार्च',
        april: 'अप्रैल',
        may: 'मई',
        june: 'जून',
        july: 'जुलाई',
        leaderboard: 'लीडरबोर्ड',
        sendMessages: 'संदेश भेजें',
        manageUsers: 'उपयोगकर्ता प्रबंधित करें',
        roles: 'भूमिकाएँ',
        assignLuckyWinners: 'सौभाग्यशाली विजेताओं को असाइन करें',

        // question bank toast
        errorFillFields: 'कृपया सभी आवश्यक फ़ील्ड भरें।',
        errorInsert: 'प्रश्न जोड़ने में विफल।',
        errorUnexpected: 'कुछ गलत हो गया।',
        successInsert: 'प्रश्न सफलतापूर्वक जोड़ा गया!',
        successUpdate: 'प्रश्न सफलतापूर्वक अपडेट किया गया!',
        confirmEdit: 'संपादन की पुष्टि करें',
        editPrompt: 'क्या आप इस प्रश्न को संपादित करना चाहते हैं?',
        yes: 'हाँ',
        cancel: 'रद्द करें',
        actions: 'क्रिया',

        // daily quiz question instruction
        enterClearQuestionText: 'स्पष्ट और पूर्ण प्रश्न दर्ज करें',
        addOptions: 'उत्तर विकल्प जोड़ें',
        minimumTwoRequired: 'कम से कम 2 आवश्यक',
        markCorrectAnswer: 'सही उत्तर चुनें',
        addImageOrAudioOptional: 'वैकल्पिक रूप से छवि या ऑडियो अपलोड करें',
        setQuestionDateWithinQuizRange: 'प्रश्न तिथि को क्विज़ अनुसूची के भीतर सेट करें',
        assignPoints: 'इस प्रश्न के लिए अंक निर्धारित करें',
        useSimpleLanguage: 'बेहतर समझ के लिए सरल और स्पष्ट भाषा का उपयोग करें',
        points: 'अंक',
        durationInDays: 'अवधि (दिनों में)',
        enterDays: 'दिनों की संख्या दर्ज करें',

        // lucky winner
        luckyWinnersManagement: 'लकी विजेताओं का प्रबंधन',
        dailyWinners: 'दैनिक विजेता',
        weeklyWinners: 'साप्ताहिक विजेता',
        selectDate: 'तिथि चुनें',
        searchParticipants: 'नाम या आईडी से प्रतिभागियों को खोजें',
        quizName: 'क्विज़ का नाम',
        participantId: 'प्रतिभागी आईडी',
        name: 'नाम',
        quizType: 'क्विज़ प्रकार',
        score: 'स्कोर',
        participationDate: 'भाग लेने की तिथि',
        performance: 'प्रदर्शन',
        winnerStatus: 'विजेता स्थिति',
        alreadyWinner: 'पहले से विजेता',
        gold: 'स्वर्ण',
        silver: 'रजत',
        bronze: 'कांस्य',
        sendNotifications: 'सूचनाएँ भेजें',
        clearSelection: 'चयन साफ़ करें',
        saveWinners: 'विजेताओं को सहेजें',
        noParticipantsFound: 'कोई प्रतिभागी नहीं मिला',
        noWinnersSelected: 'कृपया कम से कम एक विजेता चुनें।',
        noNewWinners: 'कृपया कम से कम एक नया विजेता चुनें।',
        winnersSaved: 'लकी विजेताओं को सफलतापूर्वक सहेजा गया!',
        saveFailed: 'सहेजना असफल रहा',
        success: 'सफलता',
        error: 'त्रुटि',
        whatsappError: 'व्हाट्सएप त्रुटि',
        excellent: 'उत्कृष्ट',
        good: 'अच्छा',
        average: 'औसत',
        saveWeeklyWinners: 'साप्ताहिक विजेताओं को सहेजें',
        weeklyWinnersSaved: 'साप्ताहिक विजेताओं को सफलतापूर्वक सहेजा गया!',
        saveError: 'साप्ताहिक विजेताओं को सहेजने में त्रुटि',
        fetchError: 'प्रतिभागियों को लाने में त्रुटि',
        noParticipantsSelected: 'कृपया कम से कम एक प्रतिभागी चुनें',

        // role management
        roleManagement: 'भूमिका प्रबंधन',
        roleManagementDesc: 'अपनी क्विज़ प्रणाली के लिए भूमिकाएँ प्रबंधित करें और बनाएँ',
        addNewRole: 'नई भूमिका जोड़ें',
        roleName: 'भूमिका का नाम',
        enterRoleName: 'भूमिका का नाम दर्ज करें',
        description: 'विवरण',
        enterDescription: 'भूमिका का विवरण दर्ज करें',
        permissions: 'अनुमतियाँ',
        createRole: 'भूमिका बनाएँ',
        currentRoles: 'वर्तमान भूमिकाएँ',
        searchRoles: 'भूमिकाएँ खोजें...',
        createdDate: 'निर्माण तिथि',
        updatedDate: 'अद्यतन तिथि',
        validationError: 'कृपया सभी फ़ील्ड भरें।',
        roleCreationFailed: 'भूमिका निर्माण विफल',
        permissionMappingFailed: 'अनुमति मैपिंग विफल',
        roleCreated: 'भूमिका सफलतापूर्वक बनाई गई!',

        // manage users
        quizAccessControl: 'क्विज़ प्रबंधन एक्सेस नियंत्रण',
        quizAccessControlDesc: 'उन उपयोगकर्ताओं का प्रबंधन करें जो क्विज़ बना और संपादित कर सकते हैं',
        addNewUser: 'नया उपयोगकर्ता जोड़ें',
        quizManagerRole: 'क्विज़ प्रबंधक भूमिका',
        quizManagerRoleDesc: 'इस भूमिका वाले उपयोगकर्ता क्विज़ बना, संपादित और हटा सकते हैं',
        createQuizzes: 'नई क्विज़ बनाएं',
        editQuizzes: 'मौजूदा क्विज़ संपादित करें',
        deleteQuizzes: 'क्विज़ हटाएं',
        manageSettings: 'क्विज़ सेटिंग्स प्रबंधित करें',
        viewAnalytics: 'विश्लेषण देखें',
        assignPermissions: 'अनुमतियाँ असाइन करें',
        currentManagers: 'वर्तमान क्विज़ प्रबंधक',
        noManagers: 'कोई क्विज़ प्रबंधक उपलब्ध नहीं है',
        noEducatorsInSoftware: 'आपके सॉफ्टवेयर में कोई शिक्षक नहीं है',
        userName: 'उपयोगकर्ता नाम',
        email: 'ईमेल',
        mobile: 'मोबाइल नंबर',
        role: 'भूमिका',
        accessLevel: 'प्रवेश स्तर',
        dateAdded: 'तारीख जोड़ी गई',
        actions: 'कार्रवाई',
        confirmAddManager: 'प्रबंधक जोड़ने की पुष्टि करें',
        confirmAddText: 'क्या आप वाकई प्रबंधक जोड़ना चाहते हैं?',
        yes: 'हाँ',
        cancel: 'रद्द करें',
        editManagerRole: 'प्रबंधक भूमिका संपादित करें',
        selectRole: 'भूमिका चुनें',
        save: 'सहेजें',
        confirmDeletion: 'हटाने की पुष्टि करें',
        confirmDeleteText: 'क्या आप वाकई इस प्रबंधक को हटाना चाहते हैं?',
        yesDelete: 'हाँ, हटाएँ',
        error: 'त्रुटि',
        invalidManager: 'अमान्य प्रबंधक चुना गया',
        deleteFailed: 'प्रबंधक हटाने में विफल',
        deleteSuccess: '{name} को क्विज़ प्रबंधकों से हटा दिया गया',
        roleUpdateFailed: 'भूमिका अपडेट करने में विफल',
        roleUpdated: 'प्रबंधक की भूमिका सफलतापूर्वक अपडेट की गई',

        // get leadersipboard
        selectQuizAndDate: 'क्विज़ और तारीख चुनें',
        selectDate: 'तारीख चुनें',
        chooseQuiz: 'क्विज़ चुनें',
        selectAQuiz: 'एक क्विज़ चुनें',
        viewLeaderboard: 'लीडरबोर्ड देखें',
        seeHowYouRank: 'देखें आप दूसरों के मुकाबले कहां खड़े हैं और खुद को चुनौती दें 💡',
        userNotLoggedIn: 'उपयोगकर्ता लॉगिन नहीं है',
        noScoresFound: '❌ इस तारीख के लिए कोई स्कोर नहीं मिला।',
        noQuizzesFound: '❌ इस तारीख को आपके द्वारा कोई क्विज़ नहीं बनाई गई।',

        // create sanstha quiz
        organizationQuizUrl: 'संगठन क्विज़ URL',
        active: 'सक्रिय',
        quickAccess: 'त्वरित पहुँच',
        scanQrCode: 'क्विज़ पोर्टल तक पहुँचने के लिए QR कोड स्कैन करें',
        createNewQuiz: 'नई क्विज़ बनाएँ',
        quizTitle: 'क्विज़ का शीर्षक',
        enterQuizTitle: 'क्विज़ का शीर्षक दर्ज करें',
        organization: 'संगठन',
        description: 'विवरण',
        enterDescription: 'क्विज़ का विवरण दर्ज करें',
        quizDurationType: 'क्विज़ अवधि प्रकार',
        singleDay: 'एक ही दिन',
        multiDay: 'कई दिन',
        topic: 'विषय',
        enterTopic: 'विषय दर्ज करें',
        subtopic: 'उपविषय',
        enterSubtopic: 'उपविषय दर्ज करें',
        startDate: 'आरंभ तिथि',
        startTime: 'आरंभ समय',
        endDate: 'समाप्ति तिथि',
        endTime: 'समाप्ति समय',
        releaseResult: 'परिणाम जारी करें',
        instant: 'तुरंत',
        scheduled: 'निर्धारित',
        resultReleaseDate: 'परिणाम जारी करने की तिथि',
        resultReleaseTime: 'परिणाम जारी करने का समय',
        createQuizBtn: 'क्विज़ बनाएँ',
        validationQuizTitle: 'कृपया क्विज़ का शीर्षक दर्ज करें',
        validationTopic: 'कृपया विषय दर्ज करें',
        validationDuration: 'कृपया क्विज़ अवधि प्रकार चुनें',
        validationStartDate: 'कृपया आरंभ तिथि चुनें',
        validationStartTime: 'कृपया आरंभ समय चुनें',
        validationEndDate: 'कृपया समाप्ति तिथि चुनें',
        validationEndTime: 'कृपया समाप्ति समय चुनें',
        validationReleaseResult: 'कृपया परिणाम जारी करने का विकल्प चुनें',
        validationResultReleaseDate: 'कृपया परिणाम जारी करने की तिथि चुनें',
        validationResultReleaseTime: 'कृपया परिणाम जारी करने का समय चुनें',
        quizCreated: 'क्विज़ सफलतापूर्वक बनाई गई',
        quizCreateFailed: 'क्विज़ बनाने में विफल',

        // sanstha quiz educator
        header: 'संस्था क्विज़',
        subHeader: 'हमारे संस्थागत क्विज़ संग्रह को देखें',
        createSansthaQuiz: '+ संस्था क्विज़ बनाएं',
        copyLink: 'लिंक कॉपी करें',
        edit: 'संपादित करें',
        noDescription: 'कोई विवरण उपलब्ध नहीं है',
        totalQuestions: 'प्रश्न',
        totalTime: 'मिनट',
        quizLinkCopied: 'क्विज़ लिंक क्लिपबोर्ड में कॉपी किया गया!',

        // sanstha quiz participant
        sansthaQuizLists: 'संस्था क्विज़ सूची',
        header: 'संस्था क्विज़',
        subHeader: 'हमारे संस्थागत क्विज़ संग्रह को देखें',
        sanstha: 'संस्था',
        noDescription: 'कोई विवरण उपलब्ध नहीं है',
        totalQuestions: 'प्रश्न',
        totalTime: 'मिनट',
        quizNotFinished: 'क्विज़ अभी समाप्त नहीं हुआ',
        leaderboardNotAvailable: 'लीडरबोर्ड अभी उपलब्ध नहीं है!',
        quizStillRunning: 'यह क्विज़ अभी चल रहा है। कृपया समाप्त होने के बाद वापस आएं।',
        endsOn: 'समाप्ति तिथि:',
        stayTuned: 'बने रहें! परिणाम क्विज़ समाप्त होने के तुरंत बाद उपलब्ध होंगे।',
        gotIt: 'समझ गया',

        // daily quiz participant
        dailyQuizLists: 'दैनिक क्विज़ सूची',
        dailyQuizChallenge: 'दैनिक क्विज़ चुनौती',
        dailyQuizSubHeader: 'हमारे दैनिक तैयार किए गए क्विज़ के साथ अपने ज्ञान की परीक्षा लें',
        noDataAvailable: 'कोई डेटा उपलब्ध नहीं है',
        allDifficulties: 'सभी कठिनाई स्तर',
        questions: 'प्रश्न',
        easy: 'आसान',
        medium: 'मध्यम',
        hard: 'कठिन',
        allCategories: 'सभी श्रेणियां',
        beginChallenge: 'चुनौती शुरू करें',
        nextQuestion: 'अगला प्रश्न',
        noMoreQuestions: 'कोई और प्रश्न नहीं',
        startTime: 'प्रारंभ समय',
        startQuiz: 'क्विज़ शुरू करें',
        prev: 'पिछला',
        next: 'अगला',
        noQuizzesAvailable: 'फिलहाल कोई क्विज़ उपलब्ध नहीं है।',
        dailyKnowledgeChallenge: 'दैनिक ज्ञान चुनौती',
        generalKnowledgeQuiz: 'सामान्य ज्ञान क्विज़',
        noDetailAvailable: 'कोई विवरण उपलब्ध नहीं!',
        startQuizNow: 'अभी क्विज़ शुरू करें',
        quizEnded: 'यह क्विज़ समाप्त हो गया है।',
        exploreMoreQuizzes: 'कृपया और क्विज़ देखें और भाग लें!',
        viewMoreQuizzes: 'और क्विज़ देखें',
        noQuestionToday: 'आज के लिए कोई प्रश्न उपलब्ध नहीं!',
        refresh: 'रिफ्रेश',
        alreadyCompletedToday: 'आपने आज का क्विज़ पहले ही पूरा कर लिया है',
        viewRules: 'नियम देखें',
        quizDetails: 'क्विज़ विवरण',
        topicLabel: 'विषय',
        generalKnowledge: 'सामान्य ज्ञान',
        difficultyLabel: 'कठिनाई',
        availableUntil: 'तब तक उपलब्ध',
        notSet: 'सेट नहीं',
        rulesAndRegulations: 'नियम और विनियम',
        rule1: 'उत्तर देने से पहले प्रत्येक प्रश्न को ध्यान से पढ़ें।',
        rule2: 'प्रत्येक प्रश्न के लिए सबसे अच्छा संभव उत्तर चुनें।',
        rule3: 'क्विज़ समाप्त होने से पहले अपने उत्तर सबमिट करें।',
        rule4: 'अंक केवल सही उत्तरों के लिए दिए जाते हैं।',
        rule5: 'लगातार सही उत्तर आपके स्ट्रीक बोनस को बढ़ाते हैं।',
        rule6: 'धोखाधड़ी या बाहरी मदद का उपयोग करने से आपको अयोग्य ठहराया जा सकता है।',
        completeProfile: 'प्रोफाइल पूर्ण करें',
        completeProfileToContinue: 'जारी रखने के लिए कृपया अपना प्रोफाइल पूर्ण करें।',
        goToProfile: 'प्रोफाइल पर जाएं',
        firstQuestionOnDate: 'पहला सवाल {date} को {time} बजे दिखाई देगा।',
        firstQuestionTomorrow: 'पहला सवाल कल {time} बजे दिखाई देगा।',
        firstQuestionToday: 'पहला सवाल आज {time} बजे दिखाई देगा।',
        quizEndedMessage: 'यह क्विज़ समाप्त हो गया है।',
        noQuestionTodayMessage: 'आज का कोई सवाल उपलब्ध नहीं है।',
        quizEndingToday: 'आज का क्विज़ समाप्त होने वाला है।',
        nextQuestionOnDate: 'अगला सवाल {date} को {time} बजे दिखाई देगा।',
        nextQuestionTomorrow: 'अगला सवाल कल {time} बजे दिखाई देगा।',
        nextQuestionToday: 'अगला सवाल आज {time} बजे दिखाई देगा।',
        morning: 'सुबह',
        afternoon: 'दोपहर',
        evening: 'शाम',
        night: 'रात',
        startsIn: 'शुरू होने में',
        days: 'दिन',
        hours: 'घंटे',
        minutes: 'मिनट',
        seconds: 'सेकंड',
        importantNotice: 'महत्वपूर्ण सूचना',
        readBeforeStarting: 'शुरू करने से पहले पढ़ें',
        ensureStableConnection: 'कृपया स्थिर इंटरनेट कनेक्शन सुनिश्चित करें। एक बार शुरू होने के बाद, टाइमर रोका नहीं जा सकता।',
        completeAllQuestions: 'समय समाप्त होने से पहले सभी प्रश्न पूरे करें',
        noExternalResources: 'परीक्षा के दौरान बाहरी संसाधनों की अनुमति नहीं है',
        submitBeforeExpiry: 'टाइमर समाप्त होने से पहले उत्तर जमा करें',
        details: 'विवरण',
        rules: 'नियम',
        results: 'परिणाम',
        quizInformation: "प्रश्नोत्तरी की जानकारी",
        subjectCategory: 'विषय श्रेणी',
        quizType: "प्रश्नोत्तरी का प्रकार",
        quizRules: "प्रश्नोत्तरी के नियम",
        quizTips: "प्रश्नोत्तरी के सुझाव",
        difficultyLevel: 'कठिनाई स्तर',
        totalQuestions: 'कुल प्रश्न',
        availableDate: 'क्विज़ समाप्त होने की तिथि',
        time: 'समय',
        dq_start_time: "दैनिक क्विज़ प्रारंभ समय",
        readAllOptions: 'सभी विकल्प ध्यान से पढ़ें',
        focusTimeManagement: 'समय प्रबंधन पर ध्यान दें',
        solveEasyFirst: 'पहले आसान प्रश्न हल करें',
        resultsComingSoon: 'परिणाम जल्द आएंगे',
        resultsWillBeAvailable: 'परीक्षा समाप्त होने के बाद परिणाम उपलब्ध होंगे।',
        mon: 'सोम',
        tue: 'मंगल',
        wed: 'बुध',
        thu: 'गुरु',
        fri: 'शुक्र',
        sat: 'शनि',
        sun: 'रवि',
        jan: 'जन',
        feb: 'फ़र',
        mar: 'मार्च',
        apr: 'अप्र',
        may: 'मई',
        jun: 'जून',
        jul: 'जुल',
        aug: 'अग',
        sep: 'सित',
        oct: 'अक्टू',
        nov: 'नव',
        dec: 'दिस',

        adminTitle: 'जैनडायरेक्ट क्विज़ - एडमिन डैशबोर्ड',
        totalSanstha: 'कुल संस्थाएँ',
        totalQuizzes: 'कुल बनाए गए क्विज़',
        activeQuizzes: 'सक्रिय क्विज़',
        totalParticipants: 'कुल प्रतिभागी',
        userEngagement: 'उपयोगकर्ता जुड़ाव वृद्धि',
        engagementChannels: 'संलग्नता चैनल अवलोकन',
        whatsappMessages: 'भेजे गए व्हाट्सएप संदेश',
        emailMessages: 'भेजे गए ईमेल',
        avgScore: 'औसत स्कोर',
        dailyActiveUsers: 'दैनिक सक्रिय क्विज़ लेने वाले',
        topQuizzes: 'प्रयासों के अनुसार शीर्ष 5 क्विज़',
        platformUsageDistribution: 'प्लेटफ़ॉर्म उपयोग वितरण',
        activeUsers: 'सक्रिय उपयोगकर्ता',
        mostPopularQuizzes: 'हाल ही में सबसे लोकप्रिय क्विज़',
        totalParticipants: 'कुल प्रतिभागी',
        newParticipants: 'नए प्रतिभागी',
        totalEducators: 'शिक्षक',
        attempts: 'प्रयास',

        viewDetails: 'विवरण देखें',
        noDescription: 'कोई विवरण नहीं',
        allSansthas: 'सभी संस्थाएं',
        searchPlaceholder: 'खोजें...',
        noLocation: 'स्थान नहीं',
        report: 'रिपोर्ट',

        profile: 'प्रोफ़ाइल',
        messages: 'संदेश',
        logout: 'लॉगआउट',

        shortAppName: 'जेडी क्विज़',
        fullAppName: 'जैनडायरेक्ट क्विज़',

        // partcular sanstha quiz
        title: 'क्विज़',
        organization: 'संगठन का नाम',
        description: 'विवरण',
        statistics: 'क्विज़ आँकड़े',
        total_questions: 'कुल प्रश्न',
        total_points: 'कुल अंक',
        total_time: 'कुल समय',
        duration: 'अवधि',
        dates: 'तिथियाँ',
        start_date: 'प्रारंभ तिथि',
        end_date: 'समाप्ति तिथि',
        time: 'समय',
        start: 'प्रारंभ',
        end: 'समाप्त',
        additional_info: 'अतिरिक्त जानकारी',
        participants_limit: 'प्रतिभागियों की सीमा',
        unlimited: 'असीमित',
        difficulty: 'कठिनाई स्तर',
        intermediate: 'मध्यम',
        quiz_not_started: 'क्विज़ अभी शुरू नहीं हुई है',
        quiz_live: 'क्विज़ शुरू करें',
        quiz_ended: 'क्विज़ समाप्त हो गई',

        quizNotAvailable: 'क्विज़ उपलब्ध नहीं है',
        noQuestionsInQuiz: 'इस क्विज़ में कोई प्रश्न जोड़े नहीं गए हैं',

        leaderboardPublishMode: 'लीडरबोर्ड प्रकाशित करने का तरीका',
        selectOption: 'विकल्प चुनें',
        autoPublish: 'स्वचालित प्रकाशन',
        manualPublish: 'मैन्युअल प्रकाशन',
        autoPublishHint: 'क्विज़ समाप्त होने के बाद लीडरबोर्ड अपने आप प्रकाशित हो जाएगा।',
        manualPublishHint: 'लीडरबोर्ड को एडमिन द्वारा मैन्युअल रूप से प्रकाशित किया जाएगा।',
        manualPublishBadge: 'लीडरबोर्ड को मैन्युअल रूप से प्रकाशित करना होगा',

        enterPointsForRank: 'रैंक {rank} के लिए अंक दर्ज करें',
        scoringManagement: 'क्विज़ रैंकिंग और स्कोरिंग प्रबंधन',
        scoringManagementSubtitle: 'रैंकिंग, उत्तर और स्कोरिंग पैरामीटर कॉन्फ़िगर करें',
        rankBonusPoints: 'रैंक बोनस अंक',
        rankBonusPointsDescription: 'ये अतिरिक्त बोनस अंक हैं जो उपयोगकर्ताओं को क्विज़ में उनकी अंतिम रैंक के आधार पर दिए जाते हैं। उच्च रैंक को उच्च बोनस अंक मिलेंगे।',
        addMoreRank: '+ और रैंक जोड़ें',
        bonusPoints: 'बोनस अंक (अतिरिक्त पुरस्कार)',
        bonusPointsDescription: 'क्विज़ के दौरान विशेष स्थितियों के आधार पर उपयोगकर्ताओं को अतिरिक्त अंक देने के लिए बोनस नियम सक्षम करें।',
        fastestAnswer: 'सबसे तेज उत्तर (5 सेकंड के भीतर)',
        allAnswersCorrect: 'सभी उत्तर सही',
        consecutiveParticipation: 'लगातार क्विज़ भागीदारी (3+ दिन)',
        firstAttemptDay: 'दिन का पहला क्विज़ प्रयास',
        comingSoon: '(जल्द आ रहा है)',
        negativeMarking: 'निगेटिव मार्किंग (पेनल्टी अंक)',
        negativeMarkingDescription: 'प्रत्येक गलत उत्तर के लिए उपयोगकर्ता के स्कोर से अंक काटें।',
        wrongAnswer: 'गलत उत्तर',
        saveConfiguration: 'कॉन्फ़िगरेशन सहेजें',
        confirmNotification: 'सूचना की पुष्टि करें',
        whatsappNotifyQuestion: 'क्या आप इस क्विज़ के बारे में उपयोगकर्ताओं को सूचित करने के लिए WhatsApp संदेश भेजना चाहते हैं?',
        no: 'नहीं',
        yes: 'हां',
        // Leaderboard translations
        quizTitle: 'क्विज़ शीर्षक',
        totalParticipants: 'कुल प्रतिभागी',
        averageScore: 'औसत स्कोर',
        yourRank: 'आपकी रैंक',
        date: 'दिनांक',
        dateRange: 'दिनांक सीमा',
        dailyWinner: 'दैनिक विजेता',
        weeklyWinner: 'साप्ताहिक विजेता',
        monthlyWinner: 'मासिक विजेता',
        finalWinner: 'अंतिम विजेता',
        fastFinger: 'तेज़ उंगली',
        top5: 'शीर्ष 5',
        top10: 'शीर्ष 10',
        luckyWinner: 'भाग्यशाली विजेता',
        queAnsHistory: 'प्रश्न और उत्तर इतिहास',
        ourSponsors: 'हमारे प्रायोजक',
        sponsoredBy: 'प्रायोजित द्वारा',
        quizQuestions: 'क्विज़ प्रश्न',
        dailyQuiz: 'दैनिक क्विज़',
        correctAnswer: 'सही उत्तर',
        participantName: 'प्रतिभागी का नाम',
        location: 'स्थान',
        totalScore: 'कुल स्कोर',
        totalTime: 'कुल समय',
        mobile: 'मोबाइल',
        resultsNotPublished: 'परिणाम प्रकाशित नहीं',
        leaderboardNotAvailable: 'लीडरबोर्ड उपलब्ध नहीं',
        backToDashboard: 'डैशबोर्ड पर वापस जाएं',
        noParticipantsFound: 'कोई प्रतिभागी नहीं मिला',
        firstRank: '1st रैंक',
        secondRank: '2nd रैंक',
        thirdRank: '3rd रैंक',
        searchByParticipantName: 'प्रतिभागी के नाम से खोजें',
        fastestFingerFirstResult: 'तेज़ उंगली पहले परिणाम',
        top10Result: 'शीर्ष 10 परिणाम',
        top5Result: 'शीर्ष 5 परिणाम',
        luckyWinnerResult: 'भाग्यशाली विजेता परिणाम',
        luckyWinnersNotAvailable: 'भाग्यशाली विजेता उपलब्ध नहीं',
        top5WinnersNotAvailable: 'शीर्ष 5 विजेता उपलब्ध नहीं',
        top10WinnersNotAvailable: 'शीर्ष 10 विजेता उपलब्ध नहीं',
        resultsWillBeAnnounced: 'परिणाम जल्द ही घोषित किए जाएंगे। कृपया बाद में जांचें।',
        resultsNotPublishedYet: 'इस अवधि के लिए परिणाम अभी तक प्रकाशित नहीं हुए हैं।',
        // EduLeadership translations
        downloadExcel: 'एक्सेल डाउनलोड करें',
        downloadPDF: 'पीडीएफ डाउनलोड करें',
        viewQuizQuestions: 'क्विज़ प्रश्न देखें',
        publishResults: 'परिणाम प्रकाशित करें',
        quizQuestions: 'क्विज़ प्रश्न',
        dailyQuiz: 'दैनिक क्विज़',
        correctAnswer: 'सही उत्तर',
        firstRank: '1st रैंक',
        secondRank: '2nd रैंक',
        thirdRank: '3rd रैंक',
        fastestFingerFirstResult: 'तेज़ उंगली पहले परिणाम',
        top10Result: 'शीर्ष 10 परिणाम',
        top5Result: 'शीर्ष 5 परिणाम',
        luckyWinnerResult: 'भाग्यशाली विजेता परिणाम',
        searchByParticipantName: 'प्रतिभागी के नाम से खोजें',
        participantName: 'प्रतिभागी का नाम',
        location: 'स्थान',
        totalScore: 'कुल स्कोर',
        totalTime: 'कुल समय',
        mobile: 'मोबाइल',
        trueFalse: "सही / गलत",
        showingEntries: '{first} से {last} तक {totalRecords} प्रविष्टियां दिखा रहा है',
        weekStillRunning: 'यह सप्ताह अभी चल रहा है, इसलिए प्रकाशन अक्षम है।',
        weekCanPublish: 'इस सप्ताह के परिणाम प्रकाशित किए जा सकते हैं।',
        monthStillRunning: 'यह महीना अभी चल रहा है, इसलिए प्रकाशन अक्षम है।',
        monthCanPublish: 'इस महीने के परिणाम प्रकाशित किए जा सकते हैं।',
        rulesAndRegulation: "नियम एवं विनियम",
        addNewRule: 'नया नियम जोड़ें',
        minimumRulesRequired: 'कम से कम 4 नियम आवश्यक हैं',
        todaysParticipants: 'आज के प्रतिभागी',
        weeklyParticipants: 'साप्ताहिक प्रतिभागी',
        monthlyParticipants: 'मासिक प्रतिभागी',
        totalParticipants: 'कुल प्रतिभागी',
    },
    kn: {
        questionBank: 'ಪ್ರಶ್ನೆ ಭಂಡಾರ',
        searchQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಹುಡುಕಿ...',
        noQuestions: 'ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ',
        confirmDelete: 'ಅಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ',
        deletePrompt: 'ಈ ಪ್ರಶ್ನಾವಳಿಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವೇ?',
        cancel: 'ರದ್ದುಮಾಡು',
        delete: 'ಅಳಿಸಿ',
        deleted: 'ಅಳಿಸಲಾಗಿದೆ',
        questionDeleted: 'ಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ',
        error: 'ದೋಷ',
        failedToDelete: 'ಪ್ರಶ್ನೆಯನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ',
        topic: 'ವಿಷಯ',
        subTopic: 'ಉಪ ವಿಷಯ',
        actions: 'ಕ್ರಿಯೆಗಳು',
        question: 'ಪ್ರಶ್ನೆ',
        createNewQuestion: 'ಹೊಸ ಪ್ರಶ್ನೆ ರಚಿಸಿ',
        editQuestion: "ಪ್ರಶ್ನೆಯನ್ನು ಸಂಪಾದಿಸಿ",
        questionType: 'ಪ್ರಶ್ನೆಯ ಪ್ರಕಾರ',
        multipleChoice: 'ಬಹು ಆಯ್ಕೆ',
        questionText: 'ಪ್ರಶ್ನೆಯ ಪಠ್ಯ',
        enterQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ನಮೂದಿಸಿ...',
        enterTopic: 'ವಿಷಯವನ್ನು ನಮೂದಿಸಿ...',
        enterSubTopic: 'ಉಪ ವಿಷಯವನ್ನು ನಮೂದಿಸಿ...',
        answerOptions: 'ಉತ್ತರದ ಆಯ್ಕೆಗಳು',
        addOption: '+ ಆಯ್ಕೆಯನ್ನು ಸೇರಿಸಿ',
        selectCorrectAnswer: 'ಸರಿಯಾದ ಉತ್ತರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        option: 'ಆಯ್ಕೆ',
        submit: 'ಸಲ್ಲಿಸು',
        pleaseFill: 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಕ್ಷೇತ್ರಗಳನ್ನು ತುಂಬಿ.',
        failedToAdd: 'ಪ್ರಶ್ನೆಯನ್ನು ಸೇರಿಸಲು ವಿಫಲವಾಗಿದೆ.',
        success: 'ಯಶಸ್ವಿಯಾಗಿದೆ',
        questionAdded: 'ರಸಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ!',
        somethingWrong: 'ಏನೋ ತಪ್ಪಾಗಿದೆ.',
        createQuizBasic: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        createDailyQuiz: 'ದೈನಂದಿನ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        updateDailyQuiz: 'ದೈನಂದಿನ ಕ್ವಿಜ್ ಅನ್ನು ನವೀಕರಿಸಿ',
        updateQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ನವೀಕರಿಸಿ',
        editQuiz: 'ರಸಪ್ರಶ್ನೆ ಸಂಪಾದಿಸಿ',
        openQuiz: 'ರಸಪ್ರಶ್ನೆ ತೆರೆಯಿರಿ',
        quizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ',
        quizTitlePlaceholder: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ',
        quizTitleRequired: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ ಅಗತ್ಯವಿದೆ.',
        quizDescription: 'ರಸಪ್ರಶ್ನೆ ವಿವರಣೆ',
        quizDescriptionRequired: 'ರಸಪ್ರಶ್ನೆ ವಿವರಣೆ ಅಗತ್ಯವಿದೆ.',
        topicPlaceholder: 'ವಿಷಯವನ್ನು ನಮೂದಿಸಿ',
        subTopicPlaceholder: 'ಉಪ ವಿಷಯವನ್ನು ನಮೂದಿಸಿ',
        startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        endDate: 'ಕೊನೆಯ ದಿನಾಂಕ',
        startTime: 'ಪ್ರಾರಂಭ ಸಮಯ',
        endTime: 'ಕೊನೆಯ ಸಮಯ',
        quizVisibility: 'ರಸಪ್ರಶ್ನೆ ಗೋಚರತೆ',
        selectVisibility: 'ಗೋಚರತೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        public: 'ಸಾರ್ವಜನಿಕ',
        private: 'ಖಾಸಗಿ',
        save: 'ಉಳಿಸಿ',
        editQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸಂಪಾದಿಸಿ',
        addQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸೇರಿಸಿ',
        quizUpdated: 'ರಸಪ್ರಶ್ನೆ ನವೀಕರಿಸಲಾಗಿದೆ',
        quizCreated: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸಲಾಗಿದೆ',
        quizUpdatedDetail: 'ರಸಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ.',
        quizCreatedDetail: 'ರಸಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ.',
        saveQuizError: 'ರಸಪ್ರಶ್ನೆ ಉಳಿಸುವಾಗ ದೋಷ ಉಂಟಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        createQuizError: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸುವಾಗ ದೋಷ ಉಂಟಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        noQuizSelected: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆ ಆಯ್ಕೆ ಮಾಡಿಲ್ಲ',
        saveQuizBeforeEdit: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸಂಪಾದಿಸುವ ಮೊದಲು ರಸಪ್ರಶ್ನೆ ಉಳಿಸಿ.',
        toJoinGoTo: 'ಸೇರಲು, ಹೋಗಿ',
        quizAppName: 'ಜೈನ್ ಡೈರೆಕ್ಟ್ ರಸಪ್ರಶ್ನೆ',
        preview: 'ಪೂರ್ವನೋಟ',
        addQuestionPlaceholder: 'ಪ್ರಶ್ನೆ ಸೇರಿಸಲು ಕ್ಲಿಕ್ ಮಾಡಿ',
        addImageForQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಚಿತ್ರವನ್ನು ಸೇರಿಸಿ',
        addAudioForQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಆಡಿಯೊ ಸೇರಿಸಿ',
        addBackgroundImage: 'ಹಿನ್ನೆಲೆಯ ಚಿತ್ರವನ್ನು ಸೇರಿಸಿ',
        addAudioForBackground: 'ಹಿನ್ನೆಲೆಯ ಆಡಿಯೊ ಸೇರಿಸಿ',
        questionImage: 'ಪ್ರಶ್ನೆಯ ಚಿತ್ರ',
        yourQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ',
        addFromQuestionBank: 'ಪ್ರಶ್ನೆ ಭಂಡಾರ ಸೇರಿಸಿ',
        yourQuestionPlaceholder: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ...',
        pickAnswer: 'ಉತ್ತರ ಆಯ್ಕೆಮಾಡಿ',
        shortAnswer: 'ಸಣ್ಣ ಉತ್ತರ',
        shortAnswerPlaceholder: 'ನಿಮ್ಮ ಸಣ್ಣ ಉತ್ತರವನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ...',
        points: 'ಅಂಕಗಳು',
        fasterAnswersGetMorePoints: 'ವೇಗದ ಉತ್ತರಗಳಿಗೆ ಹೆಚ್ಚಿನ ಅಂಕಗಳು ಸಿಗುತ್ತವೆ',
        timeLimit: 'ಸಮಯ ಮಿತಿ',
        seconds: 'ಸೆಕೆಂಡುಗಳು',
        leaderboard: 'ಅಂಕಪಟ್ಟಿ',
        generalQuizzes: 'ಸಾಮಾನ್ಯ ಕ್ವಿಜ್‌ಗಳು',
        dailyQuizLeaderboard: 'ದೈನಂದಿನ ಕ್ವಿಜ್ ಲೀಡರ್‌ಬೋರ್ಡ್',
        sansthaQuizLeaderboard: 'ಸಂಸ್ಥೆ ಕ್ವಿಜ್ ಲೀಡರ್‌ಬೋರ್ಡ್',
        generalQuizSettings: 'ಸಾಮಾನ್ಯ ರಸಪ್ರಶ್ನೆ  ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
        type: 'ಪ್ರಕಾರ',
        back: 'ಹಿಂದೆ',
        next: 'ಮುಂದೆ',
        confirmSave: 'ಉಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ',
        confirmSaveMessage: 'ಈ ಪ್ರಶ್ನೆಯನ್ನು ಪ್ರಶ್ನೋತ್ತರದಲ್ಲಿ ಉಳಿಸಲು ನೀವು ಖಚಿತವೇ?',
        cancel: 'ರದ್ದುಮಾಡು',
        confirm: 'ದೃಢೀಕರಿಸಿ',
        questionBank: 'ಪ್ರಶ್ನೆ ಭಂಡಾರ',
        selectAll: 'ಎಲ್ಲವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        noQuestionsInBank: 'ಭಂಡಾರದಲ್ಲಿ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.',
        previous: 'ಹಿಂದೆ',
        next: 'ಮುಂದೆ',
        page: 'ಪುಟ',
        of: 'ನಲ್ಲಿ',
        addQuiz: 'ರಸಪ್ರಶ್ನೆ ಸೇರಿಸಿ',
        join_instruction: 'ಸೇರಲು, ಹೋಗಿ:',
        add_image: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಚಿತ್ರವನ್ನು ಸೇರಿಸಿ',
        add_audio: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಆಡಿಯೋ ಸೇರಿಸಿ',
        add_bg_image: 'ಹಿನ್ನೆಲೆ ಚಿತ್ರವನ್ನು ಸೇರಿಸಿ',
        add_bg_audio: 'ಹಿನ್ನೆಲೆ ಆಡಿಯೋ ಸೇರಿಸಿ',
        save: 'ಉಳಿಸಿ',
        your_question: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ',
        add_from_bank: 'ಪ್ರಶ್ನೆ ಭಂಡಾರದಿಂದ ಸೇರಿಸಿ',
        placeholder_question: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ...',
        add_option: '+ ಆಯ್ಕೆಯನ್ನು ಸೇರಿಸಿ',
        short_answer_placeholder: 'ನಿಮ್ಮ ಸಣ್ಣ ಉತ್ತರವನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ...',
        points: 'ಅಂಕಗಳು',
        faster_points: 'ವೇಗದ ಉತ್ತರಗಳಿಗೆ ಹೆಚ್ಚಿನ ಅಂಕಗಳು ಸಿಗುತ್ತವೆ',
        time_limit: 'ಸಮಯ ಮಿತಿ',
        seconds: 'ಸೆಕೆಂಡುಗಳು',
        leaderboard: 'ಅಂಕಪಟ್ಟಿ',
        settings: 'ಸಾಮಾನ್ಯ ರಸಪ್ರಶ್ನೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
        pick_answer: 'ಉತ್ತರ ಆಯ್ಕೆಮಾಡಿ',
        short_answer: 'ಸಣ್ಣ ಉತ್ತರ',
        back: 'ಹಿಂದೆ',
        next: 'ಮುಂದೆ',
        confirm_save_title: 'ಉಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ',
        confirm_save_text: 'ಈ ಪ್ರಶ್ನೆಯನ್ನು ರಸಪ್ರಶ್ನೆ ಉಳಿಸಲು ನೀವು ಖಚಿತವೇ?',
        question_bank: 'ಪ್ರಶ್ನೆ ಭಂಡಾರ',
        select_all: 'ಎಲ್ಲವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        no_questions: 'ಭಂಡಾರದಲ್ಲಿ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.',
        page: 'ಪುಟ',
        next_page: 'ಮುಂದಿನ ಪುಟ',
        add_quiz: 'ರಸಪ್ರಶ್ನೆ ಸೇರಿಸಿ',
        untitled_question: 'ಶೀರ್ಷಿಕೆ ಇಲ್ಲದ ಪ್ರಶ್ನೆ',
        searchQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಹುಡುಕಿ...',
        question: 'ಪ್ರಶ್ನೆ',
        actions: 'ಕ್ರಿಯೆಗಳು',
        noQuestions: 'ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ',
        confirmDelete: 'ಅಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ',
        confirmDeleteMsg: 'ಈ ಪ್ರಶ್ನೋತ್ತರವನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವೇ?',
        delete: 'ಅಳಿಸಿ',
        deleted: 'ಅಳಿಸಲಾಗಿದೆ',
        deleteSuccess: 'ಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ',
        deleteError: 'ಪ್ರಶ್ನೆಯನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ',
        back: 'ಹಿಂದೆ',
        createTitle: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        editTitle: 'ರಸಪ್ರಶ್ನೆ ಸಂಪಾದಿಸಿ',
        sansthaName: 'ಸಂಸ್ಥೆಯ ಹೆಸರು',
        quizDescription: 'ರಸಪ್ರಶ್ನೆ ವಿವರಣೆ',
        uploadImage: 'ಪ್ರಶ್ನೋತ್ತರಕ್ಕಾಗಿ ಚಿತ್ರವನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ',
        topic: 'ವಿಷಯ',
        timedQuiz: 'ಸಮಯಾಧಾರಿತ ರಸಪ್ರಶ್ನೆ',
        enabled: 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
        disabled: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
        visibility: 'ರಸಪ್ರಶ್ನೆ ಗೋಚರತೆ',
        selectVisibility: 'ಗೋಚರತೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        public: 'ಸಾರ್ವಜನಿಕ',
        private: 'ಖಾಸಗಿ',
        addQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸೇರಿಸಿ',
        editQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸಂಪಾದಿಸಿ',
        dragDrop: 'ಚಿತ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡಲು ಡ್ರಾಗ್ ಮತ್ತು ಡ್ರಾಪ್ ಮಾಡಿ ಅಥವಾ ಕ್ಲಿಕ್ ಮಾಡಿ',
        required: '{field} ಅಗತ್ಯವಿದೆ',
        successSave: 'ರಸಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!',
        errorSave: 'ರಸಪ್ರಶ್ನೆ ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ.',
        imageSelected: 'ಚಿತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ',
        sansthaQuizzes: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್',
        createSansthaQuiz: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        quizTitle: 'ಸಂಸ್ಥೆಯ ಹೆಸರು',
        uploadQuizImage: 'ರಸಪ್ರಶ್ನೆ ಚಿತ್ರವನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ',
        quizVisibility: 'ರಸಪ್ರಶ್ನೆ ಗೋಚರತೆ',
        enabled: 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
        disabled: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
        public: 'ಸಾರ್ವಜನಿಕ',
        private: 'ಖಾಸಗಿ',
        save: 'ಉಳಿಸು',
        cancel: 'ರದ್ದುಮಾಡು',
        editQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸಂಪಾದಿಸು',
        addQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಸೇರಿಸು',
        successQuizSaved: 'ರಸಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!',
        errorQuizSave: 'ರಸಪ್ರಶ್ನೆ ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ.',
        successCopy: 'ರಸಪ್ರಶ್ನೆ ಲಿಂಕ್ ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ!',
        copyQuizLink: 'ರಸಪ್ರಶ್ನೆ ಲಿಂಕ್ ನಕಲಿಸು',
        educatorDashboard: 'ಶಿಕ್ಷಕರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        createQuizBasic: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸು',
        totalQuizzes: 'ಒಟ್ಟು ರಸಪ್ರಶ್ನೆಗಳು',
        totalAttempts: 'ಒಟ್ಟು ಪ್ರಯತ್ನಗಳು',
        totalRegisteredUsers: 'ಒಟ್ಟು ನೋಂದಾಯಿತ ಬಳಕೆದಾರರು',
        averageScore: 'ಸರಾಸರಿ ಅಂಕ',
        completionRate: 'ಪೂರ್ಣಗೊಳಿಸುವ ದರ',
        thisWeek: 'ಈ ವಾರ',
        addedThisWeek: '+3',
        scoreIncrease: '+2.5%',
        completionIncrease: '+4%',
        recentQuizzes: 'ಇತ್ತೀಚಿನ ರಸಪ್ರಶ್',
        quizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ',
        dateCreated: 'ರಚಿಸಿದ ದಿನಾಂಕ',
        attempts: 'ಪ್ರಯತ್ನಗಳು',
        status: 'ಸ್ಥಿತಿ',
        action: 'ಕ್ರಮ',
        selectOne: 'ಒಂದನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        viewAllQuizzes: 'ಎಲ್ಲಾ ರಸಪ್ರಶ್ನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        viewAllQuizzesDesc: 'ನಿಮ್ಮ ಎಲ್ಲಾ ರಸಪ್ರಶ್ನೆಗಳನ್ನು ಪ್ರವೇಶಿಸಿ ಮತ್ತು ನಿರ್ವಹಿಸಿ.',
        quizAnalytics: 'ರಸಪ್ರಶ್ನೆ ವಿಶ್ಲೇಷಣೆ',
        quizAnalyticsDesc: 'ವಿಸ್ತೃತ ಕಾರ್ಯಕ್ಷಮತೆ ವಿಶ್ಲೇಷಣೆ.',
        studentReports: 'ವಿದ್ಯಾರ್ಥಿ ವರದಿಗಳು',
        studentReportsDesc: 'ವೈಯಕ್ತಿಕ ವಿದ್ಯಾರ್ಥಿಗಳ ಪ್ರಗತಿಯನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.',
        viewReports: 'ವರದಿಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        myQuizzes: 'ನನ್ನ ರಸಪ್ರಶ್ನೆಗಳು',
        manageAndOrganize: 'ನಿಮ್ಮ ಮೌಲ್ಯಮಾಪನಗಳನ್ನು ನಿರ್ವಹಿಸಿ ಮತ್ತು ಸಂಘಟಿಸಿ',
        createNewQuiz: '+ ಹೊಸ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        searchPlaceholder: 'ರಸಪ್ರಶ್ನೆಗಳನ್ನು ಹುಡುಕಿ...',
        allQuizzes: 'ಎಲ್ಲಾ ರಸಪ್ರಶ್ನೆಗಳು',
        active: 'ಸಕ್ರಿಯ',
        inactive: 'ನಿಷ್ಕ್ರಿಯ',
        completed: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
        loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
        questions: 'ಪ್ರಶ್ನೆಗಳು',
        aboutThisQuiz: 'ಈ ರಸಪ್ರಶ್ನೆಯ ಬಗ್ಗೆ',
        editQuiz: 'ರಸಪ್ರಶ್ನೆ ಸಂಪಾದಿಸು',
        copyLink: 'ಲಿಂಕ್ ನಕಲಿಸು',
        viewQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        deleteQuiz: 'ರಸಪ್ರಶ್ನೆ ಅಳಿಸು',
        delete: 'ಅಳಿಸು',
        showingQuizzes: '{count} ರಸಪ್ರಶ್ನೆಗಳನ್ನು ತೋರಿಸುತ್ತಿದೆ',
        pageOf: 'ಪುಟ {current} ರಲ್ಲಿ {total}',
        noQuizzesFoundTitle: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
        tryAdjustingSearch: 'ನಿಮ್ಮ ಹುಡುಕಾಟ ಅಥವಾ ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಸರಿಹೊಂದಿಸಲು ಪ್ರಯತ್ನಿಸಿ',
        confirmDelete: 'ಅಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ',
        areYouSureDelete: 'ನೀವು ಖಚಿತವಾಗಿಯೂ ಅಳಿಸಲು ಬಯಸುತ್ತೀರಾ',
        cancel: 'ರದ್ದು ಮಾಡು',
        deleting: 'ಅಳಿಸುತ್ತಿದೆ...',
        chooseReportType: 'ವರದಿ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        quizReport: 'ರಸಪ್ರಶ್ನೆ ವರದಿ',
        userReport: 'ಬಳಕೆದಾರ ವರದಿ',
        quizReportDesc: 'ಈ ರಸಪ್ರಶ್ನೆಯ ವರದಿಯನ್ನು ವೀಕ್ಷಿಸಿ (ಪ್ರತಿ ಪ್ರಶ್ನೆ ಬಳಕೆದಾರ ಪ್ರಯತ್ನಗಳು)',
        userReportDesc: 'ಪ್ರತಿ ಬಳಕೆದಾರ ಪ್ರಶ್ನೆ ಫಲಿತಾಂಶಗಳನ್ನು ವೀಕ್ಷಿಸಿ (ಸರಿ/ತಪ್ಪು)',
        previous: 'ಹಿಂದಿನದು',
        next: 'ಮುಂದಿನದು',
        noQuizzesFound: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
        quizQuestions: 'ರಸಪ್ರಶ್ನೆ ಪ್ರಶ್ನೆಗಳು',
        noQuestionsFound: 'ಈ ರಸಪ್ರಶ್ನೆಗೆ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
        points: 'ಅಂಕಗಳು',
        date: 'ದಿನಾಂಕ',
        close: 'ಮುಚ್ಚು',
        showQuizInstruction: 'ರಸಪ್ರಶ್ನೆ ಸೂಚನೆ ತೋರಿಸು',
        hideQuizInstruction: 'ರಸಪ್ರಶ್ನೆ ಸೂಚನೆ ಮರೆಮಾಡು',
        howToCreateQuiz: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸುವ ವಿಧಾನ',
        quizTip1: 'ಸ್ಪಷ್ಟ ಮತ್ತು ಚಿಕ್ಕ ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ.',
        quizTip2: 'ಬಹು ಆಯ್ಕೆಯಂತಹ ಸೂಕ್ತ ವರ್ಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ.',
        quizTip3: 'ಅಧ್ಯಯನಾರ್ಥಿಗಳಿಗೆ ಸಂಕ್ಷಿಪ್ತ ವಿವರಣೆಯನ್ನು ನೀಡಿ.',
        quizTip4: 'ರಸಪ್ರಶ್ನೆ ಎಷ್ಟು ದಿನಗಳ ಕಾಲ ನಡೆಯುತ್ತದೆ ಎಂದು ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ಪ್ರಾರಂಭ/ಕೊನೆ ದಿನಾಂಕಗಳನ್ನು ಹೊಂದಿಸಿ.',
        quizTip5: 'ರಜಾದಿನಗಳನ್ನು ಗುರುತಿಸಿ (ಇದ್ದರೆ) ಆ ದಿನಗಳಲ್ಲಿ ಪ್ರಶ್ನೆಗಳನ್ನು ತಪ್ಪಿಸಲು.',
        quizTip6: 'ಪ್ರತಿದಿನ ಎಷ್ಟು ಪ್ರಶ್ನೆಗಳು ತೋರಿಸಬೇಕು ಎಂದು ಹೊಂದಿಸಿ.',
        quizTip7: 'ಕಷ್ಟದ ಮಟ್ಟವನ್ನು ಆಯ್ಕೆಮಾಡಿ (ಸುಲಭ / ಮಧ್ಯಮ / ಕಠಿಣ).',
        createQuiz: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸು',
        enterQuizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ',
        category: 'ವರ್ಗ',
        multipleChoice: 'ಬಹು ಆಯ್ಕೆ',
        quizDescription: 'ರಸಪ್ರಶ್ನೆ ವಿವರಣೆ',
        startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        endDate: 'ಕೊನೆಯ ದಿನಾಂಕ',
        startTime: 'ಪ್ರಾರಂಭ ಸಮಯ',
        endTime: 'ಕೊನೆಯ ಸಮಯ',
        selectHolidayDays: 'ರಜಾದಿನಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        dailyQuestionCount: 'ಒಂದು ದಿನದಲ್ಲಿ ಎಷ್ಟು ಪ್ರಶ್ನೆಗಳನ್ನು ಹೊಂದಿಸಬೇಕು',
        selectNumber: 'ಸಂಖ್ಯೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        difficultyLevel: 'ಕಷ್ಟದ ಮಟ್ಟ',
        easy: 'ಸುಲಭ',
        medium: 'ಮಧ್ಯಮ',
        hard: 'ಕಷ್ಟದ',
        updateQuiz: 'ರಸಪ್ರಶ್ನೆ ನವೀಕರಿಸಿ',
        createQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಿ',
        saveQuestions: 'ಪ್ರಶ್ನೆಗಳನ್ನು ಉಳಿಸಿ',
        back: 'ಹಿಂದೆ',
        show: 'ತೋರಿಸು',
        hide: 'ಮರೆಮಾಡು',
        quizInstruction: 'ರಸಪ್ರಶ್ನೆ ಸೂಚನೆ',
        howToCreateQuestion: '📘 ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸುವ ವಿಧಾನ',
        description: 'ವಿವರಣೆ',
        daysQuizRun: 'ರಸಪ್ರಶ್ನೆ ಎಷ್ಟು ದಿನಗಳ ಕಾಲ ನಡೆಯುತ್ತದೆ ಎಂಬುದನ್ನು ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ದಿನಾಂಕಗಳನ್ನು ಹೊಂದಿಸಿ.',
        markHolidays: 'ರಜಾದಿನಗಳನ್ನು ಗುರುತಿಸಿ (ಇದ್ದರೆ) ಆ ದಿನಗಳಲ್ಲಿ ಪ್ರಶ್ನೆಗಳನ್ನು ತಪ್ಪಿಸಲು.',
        questionsPerDay: 'ಪ್ರತಿದಿನ ಎಷ್ಟು ಪ್ರಶ್ನೆಗಳು ತೋರಿಸಬೇಕು ಎಂದು ಹೊಂದಿಸಿ.',
        questionBuilder: 'ಪ್ರಶ್ನೆ ನಿರ್ಮಾಪಕ',
        addFromQuestionBank: '+ ಪ್ರಶ್ನೆ ಬ್ಯಾಂಕ್‌ನಿಂದ ಸೇರಿಸಿ',
        question: 'ಪ್ರಶ್ನೆ',
        removeQuestion: 'ಪ್ರಶ್ನೆಯನ್ನು ಅಳಿಸು',
        enterQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ...',
        addImageOfQuestion: 'ಪ್ರಶ್ನೆಯ ಚಿತ್ರ ಸೇರಿಸು',
        addAudioOfQuestion: 'ಪ್ರಶ್ನೆಯ ಧ್ವನಿ ಸೇರಿಸು',
        addVideoOfQuestion: 'ಪ್ರಶ್ನೆಯ ವೀಡಿಯೊ ಸೇರಿಸು',
        options: 'ಆಯ್ಕೆಗಳು',
        option: 'ಆಯ್ಕೆ',
        addAnotherOption: '+ ಮತ್ತೊಂದು ಆಯ್ಕೆಯನ್ನು ಸೇರಿಸಿ',
        correctAnswer: 'ಸರಿಯಾದ ಉತ್ತರ',
        questionDate: 'ಪ್ರಶ್ನೆಯ ದಿನಾಂಕ',
        selectQuestionDate: 'ಪ್ರಶ್ನೆಯ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        addNewQuestion: '+ ಹೊಸ ಪ್ರಶ್ನೆ ಸೇರಿಸಿ',
        questionBank: 'ಪ್ರಶ್ನೆ ಬ್ಯಾಂಕ್',
        selectQuestionsFromBank: 'ಪ್ರಶ್ನೆ ಬ್ಯಾಂಕ್‌ನಿಂದ ಆಯ್ಕೆಮಾಡಿ',
        noQuestionsAvailable: 'ಬ್ಯಾಂಕ್‌ನಲ್ಲಿ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.',
        addSelected: 'ಆಯ್ಕೆ ಮಾಡಿದವು ಸೇರಿಸಿ',
        cancel: 'ರದ್ದುಮಾಡು',
        added: 'ಸೇರಿಸಲಾಗಿದೆ',
        selectedQuestionsAdded: 'ಆಯ್ಕೆ ಮಾಡಿದ ಪ್ರಶ್ನೆಗಳು ರಸಪ್ರಶ್ನೆ ನಿರ್ಮಾಪಕಕ್ಕೆ ಸೇರಿಸಲಾಗಿದೆ.',
        error: 'ದೋಷ',
        failedToLoadBank: 'ಸಂಗ್ರಹದಿಂದ ಪ್ರಶ್ನೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.',
        noData: 'ಮಾಹಿತಿ ಇಲ್ಲ',
        noQuestionsFound: 'ಈ ರಸಪ್ರಶ್ನೆಗೆ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
        failedToLoadQuizQuestions: 'ರಸಪ್ರಶ್ನೆಯ ಪ್ರಶ್ನೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.',
        remove: '✖',
        selectAll: 'ಎಲ್ಲವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        previous: 'ಹಿಂದಿನದು',
        next: 'ಮುಂದಿನದು',
        page: 'ಪುಟ',
        of: 'ಯಾವುದರಲ್ಲಿ',
        addQuiz: 'ರಸಪ್ರಶ್ನೆ ಸೇರಿಸಿ',
        noAvailableQuizzes: 'ಲಭ್ಯವಿರುವ ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳಿಲ್ಲ',
        quizzesWillAppear: 'ಹೊಸ ಪ್ರಶ್ನೋತ್ತರಿಕೆಗಳು ಲಭ್ಯವಾದಾಗ ಇಲ್ಲಿ ತೋರಿಸಲಾಗುತ್ತದೆ. ನಿರೀಕ್ಷಿಸಿರಿ!',
        noDetailsAvailable: 'ಯಾವುದೇ ವಿವರಗಳು ಲಭ್ಯವಿಲ್ಲ',
        questions: 'ಪ್ರಶ್ನೆಗಳು',
        marks: 'ಅಂಕಗಳು',
        start: 'ಪ್ರಾರಂಭಿಸು',
        end: 'ಕೊನೆಗೊಳಿಸು',
        comingSoon: 'ಬರುತ್ತಿದೆ ಶೀಘ್ರದಲ್ಲೇ',
        startQuiz: 'ರಸಪ್ರಶ್ನೆ ಪ್ರಾರಂಭಿಸು',
        failedToLoadQuizzes: 'ರಸಪ್ರಶ್ನೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        daily_quiz_challenges: 'ದೈನಂದಿನ ರಸಪ್ರಶ್ನೆ ಸವಾಲುಗಳು',
        test_your_knowledge: 'ನಮ್ಮ ದೈನಂದಿನ ಆಯ್ಕೆ ಮಾಡಿದ ರಸಪ್ರಶ್ನೆಗಳಿಂದ ನಿಮ್ಮ ಜ್ಞಾನವನ್ನು ಪರೀಕ್ಷಿಸಿ',
        search_placeholder: 'ರಸಪ್ರಶ್ನೆ ಹುಡುಕಿ...',
        todays_special: 'ಇಂದಿನ ವಿಶೇಷ',
        start_quiz: 'ರಸಪ್ರಶ್ನೆ ಪ್ರಾರಂಭಿಸಿ',
        all: 'ಎಲ್ಲಾ',
        easy: 'ಸುಲಭ',
        medium: 'ಮಧ್ಯಮ',
        hard: 'ಕಠಿಣ',
        sort_by_latest: 'ವಿಂಗಡಣೆ: ಇತ್ತೀಚಿನದು',
        sort_by_popular: 'ವಿಂಗಡಣೆ: ಜನಪ್ರಿಯ',
        no_quizzes_found: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ!',
        prev: 'ಹಿಂದಿನದು',
        next: 'ಮುಂದಿನದು',
        active_users: 'ಸಕ್ರಿಯ ಬಳಕೆದಾರರು',
        daily_winners: 'ದೈನಂದಿನ ವಿಜೇತರು',
        success_rate: 'ಯಶಸ್ಸಿನ ಪ್ರಮಾಣ',
        quizzes_available: 'ಲಭ್ಯವಿರುವ ರಸಪ್ರಶ್ನೆಗಳು',
        sansthaName: 'ಜೈನ್ ಅಹೀರ್ ಸಂಸ್ಥೆ',
        topicName: 'ವಿಷಯದ ಹೆಸರು',
        addQuestionImage: 'ಪ್ರಶ್ನೆಯ ಚಿತ್ರ ಸೇರಿಸಿ',
        addQuestionAudio: 'ಪ್ರಶ್ನೆಯ ಧ್ವನಿ ಸೇರಿಸಿ',
        defaultQuestion: 'ನಿಮ್ಮ ಅದ್ಭುತ ಪ್ರಶ್ನೆಯನ್ನು ಸೇರಿಸಲು ಕ್ಲಿಕ್ ಮಾಡಿ',
        quizQuestion: 'ರಸಪ್ರಶ್ನೆಯ ಪ್ರಶ್ನೆ',
        option: 'ಆಯ್ಕೆ',
        addOption: '+ ಆಯ್ಕೆ ಸೇರಿಸಿ',
        points: 'ಅಂಕಗಳು',
        timer: 'ಟೈಮರ್ (ಸೆಕೆಂಡ್)',
        bonus: 'ವೇಗವಾಗಿ ಉತ್ತರಿಸಿದವರಿಗೆ ಹೆಚ್ಚು ಅಂಕಗಳು ಸಿಗುತ್ತವೆ',
        confirmSave: 'ಉಳಿಸುವುದನ್ನು ದೃಢಪಡಿಸಿ',
        confirmMsg: 'ಈ ಪ್ರಶ್ನೆಯನ್ನು ರಸಪ್ರಶ್ನೆಯಲ್ಲಿ ಉಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?',
        confirm: 'ದೃಢಪಡಿಸಿ',
        back: 'ಹಿಂದೆ',
        next: 'ಮುಂದಿನದು',
        mcq: 'ಬಹು ಆಯ್ಕೆ ಪ್ರಶ್ನೆ',
        save: 'ಉಳಿಸು',
        quizzes: 'ರಸಪ್ರಶ್ನೆಗಳು',
        quizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ',
        topic: 'ವಿಷಯ',
        subTopic: 'ಉಪವಿಷಯ',
        sansthaNameField: 'ಸಂಸ್ಥೆಯ ಹೆಸರು',
        startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        endDate: 'ಕೊನೆಯ ದಿನಾಂಕ',
        quizDetail: 'ರಸಪ್ರಶ್ನೆ ವಿವರ',
        action: 'ಕ್ರಮ',
        noQuizzes: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.',
        confirmDelete: 'ಅಳಿಸುವುದನ್ನು ದೃಢಪಡಿಸಿ',
        deleteMsg: 'ಈ ರಸಪ್ರಶ್ನೆಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?',
        delete: 'ಅಳಿಸು',
        viewQuestions: 'ಪ್ರಶ್ನೆಗಳು -ವೀಕ್ಷಿಸಿ',
        noQuestions: 'ಈ ರಸಪ್ರಶ್ನೆಗೆ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.',
        close: 'ಮುಚ್ಚು',
        linkCopied: 'ರಸಪ್ರಶ್ನೆ ಲಿಂಕ್ ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ.',
        copyError: 'ಲಿಂಕ್ ನಕಲಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.',
        quizDeleted: 'ರಸಪ್ರಶ್ನೆ ಮತ್ತು ಸಂಬಂಧಿತ ಡೇಟಾ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ.',
        deleteError: 'ರಸಪ್ರಶ್ನೆ ಅಥವಾ ಅದರ ಡೇಟಾವನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ.',
        home: 'ಮುಖಪುಟ',
        pages: 'ಪುಟಗಳು',
        userDashboard: 'ಬಳಕೆದಾರರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        educatorDashboard: 'ಶಿಕ್ಷಕರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        quizDashboard: 'ರಸಪ್ರಶ್ನೆ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        questionBank: 'ಪ್ರಶ್ನೆ ಸಂಗ್ರಹ',
        sansthaQuiz: 'ಸಂಸ್ಥೆ ರಸಪ್ರಶ್ನೆ',
        sansthaQuizzes: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆಗಳು',
        dailyQuizzes: 'ದೈನಂದಿನ ರಸಪ್ರಶ್ನೆಗಳು',
        quizes: 'ರಸಪ್ರಶ್ನೆಗಳು',
        adminDashboard: 'ನಿರ್ವಾಹಕ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        addBrandOrSponsorImage: 'ಬ್ರ್ಯಾಂಡ್ ಅಥವಾ ಪ್ರಾಯೋಜಕ ಚಿತ್ರವನ್ನು ಸೇರಿಸಿ',
        analyticsOverview: 'ವಿಶ್ಲೇಷಣೆ ಅವಲೋಕನ',
        overallAnalytics: 'ಸಮಗ್ರ ವಿಶ್ಲೇಷಣೆ',
        settings: 'ಸೆಟ್ಟಿಂಗ್ಸ್',
        leaderboardPublishing: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ಪ್ರಕಟಣೆ',
        profile: 'ಪ್ರೊಫೈಲ್',
        managedByMe: 'ನನ್ನಿಂದ ನಿರ್ವಹಿಸಲಾಗಿದೆ',
        dailyQuizCreation: 'ದೈನಂದಿನ ರಸಪ್ರಶ್ನೆರಚನೆ',
        switchToEducator: 'ಶಿಕ್ಷಕರ ಮೋಡ್‌ಗೆ ಬದಲಾಯಿಸಿ',
        switchToParticipant: 'ಭಾಗವಹಿಸುವವರ ಮೋಡ್‌ಗೆ ಬದಲಾಯಿಸಿ',
        language: 'ಭಾಷೆ',
        switchToHindi: 'ಹಿಂದಿಗೆ ಬದಲಾಯಿಸಿ',
        switchToEnglish: 'ಇಂಗ್ಲಿಷ್‌ಗೆ ಬದಲಾಯಿಸಿ',
        weeklyQuizCompletion: 'ವಾರದ ರಸಪ್ರಶ್ನೆ ಪೂರ್ಣಗೊಳಿಸುವಿಕೆ',
        quizCompletionStatus: 'ರಸಪ್ರಶ್ನೆ ಪೂರ್ಣಗೊಳಿಸುವ ಸ್ಥಿತಿ',
        completed: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
        inProgress: 'ಪ್ರಗತಿಯಲ್ಲಿದೆ',
        notStarted: 'ಪ್ರಾರಂಭವಾಗಿಲ್ಲ',
        completions: 'ಪೂರ್ಣಗೊಳಿಸುವಿಕೆಗಳು',
        january: 'ಜನವರಿ',
        february: 'ಫೆಬ್ರವರಿ',
        march: 'ಮಾರ್ಚ್',
        april: 'ಏಪ್ರಿಲ್',
        may: 'ಮೇ',
        june: 'ಜೂನ್',
        july: 'ಜುಲೈ',
        leaderboard: 'ನಾಯಕತ್ವ ಫಲಕ',
        sendMessages: 'ಸಂದೇಶಗಳನ್ನು ಕಳುಹಿಸಿ',
        manageUsers: 'ಬಳಕೆದಾರರನ್ನು ನಿರ್ವಹಿಸಿ',
        roles: 'ಪಾತ್ರಗಳು',
        assignLuckyWinners: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತರನ್ನು ನಿಯೋಜಿಸಿ',
        // Question bank toast
        errorFillFields: 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ.',
        errorInsert: 'ಪ್ರಶ್ನೆಯನ್ನು ಸೇರಿಸಲು ವಿಫಲವಾಗಿದೆ.',
        errorUnexpected: 'ಏನೋ ತಪ್ಪಾಗಿದೆ.',
        successInsert: 'ಪ್ರಶ್ನೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ!',
        successUpdate: 'ಪ್ರಶ್ನೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ!',
        confirmEdit: 'ಸಂಪಾದನೆಯನ್ನು ದೃಢಪಡಿಸಿ',
        editPrompt: 'ನೀವು ಈ ಪ್ರಶ್ನೆಯನ್ನು ಸಂಪಾದಿಸಲು ಬಯಸುವಿರಾ?',
        yes: 'ಹೌದು',
        // daily quiz question
        enterClearQuestionText: 'ಸ್ಪಷ್ಟ ಮತ್ತು ಸಂಪೂರ್ಣವಾದ ಪ್ರಶ್ನೆಯನ್ನು ನಮೂದಿಸಿ',
        addOptions: 'ಉತ್ತರ ಆಯ್ಕೆಗಳನ್ನು ಸೇರಿಸಿ',
        minimumTwoRequired: 'ಕನಿಷ್ಠ 2 ಅಗತ್ಯವಿದೆ',
        markCorrectAnswer: 'ಸರಿಯಾದ ಉತ್ತರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        addImageOrAudioOptional: 'ಐಚ್ಛಿಕವಾಗಿ ಚಿತ್ರ ಅಥವಾ ಧ್ವನಿಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
        setQuestionDateWithinQuizRange: 'ರಸಪ್ರಶ್ನೆ ವೇಳಾಪಟ್ಟಿಯೊಳಗೆ ಪ್ರಶ್ನೆಯ ದಿನಾಂಕವನ್ನು ಹೊಂದಿಸಿ',
        assignPoints: 'ಈ ಪ್ರಶ್ನೆಗೆ ಅಂಕಗಳನ್ನು ನೀಡು',
        useSimpleLanguage: 'ಉತ್ತಮ ಅರ್ಥೈಸಿಕೊಳ್ಳಲು ಸರಳ ಮತ್ತು ಸ್ಪಷ್ಟ ಭಾಷೆಯನ್ನು ಬಳಸಿ',
        points: 'ಅಂಕಗಳು',
        durationInDays: 'ಅವಧಿ (ದಿನಗಳಲ್ಲಿ)',
        enterDays: 'ದಿನಗಳ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        // Lucky winner
        luckyWinnersManagement: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತರ ನಿರ್ವಹಣೆ',
        dailyWinners: 'ದೈನಂದಿನ ವಿಜೇತರು',
        weeklyWinners: 'ವಾರದ ವಿಜೇತರು',
        selectDate: 'ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
        searchParticipants: 'ಹೆಸರು ಅಥವಾ ಐಡಿ ಮೂಲಕ ಭಾಗವಹಿಸುವವರನ್ನು ಹುಡುಕಿ',
        quizName: 'ರಸಪ್ರಶ್ನೆ ಹೆಸರು',
        participantId: 'ಭಾಗವಹಿಸುವವರ ಐಡಿ',
        name: 'ಹೆಸರು',
        quizType: 'ರಸಪ್ರಶ್ನೆ ಪ್ರಕಾರ',
        score: 'ಅಂಕ',
        participationDate: 'ಭಾಗವಹಿಸುವ ದಿನಾಂಕ',
        performance: 'ಕಾರ್ಯಕ್ಷಮತೆ',
        winnerStatus: 'ವಿಜೇತರ ಸ್ಥಿತಿ',
        alreadyWinner: 'ಈಗಾಗಲೇ ವಿಜೇತ',
        gold: 'ಚಿನ್ನ',
        silver: 'ಬೆಳ್ಳಿ',
        bronze: 'ಕಂಚು',
        sendNotifications: 'ಅಧಿಸೂಚನೆಗಳನ್ನು ಕಳುಹಿಸಿ',
        clearSelection: 'ಆಯ್ಕೆಯನ್ನು ತೆರವುಗೊಳಿಸಿ',
        saveWinners: 'ವಿಜೇತರನ್ನು ಉಳಿಸಿ',
        noParticipantsFound: 'ಯಾವುದೇ ಭಾಗವಹಿಸುವವರು ಕಂಡುಬಂದಿಲ್ಲ',
        noWinnersSelected: 'ಕನಿಷ್ಠ ಒಂದು ವಿಜೇತನಾದರೂ ಆಯ್ಕೆಮಾಡಿ.',
        noNewWinners: 'ಕನಿಷ್ಠ ಒಂದು ಹೊಸ ವಿಜೇತನಾದರೂ ಆಯ್ಕೆಮಾಡಿ.',
        winnersSaved: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತರನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!',
        saveFailed: 'ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ',
        success: 'ಯಶಸ್ಸು',
        error: 'ದೋಷ',
        whatsappError: 'ವಾಟ್ಸಾಪ್ ದೋಷ',
        excellent: 'ಅತ್ಯುತ್ತಮ',
        good: 'ಉತ್ತಮ',
        average: 'ಸರಾಸರಿ',
        saveWeeklyWinners: 'ವಾರದ ವಿಜೇತರನ್ನು ಉಳಿಸಿ',
        weeklyWinnersSaved: 'ವಾರದ ವಿಜೇತರನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!',
        saveError: 'ವಾರದ ವಿಜೇತರನ್ನು ಉಳಿಸುವಾಗ ದೋಷ ಸಂಭವಿಸಿದೆ',
        fetchError: 'ಭಾಗವಹಿಸುವವರನ್ನು ತರಲು ದೋಷ',
        noParticipantsSelected: 'ಕನಿಷ್ಠ ಒಂದು ಭಾಗವಹಿಸುವವರಾದರೂ ಆಯ್ಕೆಮಾಡಿ',
        // role management
        roleManagement: 'ಪಾತ್ರ ನಿರ್ವಹಣೆ',
        roleManagementDesc: 'ನಿಮ್ಮ ರಸಪ್ರಶ್ನೆ ವ್ಯವಸ್ಥೆಗೆ ಪಾತ್ರಗಳನ್ನು ನಿರ್ವಹಿಸಿ ಮತ್ತು ರಚಿಸಿ',
        addNewRole: 'ಹೊಸ ಪಾತ್ರವನ್ನು ಸೇರಿಸಿ',
        roleName: 'ಪಾತ್ರದ ಹೆಸರು',
        enterRoleName: 'ಪಾತ್ರದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
        description: 'ವಿವರಣೆ',
        enterDescription: 'ಪಾತ್ರದ ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ',
        permissions: 'ಅನುಮತಿಗಳು',
        createRole: 'ಪಾತ್ರವನ್ನು ರಚಿಸಿ',
        currentRoles: 'ಪ್ರಸ್ತುತ ಪಾತ್ರಗಳು',
        searchRoles: 'ಪಾತ್ರಗಳನ್ನು ಹುಡುಕಿ...',
        createdDate: 'ರಚಿಸಿದ ದಿನಾಂಕ',
        updatedDate: 'ನವೀಕರಿಸಿದ ದಿನಾಂಕ',
        validationError: 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ.',
        roleCreationFailed: 'ಪಾತ್ರ ರಚನೆ ವಿಫಲವಾಗಿದೆ',
        permissionMappingFailed: 'ಅನುಮತಿ ಮ್ಯಾಪಿಂಗ್ ವಿಫಲವಾಗಿದೆ',
        roleCreated: 'ಪಾತ್ರವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ!',
        quizAccessControl: 'ರಸಪ್ರಶ್ನೆ ನಿರ್ವಹಣಾ ಪ್ರವೇಶ ನಿಯಂತ್ರಣ',
        quizAccessControlDesc: 'ರಸಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಲು ಮತ್ತು ಸಂಪಾದಿಸಲು ಸಾಧ್ಯವಾದ ಬಳಕೆದಾರರನ್ನು ನಿರ್ವಹಿಸಿ',
        addNewUser: 'ಹೊಸ ಬಳಕೆದಾರರನ್ನು ಸೇರಿಸಿ',
        quizManagerRole: 'ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕ ಪಾತ್ರ',
        quizManagerRoleDesc: 'ಈ ಪಾತ್ರದ ಬಳಕೆದಾರರು ರಸಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಲು, ಸಂಪಾದಿಸಲು ಮತ್ತು ಅಳಿಸಲು ಸಾಧ್ಯ',
        createQuizzes: 'ಹೊಸ ರಸಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಿ',
        editQuizzes: 'ಈಗಿರುವ ರಸಪ್ರಶ್ನೆಗಳನ್ನು ಸಂಪಾದಿಸಿ',
        deleteQuizzes: 'ರಸಪ್ರಶ್ನೆಗಳನ್ನು ಅಳಿಸಿ',
        manageSettings: 'ರಸಪ್ರಶ್ನೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
        viewAnalytics: 'ವಿಶ್ಲೇಷಣೆ ವೀಕ್ಷಿಸಿ',
        assignPermissions: 'ಅನುಮತಿಗಳನ್ನು ನೀಡು',
        currentManagers: 'ಪ್ರಸ್ತುತ ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕರು',
        noManagers: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕರು ಲಭ್ಯವಿಲ್ಲ',
        noEducatorsInSoftware: 'ನಿಮ್ಮ ಸಾಫ್ಟ್‌ವೇರ್‌ನಲ್ಲಿ ಯಾವುದೇ ಶಿಕ್ಷಕರು ಇಲ್ಲ',
        userName: 'ಬಳಕೆದಾರರ ಹೆಸರು',
        email: 'ಇಮೇಲ್',
        mobile: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
        role: 'ಪಾತ್ರ',
        accessLevel: 'ಪ್ರವೇಶ ಮಟ್ಟ',
        dateAdded: 'ಸೇರಿಸಿದ ದಿನಾಂಕ',
        actions: 'ಕ್ರಮಗಳು',
        confirmAddManager: 'ನಿರ್ವಾಹಕ ಸೇರ್ಪಡೆ ದೃಢಪಡಿಸಿ',
        confirmAddText: 'ನೀವು ನಿರ್ವಾಹಕರನ್ನು ಸೇರಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?',
        yes: 'ಹೌದು',
        cancel: 'ರದ್ದುಮಾಡಿ',
        editManagerRole: 'ನಿರ್ವಾಹಕ ಪಾತ್ರ ಸಂಪಾದಿಸಿ',
        selectRole: 'ಪಾತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        save: 'ಉಳಿಸಿ',
        confirmDeletion: 'ಅಳಿಸುವುದನ್ನು ದೃಢಪಡಿಸಿ',
        confirmDeleteText: 'ನೀವು ಈ ನಿರ್ವಾಹಕರನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿದ್ದೀರಾ?',
        yesDelete: 'ಹೌದು, ಅಳಿಸಿ',
        error: 'ದೋಷ',
        invalidManager: 'ಅಮಾನ್ಯ ನಿರ್ವಾಹಕ ಆಯ್ಕೆಯಾಗಿದೆ',
        deleteFailed: 'ನಿರ್ವಾಹಕರನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ',
        deleteSuccess: '{name} ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕರಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ',
        roleUpdateFailed: 'ಪಾತ್ರವನ್ನು ನವೀಕರಿಸಲು ವಿಫಲವಾಗಿದೆ',
        roleUpdated: 'ನಿರ್ವಾಹಕ ಪಾತ್ರ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ',
        // get leadershipboard
        selectQuizAndDate: 'ರಸಪ್ರಶ್ನೆ ಮತ್ತು ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        selectDate: 'ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        chooseQuiz: 'ರಸಪ್ರಶ್ನೆ ಆಯ್ಕೆಮಾಡಿ',
        selectAQuiz: 'ಒಂದು ರಸಪ್ರಶ್ನೆ ಆಯ್ಕೆಮಾಡಿ',
        viewLeaderboard: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ವೀಕ್ಷಿಸಿ',
        seeHowYouRank: 'ಇತರರೊಂದಿಗೆ ನಿಮ್ಮ ರ‍್ಯಾಂಕ್ ನೋಡಿ ಮತ್ತು ನಿಮ್ಮನ್ನು ಸವಾಲು ಮಾಡಿ 💡',
        userNotLoggedIn: 'ಬಳಕೆದಾರರು ಲಾಗಿನ್ ಆಗಿಲ್ಲ',
        noScoresFound: '❌ ಈ ದಿನಾಂಕಕ್ಕೆ ಯಾವುದೇ ಅಂಕಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
        noQuizzesFound: '❌ ಈ ದಿನಾಂಕಕ್ಕೆ ನೀವು ಯಾವುದೇ ಕ್ವಿಜ್‌ಗಳನ್ನು ರಚಿಸಿಲ್ಲ.',
        // create sanstha quiz
        organizationQuizUrl: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ URL',
        active: 'ಸಕ್ರಿಯ',
        quickAccess: 'ತ್ವರಿತ ಪ್ರವೇಶ',
        scanQrCode: 'ರಸಪ್ರಶ್ನೆ ಪೋರ್ಟಲ್‌ಗೆ ಪ್ರವೇಶಿಸಲು QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
        createNewQuiz: 'ಹೊಸ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        quizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ',
        enterQuizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ ನಮೂದಿಸಿ',
        organization: 'ಸಂಸ್ಥೆ',
        description: 'ವಿವರಣೆ',
        enterDescription: 'ಕ್ವಿಜ್ ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ',
        quizDurationType: 'ರಸಪ್ರಶ್ನೆ ಅವಧಿಯ ಪ್ರಕಾರ',
        singleDay: 'ಒಂದು ದಿನ',
        multiDay: 'ಬಹು ದಿನ',
        topic: 'ವಿಷಯ',
        enterTopic: 'ವಿಷಯ ನಮೂದಿಸಿ',
        subtopic: 'ಉಪವಿಷಯ',
        enterSubtopic: 'ಉಪವಿಷಯ ನಮೂದಿಸಿ',
        startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        startTime: 'ಪ್ರಾರಂಭ ಸಮಯ',
        endDate: 'ಕೊನೆ ದಿನಾಂಕ',
        endTime: 'ಕೊನೆ ಸಮಯ',
        releaseResult: 'ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ',
        instant: 'ತಕ್ಷಣ',
        scheduled: 'ನಿಗದಿತ',
        resultReleaseDate: 'ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ದಿನಾಂಕ',
        resultReleaseTime: 'ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ಸಮಯ',
        createQuizBtn: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        quizAccessControl: 'ರಸಪ್ರಶ್ನೆ ನಿರ್ವಹಣಾ ಪ್ರವೇಶ ನಿಯಂತ್ರಣ',
        quizAccessControlDesc: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸಲು ಮತ್ತು ಸಂಪಾದಿಸಲು ಸಾಧ್ಯವಾಗುವ ಬಳಕೆದಾರರನ್ನು ನಿರ್ವಹಿಸಿ',
        addNewUser: 'ಹೊಸ ಬಳಕೆದಾರರನ್ನು ಸೇರಿಸಿ',
        quizManagerRole: 'ರಸಪ್ರಶ್ನೆ ಮ್ಯಾನೇಜರ್ ಪಾತ್ರ',
        quizManagerRoleDesc: 'ಈ ಪಾತ್ರದ ಬಳಕೆದಾರರು ರಸಪ್ರಶ್ನೆ ರಚಿಸಲು, ಸಂಪಾದಿಸಲು ಮತ್ತು ಅಳಿಸಲು ಸಾಧ್ಯವಿದೆ',
        createQuizzes: 'ಹೊಸ ರಸಪ್ರಶ್ನೆ ಗಳನ್ನು ರಚಿಸಿ',
        editQuizzes: 'ಇದ್ದ ರಸಪ್ರಶ್ನೆ ಗಳನ್ನು ಸಂಪಾದಿಸಿ',
        deleteQuizzes: 'ರಸಪ್ರಶ್ನೆಗಳನ್ನು ಅಳಿಸಿ',
        manageSettings: 'ರಸಪ್ರಶ್ನೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
        viewAnalytics: 'ವಿಶ್ಲೇಷಣೆಯನ್ನು ವೀಕ್ಷಿಸಿ',
        assignPermissions: 'ಅನುಮತಿಗಳನ್ನು ನೀಡು',
        currentManagers: 'ಪ್ರಸ್ತುತ ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕರು',
        noManagers: 'ಯಾವುದೇ ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕರು ಲಭ್ಯವಿಲ್ಲ',
        noEducatorsInSoftware: 'ನಿಮ್ಮ ಸಾಫ್ಟ್‌ವೇರ್‌ನಲ್ಲಿ ಯಾವುದೇ ಶಿಕ್ಷಕರು ಇಲ್ಲ',
        userName: 'ಬಳಕೆದಾರರ ಹೆಸರು',
        email: 'ಇಮೇಲ್',
        mobile: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
        role: 'ಪಾತ್ರ',
        accessLevel: 'ಪ್ರವೇಶ ಮಟ್ಟ',
        dateAdded: 'ಸೇರಿಸಿದ ದಿನಾಂಕ',
        actions: 'ಕ್ರಿಯೆಗಳು',
        confirmAddManager: 'ನಿರ್ವಾಹಕರ ಸೇರ್ಪಡೆ ದೃಢೀಕರಿಸಿ',
        confirmAddText: 'ನೀವು ನಿರ್ವಾಹಕರನ್ನು ಸೇರಿಸಲು ಖಚಿತವೇ?',
        yes: 'ಹೌದು',
        cancel: 'ರದ್ದುಮಾಡಿ',
        editManagerRole: 'ನಿರ್ವಾಹಕ ಪಾತ್ರವನ್ನು ಸಂಪಾದಿಸಿ',
        selectRole: 'ಪಾತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        save: 'ಉಳಿಸಿ',
        confirmDeletion: 'ಅಳಿಸುವಿಕೆಯನ್ನು ದೃಢೀಕರಿಸಿ',
        confirmDeleteText: 'ಈ ನಿರ್ವಾಹಕರನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವೇ?',
        yesDelete: 'ಹೌದು, ಅಳಿಸಿ',
        error: 'ದೋಷ',
        invalidManager: 'ಅಮಾನ್ಯ ನಿರ್ವಾಹಕ ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
        deleteFailed: 'ನಿರ್ವಾಹಕರನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ',
        deleteSuccess: '{name} ಅವರನ್ನು ರಸಪ್ರಶ್ನೆ ನಿರ್ವಾಹಕರಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ',
        roleUpdateFailed: 'ಪಾತ್ರವನ್ನು ನವೀಕರಿಸಲು ವಿಫಲವಾಗಿದೆ',
        roleUpdated: 'ನಿರ್ವಾಹಕ ಪಾತ್ರವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ',
        // get leadershipboard
        selectQuizAndDate: 'ರಸಪ್ರಶ್ನೆ ಮತ್ತು ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
        selectDate: 'ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        chooseQuiz: 'ರಸಪ್ರಶ್ನೆ ಆಯ್ಕೆಮಾಡಿ',
        selectAQuiz: 'ಒಂದು ರಸಪ್ರಶ್ನೆ ಆಯ್ಕೆಮಾಡಿ',
        viewLeaderboard: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ವೀಕ್ಷಿಸಿ',
        seeHowYouRank: 'ನೀವು ಇತರರೊಂದಿಗೆ ಹೇಗೆ ಕ್ರಮದಲ್ಲಿದ್ದೀರಿ ನೋಡಿ ಮತ್ತು ನಿಮ್ಮನ್ನು ಸವಾಲು ಮಾಡಿ 💡',
        userNotLoggedIn: 'ಬಳಕೆದಾರರು ಲಾಗಿನ್ ಆಗಿಲ್ಲ',
        noScoresFound: '❌ ಈ ದಿನಾಂಕಕ್ಕೆ ಯಾವುದೇ ಅಂಕೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
        noQuizzesFound: '❌ ಈ ದಿನಾಂಕದಲ್ಲಿ ನೀವು ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಿಲ್ಲ.',
        // create sanstha quiz
        organizationQuizUrl: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ URL',
        active: 'ಸಕ್ರಿಯ',
        quickAccess: 'ವೇಗದ ಪ್ರವೇಶ',
        scanQrCode: 'ಕ್ವಿಜ್ ಪೋರ್ಟಲ್‌ಗೆ ಪ್ರವೇಶಿಸಲು QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
        createNewQuiz: 'ಹೊಸ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        quizTitle: 'ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ',
        enterQuizTitle: 'ಕ್ವಿಜ್ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ',
        organization: 'ಸಂಸ್ಥೆ',
        description: 'ವಿವರಣೆ',
        enterDescription: 'ರಸಪ್ರಶ್ನೆ ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ',
        quizDurationType: 'ರಸಪ್ರಶ್ನೆ ಅವಧಿಯ ಪ್ರಕಾರ',
        singleDay: 'ಒಂದು ದಿನ',
        multiDay: 'ಬಹು ದಿನ',
        topic: 'ವಿಷಯ',
        enterTopic: 'ವಿಷಯವನ್ನು ನಮೂದಿಸಿ',
        subtopic: 'ಉಪವಿಷಯ',
        enterSubtopic: 'ಉಪವಿಷಯವನ್ನು ನಮೂದಿಸಿ',
        startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        startTime: 'ಪ್ರಾರಂಭ ಸಮಯ',
        endDate: 'ಕೊನೆಯ ದಿನಾಂಕ',
        endTime: 'ಕೊನೆಯ ಸಮಯ',
        releaseResult: 'ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ',
        instant: 'ತಕ್ಷಣ',
        scheduled: 'ವೇಳಾಪಟ್ಟಿ ಮಾಡಲಾಗಿದೆ',
        resultReleaseDate: 'ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ದಿನಾಂಕ',
        resultReleaseTime: 'ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ಸಮಯ',
        createQuizBtn: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        // Validation / Toasts
        validationQuizTitle: 'ದಯವಿಟ್ಟು ರಸಪ್ರಶ್ನೆ ಶೀರ್ಷಿಕೆ ನಮೂದಿಸಿ',
        validationTopic: 'ದಯವಿಟ್ಟು ವಿಷಯವನ್ನು ನಮೂದಿಸಿ',
        validationDuration: 'ದಯವಿಟ್ಟು ರಸಪ್ರಶ್ನೆ ಅವಧಿಯ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        validationStartDate: 'ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
        validationStartTime: 'ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
        validationEndDate: 'ದಯವಿಟ್ಟು ಕೊನೆಯ ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
        validationEndTime: 'ದಯವಿಟ್ಟು ಕೊನೆಯ ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
        validationReleaseResult: 'ದಯವಿಟ್ಟು ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ಆಯ್ಕೆಮಾಡಿ',
        validationResultReleaseDate: 'ದಯವಿಟ್ಟು ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
        validationResultReleaseTime: 'ದಯವಿಟ್ಟು ಫಲಿತಾಂಶ ಬಿಡುಗಡೆ ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
        quizCreated: 'ರಸಪ್ರಶ್ನೆ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ',
        quizCreateFailed: 'ರಸಪ್ರಶ್ನೆ ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ',
        // sanstha quiz educator
        header: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆಗಳು',
        subHeader: 'ನಮ್ಮ ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ ಗಳ ಸಂಗ್ರಹವನ್ನು ಪರಿಶೀಲಿಸಿ',
        createSansthaQuiz: '+ ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ ರಚಿಸಿ',
        copyLink: 'ಲಿಂಕ್ ನಕಲಿಸಿ',
        edit: 'ಸಂಪಾದಿಸಿ',
        noDescription: 'ಯಾವುದೇ ವಿವರಣೆ ಲಭ್ಯವಿಲ್ಲ',
        totalQuestions: 'ಪ್ರಶ್ನೆಗಳು',
        totalTime: 'ನಿಮಿಷಗಳು',
        quizLinkCopied: 'ರಸಪ್ರಶ್ನೆ ಲಿಂಕ್ ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ!',
        // sanstha quiz participant
        sansthaQuizLists: 'ಸಂಸ್ಥೆ ಕ್ವಿಜ್ ಪಟ್ಟಿಗಳು',
        header: 'ಸಂಸ್ಥೆಯ ರಸಪ್ರಶ್ನೆ ಗಳು',
        subHeader: 'ನಮ್ಮ ಸಂಸ್ಥಾಗತ ರಸಪ್ರಶ್ನೆ ಸಂಗ್ರಹವನ್ನು ಬ್ರೌಸ್ ಮಾಡಿ',
        sanstha: 'ಸಂಸ್ಥೆ',
        noDescription: 'ಯಾವುದೇ ವಿವರಣೆ ಲಭ್ಯವಿಲ್ಲ',
        totalQuestions: 'ಪ್ರಶ್ನೆಗಳು',
        totalTime: 'ನಿಮಿಷಗಳು',
        quizNotFinished: 'ಕ್ವಿಜ್ ಇನ್ನೂ ಮುಗಿದಿಲ್ಲ',
        leaderboardNotAvailable: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ಇನ್ನೂ ಲಭ್ಯವಿಲ್ಲ!',
        quizStillRunning: 'ಈ ಕ್ವಿಜ್ ಇನ್ನೂ ನಡೆಯುತ್ತಿದೆ. ದಯವಿಟ್ಟು ಅದು ಮುಗಿದ ನಂತರ ಬನ್ನಿ.',
        endsOn: 'ಮುಕ್ತಾಯವಾಗುವುದು:',
        stayTuned: 'ಕಾಯಿರಿ! ಕ್ವಿಜ್ ಮುಗಿದ ತಕ್ಷಣ ಫಲಿತಾಂಶಗಳು ಲಭ್ಯವಾಗುತ್ತವೆ.',
        gotIt: 'ಅರ್ಥವಾಯಿತು',
        // daily quiz participant
        dailyQuizLists: 'ದೈನಂದಿನ ಕ್ವಿಜ್ ಪಟ್ಟಿಗಳು',
        dailyQuizChallenge: 'ದೈನಂದಿನ ಕ್ವಿಜ್ ಸವಾಲು',
        dailyQuizSubHeader: 'ನಮ್ಮ ದೈನಂದಿನ ಆಯ್ದ ರಸಪ್ರಶ್ನೆಗಳ ಮೂಲಕ ನಿಮ್ಮ ಜ್ಞಾನವನ್ನು ಪರೀಕ್ಷಿಸಿ',
        noDataAvailable: 'ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ',
        allDifficulties: 'ಎಲ್ಲಾ ಕಠಿಣತೆಗಳು',
        questions: 'ಪ್ರಶ್ನೆಗಳು',
        easy: 'ಸುಲಭ',
        medium: 'ಮಧ್ಯಮ',
        hard: 'ಕಠಿಣ',
        allCategories: 'ಎಲ್ಲಾ ವರ್ಗಗಳು',
        beginChallenge: 'ಸವಾಲು ಪ್ರಾರಂಭಿಸಿ',
        nextQuestion: 'ಮುಂದಿನ ಪ್ರಶ್ನೆ',
        noMoreQuestions: 'ಇನ್ನು ಪ್ರಶ್ನೆಗಳಿಲ್ಲ',
        startTime: 'ಪ್ರಾರಂಭ ಸಮಯ',
        startQuiz: 'ರಸಪ್ರಶ್ನೆ ಪ್ರಾರಂಭಿಸಿ',
        prev: 'ಹಿಂದಿನದು',
        next: 'ಮುಂದಿನದು',
        noQuizzesAvailable: 'ಈ ಕ್ಷಣದಲ್ಲಿ ಯಾವುದೇ ರಸಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.',
        dailyKnowledgeChallenge: "ದೈನಂದಿನ ಕ್ವಿಜ್",
        generalKnowledgeQuiz: 'ಸಾಮಾನ್ಯ ಜ್ಞಾನ ರಸಪ್ರಶ್ನೆ',
        noDetailAvailable: 'ಯಾವುದೇ ವಿವರಣೆ ಲಭ್ಯವಿಲ್ಲ!',
        startQuizNow: 'ಈಗ ರಸಪ್ರಶ್ನೆ ಪ್ರಾರಂಭಿಸಿ',
        quizEnded: 'ಈ ರಸಪ್ರಶ್ನೆ ಮುಗಿದಿದೆ.',
        exploreMoreQuizzes: 'ದಯವಿಟ್ಟು ಇನ್ನಷ್ಟು ರಸಪ್ರಶ್ನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ ಮತ್ತು ಭಾಗವಹಿಸಿ!',
        viewMoreQuizzes: 'ಇನ್ನಷ್ಟು ರಸಪ್ರಶ್ನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        noQuestionToday: 'ಇಂದು ಯಾವುದೇ ಪ್ರಶ್ನೆ ಲಭ್ಯವಿಲ್ಲ!',
        refresh: 'ರಿಫ್ರೆಶ್',
        alreadyCompletedToday: 'ನೀವು ಈಗಾಗಲೇ ಇಂದಿನ ರಸಪ್ರಶ್ನೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಿ',
        viewRules: 'ನಿಯಮಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        quizDetails: 'ರಸಪ್ರಶ್ನೆ ವಿವರಗಳು',
        topicLabel: 'ವಿಷಯ',
        generalKnowledge: 'ಸಾಮಾನ್ಯ ಜ್ಞಾನ',
        difficultyLabel: 'ಕಷ್ಟತೆ',
        availableUntil: 'ಇದರವರೆಗೆ ಲಭ್ಯವಿದೆ',
        notSet: 'ಸೆಟ್ ಮಾಡಿಲ್ಲ',
        rulesAndRegulations: 'ನಿಯಮಗಳು ಮತ್ತು ವಿಧಿನಿಯಮಗಳು',
        rule1: 'ಉತ್ತರಿಸುವ ಮೊದಲು ಪ್ರತಿ ಪ್ರಶ್ನೆಯನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಓದಿ.',
        rule2: 'ಪ್ರತಿ ಪ್ರಶ್ನೆಗೂ ಸಾಧ್ಯವಿರುವ ಉತ್ತಮ ಉತ್ತರವನ್ನು ಆರಿಸಿ.',
        rule3: 'ರಸಪ್ರಶ್ನೆ ಮುಗಿಯುವ ಮೊದಲು ನಿಮ್ಮ ಉತ್ತರಗಳನ್ನು ಸಬ್ಮಿಟ್ ಮಾಡಿ.',
        rule4: 'ಸರಿಯಾದ ಉತ್ತರಗಳಿಗೆ ಮಾತ್ರ ಅಂಕಗಳನ್ನು ನೀಡಲಾಗುತ್ತದೆ.',
        rule5: 'ಸತತ ಸರಿಯಾದ ಉತ್ತರಗಳು ನಿಮ್ಮ ಸ್ಟ್ರೀಕ್ ಬೋನಸ್ ಹೆಚ್ಚಿಸುತ್ತವೆ.',
        rule6: 'ಮೋಸ ಅಥವಾ ಬಾಹ್ಯ ಸಹಾಯವನ್ನು ಬಳಸುವುದರಿಂದ ನಿಮ್ಮನ್ನು ಅನರ್ಹಗೊಳಿಸಬಹುದು.',
        completeProfile: 'ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ',
        completeProfileToContinue: 'ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ.',
        goToProfile: 'ಪ್ರೊಫೈಲ್ ಗೆ ಹೋಗಿ',
        firstQuestionOnDate: 'ಮೊದಲ ಪ್ರಶ್ನೆ {date} ರಂದು {time} ಗೆ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
        firstQuestionTomorrow: 'ಮೊದಲ ಪ್ರಶ್ನೆ ನಾಳೆ {time} ಗೆ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
        firstQuestionToday: 'ಮೊದಲ ಪ್ರಶ್ನೆ ಇಂದು {time} ಗೆ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
        quizEndedMessage: 'ಈ ರಸಪ್ರಶ್ನೆ ಮುಗಿದಿದೆ.',
        noQuestionTodayMessage: 'ಇಂದು ಯಾವುದೇ ಪ್ರಶ್ನೆ ಲಭ್ಯವಿಲ್ಲ.',
        quizEndingToday: 'ಇಂದಿನ ರಸಪ್ರಶ್ನೆ ಮುಗಿಯುತ್ತಿದೆ.',
        nextQuestionOnDate: 'ಮುಂದಿನ ಪ್ರಶ್ನೆ {date} ರಂದು {time} ಗೆ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
        nextQuestionTomorrow: 'ಮುಂದಿನ ಪ್ರಶ್ನೆ ನಾಳೆ {time} ಗೆ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
        nextQuestionToday: 'ಮುಂದಿನ ಪ್ರಶ್ನೆ ಇಂದು {time} ಗೆ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ.',
        morning: 'ಬೆಳಗ್ಗೆ',
        afternoon: 'ಮಧ್ಯಾಹ್ನ',
        evening: 'ಸಂಜೆ',
        night: 'ರಾತ್ರಿ',
        startsIn: 'ಪ್ರಾರಂಭವಾಗಲಿದೆ',
        days: 'ದಿನಗಳು',
        hours: 'ಗಂಟೆಗಳು',
        minutes: 'ನಿಮಿಷಗಳು',
        seconds: 'ಸೆಕೆಂಡುಗಳು',
        importantNotice: 'ಮಹತ್ವದ ಸೂಚನೆ',
        readBeforeStarting: 'ಪ್ರಾರಂಭಿಸುವ ಮೊದಲು ಓದಿ',
        ensureStableConnection: 'ದಯವಿಟ್ಟು ಸ್ಥಿರ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ. ಒಮ್ಮೆ ಪ್ರಾರಂಭವಾದ ನಂತರ, ಟೈಮರ್ ಅನ್ನು ನಿಲ್ಲಿಸಲಾಗುವುದಿಲ್ಲ.',
        completeAllQuestions: 'ಸಮಯ ಮುಗಿಯುವ ಮೊದಲು ಎಲ್ಲಾ ಪ್ರಶ್ನೆಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ',
        noExternalResources: 'ಪರೀಕ್ಷೆಯ ಸಮಯದಲ್ಲಿ ಬಾಹ್ಯ ಸಂಪನ್ಮೂಲಗಳನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ',
        submitBeforeExpiry: 'ಟೈಮರ್ ಮುಗಿಯುವ ಮೊದಲು ಉತ್ತರಗಳನ್ನು ಸಬ್ಮಿಟ್ ಮಾಡಿ',
        details: 'ವಿವರಗಳು',
        rules: 'ನಿಯಮಗಳು',
        results: 'ಫಲಿತಾಂಶಗಳು',
        quizInformation: "ಕ್ವಿಜ್ ಮಾಹಿತಿ",
        subjectCategory: 'ವಿಷಯ ವರ್ಗ',
        quizType: "ಕ್ವಿಜ್ ಪ್ರಕಾರ",
        quizRules: "ಕ್ವಿಜ್ ನಿಯಮಗಳು",
        quizTips: "ಕ್ವಿಜ್ ಸಲಹೆಗಳು",
        difficultyLevel: 'ಕಷ್ಟತೆಯ ಮಟ್ಟ',
        totalQuestions: 'ಒಟ್ಟು ಪ್ರಶ್ನೆಗಳು',
        availableDate: 'ಕ್ವಿಜ್ ಮುಕ್ತಾಯಗೊಳ್ಳುವ ದಿನಾಂಕ',
        time: 'ಸಮಯ',
        dq_start_time: "ದೈನಂದಿನ ಕ್ವಿಜ್ ಪ್ರಾರಂಭ ಸಮಯ",
        readAllOptions: 'ಎಲ್ಲಾ ಆಯ್ಕೆಗಳನ್ನು ಒಳ್ಳೆಯಾಗಿ ಓದಿ',
        focusTimeManagement: 'ಸಮಯ ನಿರ್ವಹಣೆಯ ಮೇಲೆ ಒಂದಾಗಿ',
        solveEasyFirst: 'ಮೊದಲು ಸುಲಭ ಪ್ರಶ್ನೆಗಳನ್ನು ಬಿಡಿಸಿ',
        resultsComingSoon: 'ಫಲಿತಾಂಶಗಳು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿವೆ',
        resultsWillBeAvailable: 'ಪರೀಕ್ಷೆ ಮುಗಿದ ನಂತರ ಫಲಿತಾಂಶಗಳು ಲಭ್ಯವಾಗುತ್ತವೆ.',
        mon: 'ಸೋಮ',
        tue: 'ಮಂಗಳ',
        wed: 'ಬುಧ',
        thu: 'ಗುರು',
        fri: 'ಶುಕ್ರ',
        sat: 'ಶನಿ',
        sun: 'ಭಾನು',
        jan: 'ಜನ',
        feb: 'ಫೆಬ್',
        mar: 'ಮಾರ್ಚ್',
        apr: 'ಏಪ್ರಿಲ್',
        may: 'ಮೇ',
        jun: 'ಜೂನ್',
        jul: 'ಜುಲೈ',
        aug: 'ಆಗ',
        sep: 'ಸೆಪ್',
        oct: 'ಅಕ್ಟೋ',
        nov: 'ನವೆಂ',
        dec: 'ಡಿಸೆಂ',
        adminTitle: 'ಜೈನ್ ಡೈರೆಕ್ಟ್ ಕ್ವಿಜ್ - ಆಡ್ಮಿನ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        totalSanstha: 'ಒಟ್ಟು ಸಂಸ್ಥೆಗಳು',
        totalQuizzes: 'ಒಟ್ಟು ತಯಾರಿಸಿದ ಕ್ವಿಜ್‌ಗಳು',
        activeQuizzes: 'ಸಕ್ರಿಯ ಕ್ವಿಜ್‌ಗಳು',
        totalParticipants: 'ಒಟ್ಟು ಭಾಗವಹಿಸುವವರು',
        userEngagement: 'ಬಳಕೆದಾರರ ತೊಡಗಿಸಿಕೊಳ್ಳುವಿಕೆ ಬೆಳವಣಿಗೆ',
        engagementChannels: 'ಎಂಗೇಜ್‌ಮೆಂಟ್ ಚಾನಲ್ ಅವಲೋಕನ',
        whatsappMessages: 'ಕಳುಹಿಸಿದ ವಾಟ್ಸಾಪ್ ಸಂದೇಶಗಳು',
        emailMessages: 'ಕಳುಹಿಸಿದ ಇಮೇಲ್‌ಗಳು',
        avgScore: 'ಸರಾಸರಿ ಅಂಕ',
        dailyActiveUsers: 'ದಿನನಿತ್ಯ ಸಕ್ರಿಯ ಕ್ವಿಜ್‌ ಪಡೆಯುವವರು',
        topQuizzes: 'ಪ್ರಯತ್ನಗಳ ಆಧಾರದ ಮೇರೆಗೆ ಟಾಪ್ 5 ಕ್ವಿಜ್‌ಗಳು',
        platformUsageDistribution: 'ಪ್ಲಾಟ್ಫಾರ್ಮ್ ಬಳಕೆ ವಿತರಣೆ',
        activeUsers: 'ಸಕ್ರಿಯ ಬಳಕೆದಾರರು',
        mostPopularQuizzes: 'ಇತ್ತೀಚಿನ ಅತ್ಯಂತ ಜನಪ್ರಿಯ ಪ್ರಶ್ನೋತ್ತರ',
        totalParticipants: 'ಒಟ್ಟು ಭಾಗವಹಿಸಿದವರು',
        newParticipants: 'ಹೊಸ ಭಾಗವಹಿಸಿದವರು',
        totalEducators: 'ಶಿಕ್ಷಕರು',
        attempts: 'ಪ್ರಯತ್ನಗಳು',
        report: 'ವರದಿ',
        viewDetails: 'ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        noDescription: 'ವಿವರಣೆ ಇಲ್ಲ',
        allSansthas: 'ಎಲ್ಲಾ ಸಂಸ್ಥೆಗಳು',
        searchPlaceholder: 'ಹುಡುಕಿ...',
        noLocation: 'ಸ್ಥಳವಿಲ್ಲ',
        profile: 'ಪ್ರೊಫೈಲ್',
        messages: 'ಸಂದೇಶಗಳು',
        logout: 'ಲಾಗ್ ಔಟ್',
        shortAppName: 'ಜೆಡಿ ಕ್ವಿಜ್',
        fullAppName: 'ಜೈನ್ಡೈರೆಕ್ಟ್ ಕ್ವಿಜ್',
        // particular sanstha quiz
        title: 'ಪ್ರಶ್ನೋತ್ತರ',
        organization: 'ಸಂಸ್ಥೆಯ ಹೆಸರು',
        description: 'ವಿವರಣೆ',
        statistics: 'ಪ್ರಶ್ನೋತ್ತರ ಅಂಕಿಅಂಶಗಳು',
        total_questions: 'ಒಟ್ಟು ಪ್ರಶ್ನೆಗಳು',
        total_points: 'ಒಟ್ಟು ಅಂಕಗಳು',
        total_time: 'ಒಟ್ಟು ಸಮಯ',
        duration: 'ಅವಧಿ',
        dates: 'ದಿನಾಂಕಗಳು',
        start_date: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        end_date: 'ಕೊನೆ ದಿನಾಂಕ',
        time: 'ಸಮಯ',
        start: 'ಪ್ರಾರಂಭ',
        end: 'ಅಂತ್ಯ',
        additional_info: 'ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿ',
        participants_limit: 'ಭಾಗವಹಿಸುವವರ ಮಿತಿ',
        unlimited: 'ಅಪರಿಮಿತ',
        difficulty: 'ಕಷ್ಟದ ಮಟ್ಟ',
        intermediate: 'ಮಧ್ಯಮ',
        quiz_not_started: 'ಪ್ರಶ್ನೋತ್ತರ ಇನ್ನೂ ಪ್ರಾರಂಭವಾಗಿಲ್ಲ',
        quiz_live: 'ಪ್ರಶ್ನೋತ್ತರ ಪ್ರಾರಂಭಿಸಿ',
        quiz_ended: 'ಪ್ರಶ್ನೋತ್ತರ ಮುಗಿದಿದೆ',
        quizNotAvailable: 'ಪ್ರಶ್ನಾವಳಿ ಲಭ್ಯವಿಲ್ಲ',
        noQuestionsInQuiz: 'ಈ ಪ್ರಶ್ನಾವಳಿಯಲ್ಲಿ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಇಲ್ಲ',
        leaderboardPublishMode: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ಪ್ರಕಟಿಸುವ ವಿಧಾನ',
        selectOption: 'ಒಂದು ಆಯ್ಕೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        autoPublish: 'ಸ್ವಯಂಚಾಲಿತ ಪ್ರಕಟಣೆ',
        manualPublish: 'ಮ್ಯಾನುಯಲ್ ಪ್ರಕಟಣೆ',
        autoPublishHint: 'ಕ್ವಿಜ್ ಮುಗಿದ ನಂತರ ಲೀಡರ್‌ಬೋರ್ಡ್ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಪ್ರಕಟವಾಗುತ್ತದೆ.',
        manualPublishHint: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ಅನ್ನು ಆಡ್ಮಿನ್ ಕೈಯಾರೆ ಪ್ರಕಟಿಸುತ್ತಾರೆ.',
        manualPublishBadge: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ಕೈಯಾರೆ ಪ್ರಕಟಿಸಬೇಕು',

        enterPointsForRank: 'ಶ್ರೇಣಿ {rank} ಗಾಗಿ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ನಮೂದಿಸಿ',
        scoringManagement: 'ಕ್ವಿಜ್ ಶ್ರೇಣಿ ಮತ್ತು ಸ್ಕೋರಿಂಗ್ ನಿರ್ವಹಣೆ',
        scoringManagementSubtitle: 'ಶ್ರೇಣಿಗಳು, ಉತ್ತರಗಳು ಮತ್ತು ಸ್ಕೋರಿಂಗ್ ಪ್ಯಾರಾಮೀಟರ್‌ಗಳನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಿ',
        rankBonusPoints: 'ಶ್ರೇಣಿ ಬೋನಸ್ ಪಾಯಿಂಟ್‌ಗಳು',
        rankBonusPointsDescription: 'ಕ್ವಿಜ್‌ನಲ್ಲಿ ಅವರ ಅಂತಿಮ ಶ್ರೇಣಿಯ ಆಧಾರದ ಮೇಲೆ ಬಳಕೆದಾರರಿಗೆ ನೀಡಲಾಗುವ ಹೆಚ್ಚುವರಿ ಬೋನಸ್ ಪಾಯಿಂಟ್‌ಗಳು. ಹೆಚ್ಚಿನ ಶ್ರೇಣಿಗೆ ಹೆಚ್ಚಿನ ಬೋನಸ್ ಪಾಯಿಂಟ್‌ಗಳು ಸಿಗುತ್ತವೆ.',
        addMoreRank: '+ ಹೆಚ್ಚಿನ ಶ್ರೇಣಿ ಸೇರಿಸಿ',
        bonusPoints: 'ಬೋನಸ್ ಪಾಯಿಂಟ್‌ಗಳು (ಹೆಚ್ಚುವರಿ ಬಹುಮಾನಗಳು)',
        bonusPointsDescription: 'ಕ್ವಿಜ್ ಸಮಯದಲ್ಲಿ ವಿಶೇಷ ಷರತ್ತುಗಳ ಆಧಾರದ ಮೇಲೆ ಬಳಕೆದಾರರಿಗೆ ಹೆಚ್ಚುವರಿ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ನೀಡಲು ಬೋನಸ್ ನಿಯಮಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ.',
        fastestAnswer: 'ಅತ್ಯಂತ ವೇಗದ ಉತ್ತರ (5 ಸೆಕೆಂಡುಗಳ ಒಳಗೆ)',
        allAnswersCorrect: 'ಎಲ್ಲಾ ಉತ್ತರಗಳು ಸರಿಯಾಗಿವೆ',
        consecutiveParticipation: 'ತದನಂತರದ ಕ್ವಿಜ್ ಭಾಗವಹಿಸುವಿಕೆ (3+ ದಿನಗಳು)',
        firstAttemptDay: 'ದಿನದ ಮೊದಲ ಕ್ವಿಜ್ ಪ್ರಯತ್ನ',
        comingSoon: '(ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ)',
        negativeMarking: 'ನಕಾರಾತ್ಮಕ ಅಂಕನ (ದಂಡ ಅಂಕಗಳು)',
        negativeMarkingDescription: 'ಪ್ರತಿ ತಪ್ಪು ಉತ್ತರಕ್ಕೆ ಬಳಕೆದಾರರ ಸ್ಕೋರ್‌ನಿಂದ ಅಂಕಗಳನ್ನು ಕಡಿತಗೊಳಿಸಿ.',
        wrongAnswer: 'ತಪ್ಪು ಉತ್ತರ',
        saveConfiguration: 'ಕಾನ್ಫಿಗರೇಶನ್ ಉಳಿಸಿ',
        confirmNotification: 'ಸೂಚನೆಯನ್ನು ದೃಢೀಕರಿಸಿ',
        whatsappNotifyQuestion: 'ಈ ಕ್ವಿಜ್ ಬಗ್ಗೆ ಬಳಕೆದಾರರನ್ನು ತಿಳಿಸಲು ನೀವು WhatsApp ಸಂದೇಶ ಕಳುಹಿಸಲು ಬಯಸುವಿರಾ?',
        no: 'ಇಲ್ಲ',
        yes: 'ಹೌದು',
        // Leaderboard translations
        quizTitle: 'ಕ್ವಿಜ್ ಶೀರ್ಷಿಕೆ',
        totalParticipants: 'ಒಟ್ಟು ಭಾಗವಹಿಸುವವರು',
        averageScore: 'ಸರಾಸರಿ ಸ್ಕೋರ್',
        yourRank: 'ನಿಮ್ಮ ಶ್ರೇಣಿ',
        date: 'ದಿನಾಂಕ',
        dateRange: 'ದಿನಾಂಕ ಶ್ರೇಣಿ',
        dailyWinner: 'ದೈನಂದಿನ ವಿಜೇತ',
        weeklyWinner: 'ವಾರಕ್ಕೆ ವಿಜೇತ',
        monthlyWinner: 'ತಿಂಗಳಿಗೆ ವಿಜೇತ',
        finalWinner: 'ಅಂತಿಮ ವಿಜೇತ',
        fastFinger: 'ವೇಗದ ಬೆರಳು',
        top5: 'ಮೇಲಿನ 5',
        top10: 'ಮೇಲಿನ 10',
        luckyWinner: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತ',
        queAnsHistory: 'ಪ್ರಶ್ನೆ ಮತ್ತು ಉತ್ತರ ಇತಿಹಾಸ',
        ourSponsors: 'ನಮ್ಮ ಪ್ರಾಯೋಜಕರು',
        sponsoredBy: 'ಪ್ರಾಯೋಜಿಸಿದವರು',
        quizQuestions: 'ಕ್ವಿಜ್ ಪ್ರಶ್ನೆಗಳು',
        dailyQuiz: 'ದೈನಂದಿನ ಕ್ವಿಜ್',
        correctAnswer: 'ಸರಿಯಾದ ಉತ್ತರ',
        participantName: 'ಭಾಗವಹಿಸುವವರ ಹೆಸರು',
        location: 'ಸ್ಥಳ',
        totalScore: 'ಒಟ್ಟು ಸ್ಕೋರ್',
        totalTime: 'ಒಟ್ಟು ಸಮಯ',
        mobile: 'ಮೊಬೈಲ್',
        resultsNotPublished: 'ಫಲಿತಾಂಶಗಳು ಪ್ರಕಟಿಸಲಾಗಿಲ್ಲ',
        leaderboardNotAvailable: 'ಲೀಡರ್‌ಬೋರ್ಡ್ ಲಭ್ಯವಿಲ್ಲ',
        backToDashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂತಿರುಗಿ',
        noParticipantsFound: 'ಯಾವುದೇ ಭಾಗವಹಿಸುವವರು ಕಂಡುಬಂದಿಲ್ಲ',
        firstRank: '1st ಶ್ರೇಣಿ',
        secondRank: '2nd ಶ್ರೇಣಿ',
        thirdRank: '3rd ಶ್ರೇಣಿ',
        searchByParticipantName: 'ಭಾಗವಹಿಸುವವರ ಹೆಸರಿನಿಂದ ಹುಡುಕಿ',
        fastestFingerFirstResult: 'ವೇಗದ ಬೆರಳು ಮೊದಲ ಫಲಿತಾಂಶ',
        top10Result: 'ಮೇಲಿನ 10 ಫಲಿತಾಂಶ',
        top5Result: 'ಮೇಲಿನ 5 ಫಲಿತಾಂಶ',
        luckyWinnerResult: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತ ಫಲಿತಾಂಶ',
        luckyWinnersNotAvailable: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತರು ಲಭ್ಯವಿಲ್ಲ',
        top5WinnersNotAvailable: 'ಮೇಲಿನ 5 ವಿಜೇತರು ಲಭ್ಯವಿಲ್ಲ',
        top10WinnersNotAvailable: 'ಮೇಲಿನ 10 ವಿಜೇತರು ಲಭ್ಯವಿಲ್ಲ',
        resultsWillBeAnnounced: 'ಫಲಿತಾಂಶಗಳು ಶೀಘ್ರವಾಗಿ ಪ್ರಕಟಿಸಲಾಗುತ್ತವೆ. ದಯವಿಟ್ಟು ನಂತರ ಪರಿಶೀಲಿಸಿ.',
        resultsNotPublishedYet: 'ಈ ಅವಧಿಗೆ ಫಲಿತಾಂಶಗಳು ಇನ್ನೂ ಪ್ರಕಟಿಸಲಾಗಿಲ್ಲ.',
        // EduLeadership translations
        downloadExcel: 'ಎಕ್ಸೆಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
        downloadPDF: 'ಪಿಡಿಎಫ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
        viewQuizQuestions: 'ಕ್ವಿಜ್ ಪ್ರಶ್ನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        publishResults: 'ಫಲಿತಾಂಶಗಳನ್ನು ಪ್ರಕಟಿಸಿ',
        quizQuestions: 'ಕ್ವಿಜ್ ಪ್ರಶ್ನೆಗಳು',
        dailyQuiz: 'ದೈನಂದಿನ ಕ್ವಿಜ್',
        correctAnswer: 'ಸರಿಯಾದ ಉತ್ತರ',
        firstRank: '1st ಶ್ರೇಣಿ',
        secondRank: '2nd ಶ್ರೇಣಿ',
        thirdRank: '3rd ಶ್ರೇಣಿ',
        fastestFingerFirstResult: 'ವೇಗದ ಬೆರಳು ಮೊದಲ ಫಲಿತಾಂಶ',
        top10Result: 'ಮೇಲಿನ 10 ಫಲಿತಾಂಶ',
        top5Result: 'ಮೇಲಿನ 5 ಫಲಿತಾಂಶ',
        luckyWinnerResult: 'ಭಾಗ್ಯಶಾಲಿ ವಿಜೇತ ಫಲಿತಾಂಶ',
        searchByParticipantName: 'ಭಾಗವಹಿಸುವವರ ಹೆಸರಿನಿಂದ ಹುಡುಕಿ',
        participantName: 'ಭಾಗವಹಿಸುವವರ ಹೆಸರು',
        location: 'ಸ್ಥಳ',
        totalScore: 'ಒಟ್ಟು ಸ್ಕೋರ್',
        totalTime: 'ಒಟ್ಟು ಸಮಯ',
        mobile: 'ಮೊಬೈಲ್',
        trueFalse: "ಸರಿ / ತಪ್ಪು",
        showingEntries: '{first} ರಿಂದ {last} ವರೆಗೆ {totalRecords} ಪ್ರವೇಶಗಳು ತೋರಿಸುತ್ತಿದೆ',
        weekStillRunning: 'ಈ ವಾರ ಇನ್ನೂ ಚಾಲ್ತಿಯಲ್ಲಿದೆ, ಆದ್ದರಿಂದ ಪ್ರಕಟಣೆ ನಿಷ್ಕ್ರಿಯವಾಗಿದೆ.',
        weekCanPublish: 'ಈ ವಾರದ ಫಲಿತಾಂಶಗಳನ್ನು ಪ್ರಕಟಿಸಬಹುದು.',
        monthStillRunning: 'ಈ ತಿಂಗಳು ಇನ್ನೂ ಚಾಲ್ತಿಯಲ್ಲಿದೆ, ಆದ್ದರಿಂದ ಪ್ರಕಟಣೆ ನಿಷ್ಕ್ರಿಯವಾಗಿದೆ.',
        monthCanPublish: 'ಈ ತಿಂಗಳ ಫಲಿತಾಂಶಗಳನ್ನು ಪ್ರಕಟಿಸಬಹುದು.',
        rulesAndRegulation: "ನಿಯಮಗಳು ಮತ್ತು ನಿಯಮಾವಳಿ",
        addNewRule: 'ಹೊಸ ನಿಯಮವನ್ನು ಸೇರಿಸಿ',
        minimumRulesRequired: 'ಕನಿಷ್ಠ 4 ನಿಯಮಗಳು ಅಗತ್ಯವಿದೆ',
        todaysParticipants: 'ಇಂದಿನ ಭಾಗವಹಿಸಿದವರು',
        weeklyParticipants: 'ವಾರದ ಭಾಗವಹಿಸಿದವರು',
        monthlyParticipants: 'ಮಾಸಿಕ ಭಾಗವಹಿಸಿದವರು',
        totalParticipants: 'ಒಟ್ಟು ಭಾಗವಹಿಸಿದವರು',
    },
    gu: {
        questionBank: 'પ્રશ્ન બેંક',
        searchQuestions: 'પ્રશ્નો શોધો...',
        confirmDelete: 'કાઢી નાખવાની પુષ્ટિ',
        deletePrompt: 'શું તમે ખરેખર આ પ્રશ્ન કાઢી નાખવા માંગો છો?',
        cancel: 'રદ કરો',
        delete: 'કાઢી નાખો',
        deleted: 'કાઢી નાખ્યું',
        questionDeleted: 'પ્રશ્ન સફળતાપૂર્વક કાઢી નાખ્યો',
        error: 'ભૂલ',
        failedToDelete: 'પ્રશ્ન કાઢી નાખવામાં અસફળ',
        topic: 'વિષય',
        subTopic: 'ઉપ વિષય',
        actions: 'ક્રિયાઓ',
        question: 'પ્રશ્ન',
        createNewQuestion: 'નવો પ્રશ્ન બનાવો',
        editQuestion: "પ્રશ્ન સંપાદિત કરો",
        questionType: 'પ્રશ્નનો પ્રકાર',
        multipleChoice: 'બહુવિકલ્પી',
        questionText: 'પ્રશ્ન ટેક્સ્ટ',
        enterQuestion: 'તમારો પ્રશ્ન દાખલ કરો...',
        enterTopic: 'વિષય દાખલ કરો...',
        enterSubTopic: 'ઉપ વિષય દાખલ કરો...',
        answerOptions: 'જવાબ વિકલ્પો',
        addOption: '+ વિકલ્પ ઉમેરો',
        selectCorrectAnswer: 'સાચો જવાબ પસંદ કરો',
        option: 'વિકલ્પ',
        submit: 'સબમિટ કરો',
        pleaseFill: 'કૃપા કરીને બધા જરૂરી ક્ષેત્રો ભરો.',
        failedToAdd: 'પ્રશ્ન ઉમેરવામાં અસફળ.',
        success: 'સફળતા',
        questionAdded: 'પ્રશ્ન સફળતાપૂર્વક ઉમેરાયો!',
        somethingWrong: 'કશુંક ખોટું થયું.',
        createQuizBasic: 'ક્વિઝ બનાવો',
        createDailyQuiz: 'દૈનિક ક્વિઝ બનાવો',
        updateDailyQuiz: 'દૈનિક ક્વિઝ અપડેટ કરો',
        updateQuestions: 'પ્રશ્નો અપડેટ કરો',
        editQuiz: 'ક્વિઝ સંપાદિત કરો',
        openQuiz: 'ક્વિઝ ખોલો',
        quizTitle: 'ક્વિઝ શીર્ષક',
        quizTitlePlaceholder: 'ક્વિઝ શીર્ષક દાખલ કરો',
        quizTitleRequired: 'ક્વિઝ શીર્ષક જરૂરી છે.',
        quizDescription: 'ક્વિઝ વર્ણન',
        quizDescriptionRequired: 'ક્વિઝ વર્ણન જરૂરી છે.',
        topicPlaceholder: 'વિષય દાખલ કરો',
        subTopicPlaceholder: 'ઉપ વિષય દાખલ કરો',
        startDate: 'શરૂઆતની તારીખ',
        endDate: 'અંતિમ તારીખ',
        startTime: 'શરૂઆતનો સમય',
        endTime: 'અંતિમ સમય',
        quizVisibility: 'ક્વિઝ દૃશ્યતા',
        selectVisibility: 'દૃશ્યતા પસંદ કરો',
        public: 'જાહેર',
        private: 'ખાનગી',
        save: 'સાચવો',
        editQuestions: 'પ્રશ્નો સંપાદિત કરો',
        addQuestions: 'પ્રશ્નો ઉમેરો',
        quizUpdated: 'ક્વિઝ અપડેટ થયું',
        quizCreated: 'ક્વિઝ બનાવાયું',
        quizUpdatedDetail: 'ક્વિઝ સફળતાપૂર્વક અપડેટ થયું.',
        quizCreatedDetail: 'ક્વિઝ સફળતાપૂર્વક બનાવાયું.',
        saveQuizError: 'ક્વિઝ સાચવતી વખતે ભૂલ આવી. કૃપા કરીને ફરી પ્રયાસ કરો.',
        createQuizError: 'ક્વિઝ બનાવતી વખતે ભૂલ આવી. કૃપા કરીને ફરી પ્રયાસ કરો.',
        noQuizSelected: 'કોઈ ક્વિઝ પસંદ નથી',
        saveQuizBeforeEdit: 'પ્રશ્નો સંપાદિત કરતા પહેલા ક્વિઝ સાચવો.',
        toJoinGoTo: 'જોડાવા માટે, જાઓ',
        quizAppName: 'જૈનડાયરેક્ટ ક્વિઝ',
        preview: 'પૂર્વાવલોકન',
        addQuestionPlaceholder: 'પ્રશ્ન ઉમેરવા માટે ક્લિક કરો',
        addImageForQuestion: 'તમારા પ્રશ્ન માટે છબી ઉમેરો',
        addAudioForQuestion: 'તમારા પ્રશ્ન માટે ઓડિયો ઉમેરો',
        addBackgroundImage: 'પૃષ્ઠભૂમિ છબી ઉમેરો',
        addAudioForBackground: 'પૃષ્ઠભૂમિ માટે ઓડિયો ઉમેરો',
        questionImage: 'પ્રશ્ન છબી',
        yourQuestion: 'તમારો પ્રશ્ન',
        addFromQuestionBank: 'પ્રશ્ન બેંકમાંથી ઉમેરો',
        yourQuestionPlaceholder: 'તમારો પ્રશ્ન...',
        pickAnswer: 'જવાબ પસંદ કરો',
        shortAnswer: 'ટૂંકો જવાબ',
        shortAnswerPlaceholder: 'અહીં તમારો ટૂંકો જવાબ દાખલ કરો...',
        points: 'ગુણ',
        fasterAnswersGetMorePoints: 'વધુ ઝડપથી જવાબ આપનારને વધુ ગુણ મળે છે',
        timeLimit: 'સમય મર્યાદા',
        seconds: 'સેકંડ',
        leaderboard: 'લીડરબોર્ડ',
        generalQuizzes: 'સામાન્ય ક્વિઝ',
        dailyQuizLeaderboard: 'દૈનિક ક્વિઝ લીડરબોર્ડ',
        sansthaQuizLeaderboard: 'સંસ્થા ક્વિઝ લીડરબોર્ડ',
        generalQuizSettings: 'સામાન્ય ક્વિઝ સેટિંગ્સ',
        type: 'પ્રકાર',
        back: 'પાછા',
        next: 'આગળ',
        confirmSave: 'સાચવવાની પુષ્ટિ',
        confirmSaveMessage: 'શું તમે ખરેખર આ પ્રશ્નને ક્વિઝમાં સાચવવા માંગો છો?',
        confirm: 'પુષ્ટિ કરો',
        selectAll: 'બધા પસંદ કરો',
        noQuestionsInBank: 'બેંકમાં કોઈ પ્રશ્નો ઉપલબ્ધ નથી.',
        previous: 'પાછલું',
        page: 'પૃષ્ઠ',
        of: 'માંથી',
        addQuiz: 'ક્વિઝ ઉમેરો',
        join_instruction: 'જોડાવા માટે, જાઓ:',
        add_image: 'તમારા પ્રશ્ન માટે છબી ઉમેરો',
        add_audio: 'તમારા પ્રશ્ન માટે ઓડિયો ઉમેરો',
        add_bg_image: 'પૃષ્ઠભૂમિ છબી ઉમેરો',
        add_bg_audio: 'પૃષ્ઠભૂમિ ઓડિયો ઉમેરો',
        your_question: 'તમારો પ્રશ્ન',
        add_from_bank: 'પ્રશ્ન બેંકમાંથી ઉમેરો',
        placeholder_question: 'તમારો પ્રશ્ન...',
        add_option: '+ વિકલ્પ ઉમેરો',
        short_answer_placeholder: 'અહીં તમારો ટૂંકો જવાબ દાખલ કરો...',
        faster_points: 'વધુ ઝડપથી જવાબ આપનારને વધુ ગુણ મળે છે',
        time_limit: 'સમય મર્યાદા',
        settings: 'સામાન્ય ક્વિઝ સેટિંગ્સ',
        pick_answer: 'જવાબ પસંદ કરો',
        short_answer: 'ટૂંકો જવાબ',
        confirm_save_title: 'સાચવવાની પુષ્ટિ',
        confirm_save_text: 'શું તમે ખરેખર આ પ્રશ્નને ક્વિઝમાં સાચવવા માંગો છો?',
        question_bank: 'પ્રશ્ન બેંક',
        select_all: 'બધા પસંદ કરો',
        no_questions: 'બેંકમાં કોઈ પ્રશ્નો ઉપલબ્ધ નથી.',
        next_page: 'આગળનું પૃષ્ઠ',
        add_quiz: 'ક્વિઝ ઉમેરો',
        untitled_question: 'અનામાંકિત પ્રશ્ન',
        noQuestions: 'કોઈ પ્રશ્નો ઉપલબ્ધ નથી',
        confirmDeleteMsg: 'શું તમે ખરેખર આ પ્રશ્ન કાઢી નાખવા માંગો છો?',
        deleteSuccess: 'પ્રશ્ન સફળતાપૂર્વક કાઢી નાખ્યો',
        deleteError: 'પ્રશ્ન કાઢી નાખવામાં અસફળ',
        createTitle: 'સંસ્થા ક્વિઝ બનાવો',
        editTitle: 'ક્વિઝ સંપાદિત કરો',
        sansthaName: 'સંસ્થાનું નામ',
        uploadImage: 'ક્વિઝ માટે છબી અપલોડ કરો',
        timedQuiz: 'સમયબદ્ધ ક્વિઝ',
        enabled: 'સક્રિય',
        disabled: 'નિષ્ક્રિય',
        visibility: 'ક્વિઝ દૃશ્યતા',
        selectVisibility: 'દૃશ્યતા પસંદ કરો',
        dragDrop: 'છબી પસંદ કરવા માટે ખેંચો અને છોડો અથવા ક્લિક કરો',
        required: '{field} જરૂરી છે',
        successSave: 'ક્વિઝ સફળતાપૂર્વક સાચવ્યું!',
        errorSave: 'ક્વિઝ સાચવવામાં અસફળ.',
        imageSelected: 'છબી પસંદ કરાયેલ',
        sansthaQuizzes: 'સંસ્થા ક્વિઝ',
        createSansthaQuiz: 'નવી સંસ્થા ક્વિઝ બનાવો',
        uploadQuizImage: 'ક્વિઝ માટે છબી અપલોડ કરો',
        successQuizSaved: 'ક્વિઝ સફળતાપૂર્વક સાચવ્યું!',
        errorQuizSave: 'ક્વિઝ સાચવવામાં અસફળ!',
        successCopy: 'ક્વિઝ લિંક ક્લિપબોર્ડ પર કોપી કરાયું!',
        copyQuizLink: 'ક્વિઝ લિંક કોપી કરો',
        educatorDashboard: 'શિક્ષક ડેશબોર્ડ',
        totalQuizzes: 'કુલ ક્વિઝ',
        totalAttempts: 'કુલ પ્રયાસો',
        totalRegisteredUsers: 'કુલ નોંધાયેલા વપરાશકર્તાઓ',
        averageScore: 'સરેરાસ સ્કોર',
        completionRate: 'પૂર્ણતા દર',
        thisWeek: 'આ અઠવાડિયે',
        addedThisWeek: '+3',
        scoreIncrease: '+2.5%',
        completionIncrease: '+4%',
        recentQuizzes: 'તાજેતરના ક્વિઝ',
        dateCreated: 'બનાવ્યાની તારીખ',
        attempts: 'પ્રયાસો',
        status: 'સ્થિતિ',
        action: 'ક્રિયા',
        selectOne: 'એક પસંદ કરો',
        viewAllQuizzes: 'બધા ક્વિઝ જુઓ',
        viewAllQuizzesDesc: 'તમારા બધા ક્વિઝ ઍક્સેસ કરો અને મેનેજ કરો.',
        quizAnalytics: 'ક્વિઝ એનાલિટિક્સ',
        quizAnalyticsDesc: 'વિગતવાર પ્રદર્શન ઇનસાઇટ્સ.',
        studentReports: 'વિદ્યાર્થી રિપોર્ટ્સ',
        studentReportsDesc: 'વ્યક્તિગત વિદ્યાર્થી પ્રગતિ ટ્રેક કરો.',
        viewReports: 'રિપોર્ટ જુઓ',
        myQuizzes: 'મારા ક્વિઝ',
        manageAndOrganize: 'તમારા મૂલ્યાંકનનું વ્યવસ્થાપન અને સંગઠિત કરો',
        createNewQuiz: '+ નવો ક્વિઝ બનાવો',
        searchPlaceholder: 'ક્વિઝ શોધો...',
        allQuizzes: 'બધા ક્વિઝ',
        active: 'સક્રિય',
        inactive: 'નિષ્ક્રિય',
        completed: 'પૂર્ણ',
        loading: 'લોડ થઈ રહ્યું છે...',
        questions: 'પ્રશ્નો',
        aboutThisQuiz: 'આ ક્વિઝ વિશે',
        editQuiz: 'ક્વિઝ સંપાદિત કરો',
        copyLink: 'લિંક કોપી કરો',
        viewQuestions: 'પ્રશ્નો જુઓ',
        deleteQuiz: 'ક્વિઝ કાઢી નાખો',
        delete: 'કાઢી નાખો',
        showingQuizzes: '{count} ક્વિઝ બતાવી રહ્યું છે',
        pageOf: 'પૃષ્ઠ {current} નું {total}',
        noQuizzesFoundTitle: 'કોઈ ક્વિઝ મળ્યા નથી',
        tryAdjustingSearch: 'તમારી શોધ અથવા ફિલ્ટર સમાયોજિત કરવાનો પ્રયાસ કરો',
        confirmDelete: 'કાઢી નાખવાની પુષ્ટિ કરો',
        areYouSureDelete: 'શું તમે ખરેખર કાઢી નાખવા માંગો છો',
        cancel: 'રદ કરો',
        deleting: 'કાઢી નાખી રહ્યું છે...',
        chooseReportType: 'રિપોર્ટ પ્રકાર પસંદ કરો',
        quizReport: 'ક્વિઝ રિપોર્ટ',
        userReport: 'વપરાશકર્તા રિપોર્ટ',
        quizReportDesc: 'આ ક્વિઝ માટેનો રિપોર્ટ જુઓ (પ્રતિ-પ્રશ્ન વપરાશકર્તા પ્રયાસો)',
        userReportDesc: 'પ્રતિ-વપરાશકર્તા પ્રશ્ન પરિણામો જુઓ (સાચું/ખોટું)',
        noQuizzesFound: 'કોઈ ક્વિઝ મળ્યા નથી.',
        quizQuestions: 'ક્વિઝ પ્રશ્નો',
        noQuestionsFound: 'આ ક્વિઝ માટે કોઈ પ્રશ્નો મળ્યા નથી.',
        date: 'તારીખ',
        close: 'બંધ કરો',
        showQuizInstruction: 'ક્વિઝ સૂચના બતાવો',
        hideQuizInstruction: 'ક્વિઝ સૂચના છુપાવો',
        howToCreateQuiz: 'ક્વિઝ કેવી રીતે બનાવવું',
        quizTip1: 'એક સ્પષ્ટ અને ટૂંકું ક્વિઝ શીર્ષક દાખલ કરો.',
        quizTip2: 'બહુવિકલ્પી જેવી યોગ્ય કેટેગરી પસંદ કરો.',
        quizTip3: 'શીખનારાઓ માટે ટૂંકું વર્ણન આપો.',
        quizTip4: 'ક્વિઝ કેટલા દિવસ ચાલશે તે પસંદ કરો અને શરૂ/અંતિમ તારીખો સેટ કરો.',
        quizTip5: 'રજાઓ (જો હોય તો) ચિહ્નિત કરો જેથી તે દિવસે પ્રશ્નો ચૂકવાય.',
        quizTip6: 'દરરોજ કેટલા પ્રશ્નો દેખાશે તે સેટ કરો.',
        quizTip7: 'કઠિનાઈ સ્તર પસંદ કરો (સરળ / મધ્યમ / કઠિન).',
        category: 'કેટેગરી',
        selectHolidayDays: 'રજાના દિવસો પસંદ કરો',
        dailyQuestionCount: 'એક દિવસમાં તમે કેટલા પ્રશ્નો સેટ કરવા માંગો છો',
        selectNumber: 'સંખ્યા પસંદ કરો',
        difficultyLevel: 'કઠિનાઈ સ્તર',
        easy: 'સરળ',
        medium: 'મધ્યમ',
        hard: 'કઠિન',
        updateQuiz: 'ક્વિઝ અપડેટ કરો',
        createQuestions: 'પ્રશ્નો બનાવો',
        saveQuestions: 'પ્રશ્નો સાચવો',
        show: 'બતાવો',
        hide: 'છુપાવો',
        quizInstruction: 'ક્વિઝ સૂચના',
        howToCreateQuestion: '📘 પ્રશ્ન કેવી રીતે બનાવવો',
        description: 'વર્ણન',
        daysQuizRun: 'ક્વિઝ કેટલા દિવસ ચાલશે તે પસંદ કરો અને તારીખો સેટ કરો.',
        markHolidays: 'રજાઓ (જો હોય તો) ચિહ્નિત કરો જેથી તે દિવસે પ્રશ્નો ન આવે.',
        questionsPerDay: 'દરરોજ કેટલા પ્રશ્નો દેખાશે તે સેટ કરો.',
        questionBuilder: 'પ્રશ્ન બિલ્ડર',
        addFromQuestionBank: '+ પ્રશ્ન બેંકમાંથી ઉમેરો',
        removeQuestion: 'પ્રશ્ન કાઢી નાખો',
        addImageOfQuestion: 'પ્રશ્નની છબી ઉમેરો',
        addAudioOfQuestion: 'પ્રશ્નનો ઓડિયો ઉમેરો',
        addVideoOfQuestion: 'પ્રશ્નનો વીડિયો ઉમેરો',
        options: 'વિકલ્પો',
        addAnotherOption: '+ બીજો વિકલ્પ ઉમેરો',
        correctAnswer: 'સાચો જવાબ',
        questionDate: 'પ્રશ્ન તારીખ',
        selectQuestionDate: 'પ્રશ્ન તારીખ પસંદ કરો',
        addNewQuestion: '+ નવો પ્રશ્ન ઉમેરો',
        questionBank: 'પ્રશ્ન બેંક',
        selectQuestionsFromBank: 'બેંકમાંથી પ્રશ્નો પસંદ કરો',
        noQuestionsAvailable: 'બેંકમાં કોઈ પ્રશ્નો ઉપલબ્ધ નથી.',
        addSelected: 'પસંદ કરેલ ઉમેરો',
        added: 'ઉમેરાયું',
        selectedQuestionsAdded: 'પસંદ કરેલા પ્રશ્નો ક્વિઝ બિલ્ડરમાં ઉમેરાયા.',
        failedToLoadBank: 'બેંકમાંથી પ્રશ્નો લોડ કરવામાં અસફળ.',
        noData: 'કોઈ ડેટા નથી',
        failedToLoadQuizQuestions: 'ક્વિઝ પ્રશ્નો લોડ કરવામાં અસફળ.',
        remove: '✖',
        noAvailableQuizzes: 'કોઈ ઉપલબ્ધ ક્વિઝ નથી',
        quizzesWillAppear: 'નવા ક્વિઝ ઉપલબ્ધ થશે ત્યારે અહીં દેખાશે. ટ્યૂન રહો!',
        noDetailsAvailable: 'કોઈ વિગતો ઉપલબ્ધ નથી',
        marks: 'ગુણ',
        start: 'શરૂઆત',
        end: 'અંત',
        comingSoon: 'ટૂંક સમયમાં આવી રહ્યું છે',
        startQuiz: 'ક્વિઝ શરૂ કરો',
        failedToLoadQuizzes: 'ક્વિઝ લોડ કરવામાં અસફળ. કૃપા કરીને ફરી પ્રયાસ કરો.',
        daily_quiz_challenges: 'દૈનિક ક્વિઝ ચેલેન્જ્સ',
        test_your_knowledge: 'અમારા દૈનિક ક્યૂરેટેડ ક્વિઝ સાથે તમારા જ્ઞાનની કસોટી કરો',
        search_placeholder: 'ક્વિઝ શોધો...',
        todays_special: 'આજનું વિશેષ',
        start_quiz: 'ક્વિઝ શરૂ કરો',
        all: 'બધા',
        sort_by_latest: 'ક્રમબદ્ધ કરો: તાજેતરના',
        sort_by_popular: 'ક્રમબદ્ધ કરો: લોકપ્રિય',
        no_quizzes_found: 'કોઈ ક્વિઝ મળ્યા નથી!',
        prev: 'પાછલું',
        active_users: 'સક્રિય વપરાશકર્તાઓ',
        daily_winners: 'દૈનિક વિજેતાઓ',
        success_rate: 'સફળતા દર',
        quizzes_available: 'ઉપલબ્ધ ક્વિઝ',
        sansthaNameField: 'સંસ્થાનું નામ',
        topicName: 'વિષયનું નામ',
        addQuestionImage: 'પ્રશ્ન છબી ઉમેરો',
        addQuestionAudio: 'પ્રશ્ન ઓડિયો ઉમેરો',
        defaultQuestion: 'તમારો અદ્ભુત પ્રશ્ન ઉમેરવા માટે ક્લિક કરો',
        quizQuestion: 'ક્વિઝ પ્રશ્ન',
        timer: 'ટાઈમર (સેકંડ)',
        bonus: 'વધુ ઝડપથી જવાબ આપનારને વધુ ગુણ મળે છે',
        mcq: 'બહુવિકલ્પી પ્રશ્ન',
        quizzes: 'ક્વિઝ',
        quizDetail: 'ક્વિઝ વિગત',
        noQuizzes: 'કોઈ ક્વિઝ ઉપલબ્ધ નથી.',
        viewQuestions: 'માટેના પ્રશ્નો',
        linkCopied: 'ક્વિઝ લિંક ક્લિપબોર્ડ પર કોપી કરાયું.',
        copyError: 'લિંક કોપી કરી શકાયું નથી.',
        quizDeleted: 'ક્વિઝ અને તેનો સંબંધિત ડેટા સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો.',
        home: 'હોમ',
        pages: 'પૃષ્ઠો',
        userDashboard: 'વપરાશકર્તા ડેશબોર્ડ',
        quizDashboard: 'ક્વિઝ ડેશબોર્ડ',
        sansthaQuiz: 'સંસ્થા ક્વિઝ',
        dailyQuizzes: 'દૈનિક ક્વિઝ',
        quizes: 'ક્વિઝ',
        adminDashboard: 'એડમિન ડેશબોર્ડ',
        addBrandOrSponsorImage: 'બ્રાન્ડ અથવા પ્રાયોજક છબી ઉમેરો',
        analyticsOverview: 'એનાલિટિક્સ ઓવરવ્યૂ',
        overallAnalytics: 'સમગ્ર એનાલિટિક્સ',
        settings: 'સેટિંગ્સ',
        leaderboardPublishing: 'લીડરબોર્ડ પબ્લિશિંગ',
        profile: 'પ્રોફાઇલ',
        managedByMe: 'મારા દ્વારા મેનેજ કરેલ',
        dailyQuizCreation: 'દૈનિક ક્વિઝ નિર્માણ',
        switchToEducator: 'શિક્ષક તરીકે સ્વિચ કરો',
        switchToParticipant: 'ભાગીદાર તરીકે સ્વિચ કરો',
        language: 'ભાષા',
        switchToHindi: 'હિન્દીમાં સ્વિચ કરો',
        switchToEnglish: 'અંગ્રેજીમાં સ્વિચ કરો',
        weeklyQuizCompletion: 'સાપ્તાહિક ક્વિઝ પૂર્ણતા',
        quizCompletionStatus: 'ક્વિઝ પૂર્ણતા સ્થિતિ',
        inProgress: 'પ્રગતિમાં',
        notStarted: 'શરૂ થયું નથી',
        completions: 'પૂર્ણતાઓ',
        january: 'જાન્યુઆરી',
        february: 'ફેબ્રુઆરી',
        march: 'માર્ચ',
        april: 'એપ્રિલ',
        may: 'મે',
        june: 'જૂન',
        july: 'જુલાઈ',
        sendMessages: 'સંદેશાઓ મોકલો',
        manageUsers: 'વપરાશકર્તાઓ મેનેજ કરો',
        roles: 'ભૂમિકાઓ',
        assignLuckyWinners: 'નસીબદાર વિજેતાઓ નિમાવો',
        errorFillFields: 'કૃપા કરીને બધા જરૂરી ક્ષેત્રો ભરો.',
        errorInsert: 'પ્રશ્ન ઉમેરવામાં અસફળ.',
        errorUnexpected: 'કશુંક ખોટું થયું.',
        successInsert: 'પ્રશ્ન સફળતાપૂર્વક ઉમેરાયો!',
        successUpdate: 'પ્રશ્ન સફળતાપૂર્વક અપડેટ કરવામાં આવ્યો!',
        confirmEdit: 'સંપાદનની પુષ્ટિ',
        editPrompt: 'શું તમે આ પ્રશ્ન સંપાદિત કરવા માંગો છો?',
        yes: 'હા',
        enterClearQuestionText: 'સ્પષ્ટ અને સંપૂર્ણ પ્રશ્ન દાખલ કરો',
        addOptions: 'જવાબ વિકલ્પો ઉમેરો',
        minimumTwoRequired: 'ઓછામાં ઓછા 2 જરૂરી',
        markCorrectAnswer: 'સાચો જવાબ પસંદ કરો',
        addImageOrAudioOptional: 'વૈકલ્પિક રીતે છબી અથવા ઓડિયો અપલોડ કરો',
        setQuestionDateWithinQuizRange: 'ક્વિઝ શેડ્યૂલમાં પ્રશ્ન તારીખ સેટ કરો',
        assignPoints: 'આ પ્રશ્ન માટે ગુણ નિર્ધારિત કરો',
        useSimpleLanguage: 'વધુ સારી સમજ માટે સરળ અને સ્પષ્ટ ભાષાનો ઉપયોગ કરો',
        durationInDays: 'અવધિ (દિવસોમાં)',
        enterDays: 'દિવસોની સંખ્યા દાખલ કરો',
        luckyWinnersManagement: 'નસીબદાર વિજેતાઓનું મેનેજમેન્ટ',
        dailyWinners: 'દૈનિક વિજેતાઓ',
        weeklyWinners: 'સાપ્તાહિક વિજેતાઓ',
        selectDate: 'તારીખ પસંદ કરો',
        searchParticipants: 'નામ અથવા ID દ્વારા ભાગીદારો શોધો',
        quizName: 'ક્વિઝનું નામ',
        participantId: 'ભાગીદાર ID',
        name: 'નામ',
        quizType: 'ક્વિઝ પ્રકાર',
        score: 'સ્કોર',
        participationDate: 'ભાગીદારી તારીખ',
        performance: 'પ્રદર્શન',
        winnerStatus: 'વિજેતા સ્થિતિ',
        alreadyWinner: 'પહેલેથી જ વિજેતા',
        gold: 'સોનું',
        silver: 'ચાંદી',
        bronze: 'કાંસું',
        sendNotifications: 'નોટિફિકેશન્સ મોકલો',
        clearSelection: 'પસંદગી સાફ કરો',
        saveWinners: 'વિજેતાઓ સાચવો',
        noParticipantsFound: 'માટે કોઈ ભાગીદારો મળ્યા નથી',
        noWinnersSelected: 'કૃપા કરીને ઓછામાં ઓછો એક વિજેતા પસંદ કરો.',
        noNewWinners: 'કૃપા કરીને ઓછામાં ઓછો એક નવો વિજેતા પસંદ કરો.',
        winnersSaved: 'નસીબદાર વિજેતાઓ સફળતાપૂર્વક સાચવાયા!',
        saveFailed: 'સાચવવું અસફળ',
        whatsappError: 'વ્હાટ્સએપ ભૂલ',
        excellent: 'ઉત્તમ',
        good: 'સારું',
        average: 'સરેરાસ',
        saveWeeklyWinners: 'સાપ્તાહિક વિજેતાઓ સાચવો',
        weeklyWinnersSaved: 'સાપ્તાહિક વિજેતાઓ સફળતાપૂર્વક સાચવાયા!',
        saveError: 'સાપ્તાહિક વિજેતાઓ સાચવવામાં ભૂલ',
        fetchError: 'ભાગીદારો લાવવામાં ભૂલ',
        noParticipantsSelected: 'કૃપા કરીને ઓછામાં ઓછો એક ભાગીદાર પસંદ કરો',
        roleManagement: 'ભૂમિકા મેનેજમેન્ટ',
        roleManagementDesc: 'તમારી ક્વિઝ સિસ્ટમ માટે ભૂમિકાઓ મેનેજ અને બનાવો',
        addNewRole: 'નવી ભૂમિકા ઉમેરો',
        roleName: 'ભૂમિકાનું નામ',
        enterRoleName: 'ભૂમિકાનું નામ દાખલ કરો',
        enterDescription: 'ભૂમિકાનું વર્ણન દાખલ કરો',
        permissions: 'પરવાનગીઓ',
        createRole: 'ભૂમિકા બનાવો',
        currentRoles: 'વર્તમાન ભૂમિકાઓ',
        searchRoles: 'ભૂમિકાઓ શોધો...',
        createdDate: 'બનાવ્યાની તારીખ',
        updatedDate: 'અપડેટ તારીખ',
        validationError: 'કૃપા કરીને બધા ક્ષેત્રો ભરો.',
        roleCreationFailed: 'ભૂમિકા બનાવવામાં અસફળ',
        permissionMappingFailed: 'પરવાનગી મેપિંગ અસફળ',
        roleCreated: 'ભૂમિકા સફળતાપૂર્વક બનાવાઈ!',
        quizAccessControl: 'ક્વિઝ મેનેજમેન્ટ ઍક્સેસ કંટ્રોલ',
        quizAccessControlDesc: 'જે વપરાશકર્તાઓ ક્વિઝ બનાવી અને સંપાદિત કરી શકે તેમને મેનેજ કરો',
        addNewUser: 'નવો વપરાશકર્તા ઉમેરો',
        quizManagerRole: 'ક્વિઝ મેનેજર ભૂમિકા',
        quizManagerRoleDesc: 'આ ભૂમિકા ધરાવનાર વપરાશકર્તાઓ ક્વિઝ બનાવી, સંપાદિત અને કાઢી શકે છે',
        createQuizzes: 'નવા ક્વિઝ બનાવો',
        editQuizzes: 'વર્તમાન ક્વિઝ સંપાદિત કરો',
        deleteQuizzes: 'ક્વિઝ કાઢી નાખો',
        manageSettings: 'ક્વિઝ સેટિંગ્સ મેનેજ કરો',
        viewAnalytics: 'એનાલિટિક્સ જુઓ',
        assignPermissions: 'પરવાનગીઓ આપો',
        currentManagers: 'વર્તમાન ક્વિઝ મેનેજરો',
        noManagers: 'કોઈ ક્વિઝ મેનેજરો ઉપલબ્ધ નથી',
        noEducatorsInSoftware: 'તમારા સોફ્ટવેરમાં કોઈ શિક્ષક નથી',
        userName: 'વપરાશકર્તાનું નામ',
        email: 'ઈમેલ',
        mobile: 'મોબાઈલ નંબર',
        role: 'ભૂમિકા',
        accessLevel: 'ઍક્સેસ સ્તર',
        dateAdded: 'ઉમેર્યાની તારીખ',
        confirmAddManager: 'મેનેજર ઉમેરવાની પુષ્ટિ',
        confirmAddText: 'શું તમે ખરેખર મેનેજર ઉમેરવા માંગો છો?',
        editManagerRole: 'મેનેજર ભૂમિકા સંપાદિત કરો',
        selectRole: 'ભૂમિકા પસંદ કરો',
        confirmDeletion: 'કાઢી નાખવાની પુષ્ટિ',
        confirmDeleteText: 'શું તમે ખરેખર આ મેનેજરને કાઢી નાખવા માંગો છો?',
        yesDelete: 'હા, કાઢી નાખો',
        invalidManager: 'અમાન્ય મેનેજર પસંદ કરાયો',
        deleteFailed: 'મેનેજર કાઢી નાખવામાં અસફળ',
        deleteSuccess: '{name} ને ક્વિઝ મેનેજરોમાંથી કાઢી નાખ્યો',
        roleUpdateFailed: 'ભૂમિકા અપડેટ કરવામાં અસફળ',
        roleUpdated: 'મેનેજર ભૂમિકા સફળતાપૂર્વક અપડેટ થઈ',
        chooseQuiz: 'ક્વિઝ પસંદ કરો',
        selectAQuiz: 'એક ક્વિઝ પસંદ કરો',
        viewLeaderboard: 'લીડરબોર્ડ જુઓ',
        seeHowYouRank: 'જુઓ તમે બીજાઓ સામે ક્યાં છો અને પોતાને પડકારો 💡',
        userNotLoggedIn: 'વપરાશકર્તા લોગિન નથી',
        noScoresFound: '❌ આ તારીખ માટે કોઈ સ્કોર મળ્યા નથી.',
        noQuizzesFound: '❌ આ તારીખે તમે કોઈ ક્વિઝ બનાવ્યા નથી.',
        organizationQuizUrl: 'સંસ્થા ક્વિઝ URL',
        quickAccess: 'ઝડપી ઍક્સેસ',
        scanQrCode: 'ક્વિઝ પોર્ટલ ઍક્સેસ કરવા માટે QR કોડ સ્કેન કરો',
        createNewQuiz: 'નવો ક્વિઝ બનાવો',
        enterQuizTitle: 'ક્વિઝ શીર્ષક દાખલ કરો',
        organization: 'સંસ્થા',
        enterDescription: 'ક્વિઝ વર્ણન દાખલ કરો',
        quizDurationType: 'ક્વિઝ અવધિ પ્રકાર',
        singleDay: 'એક દિવસ',
        multiDay: 'ઘણા દિવસો',
        subtopic: 'ઉપવિષય',
        enterSubtopic: 'ઉપવિષય દાખલ કરો',
        releaseResult: 'પરિણામ જાહેર કરો',
        instant: 'તત્કાલ',
        scheduled: 'શેડ્યૂલ કરેલ',
        resultReleaseDate: 'પરિણામ જાહેર તારીખ',
        resultReleaseTime: 'પરિણામ જાહેર સમય',
        createQuizBtn: 'ક્વિઝ બનાવો',
        validationQuizTitle: 'કૃપા કરીને ક્વિઝ શીર્ષક દાખલ કરો',
        validationTopic: 'કૃપા કરીને વિષય દાખલ કરો',
        validationDuration: 'કૃપા કરીને ક્વિઝ અવધિ પ્રકાર પસંદ કરો',
        validationStartDate: 'કૃપા કરીને શરૂઆતની તારીખ પસંદ કરો',
        validationStartTime: 'કૃપા કરીને શરૂઆતનો સમય પસંદ કરો',
        validationEndDate: 'કૃપા કરીને અંતિમ તારીખ પસંદ કરો',
        validationEndTime: 'કૃપા કરીને અંતિમ સમય પસંદ કરો',
        validationReleaseResult: 'કૃપા કરીને પરિણામ જાહેર કરવાનો વિકલ્પ પસંદ કરો',
        validationResultReleaseDate: 'કૃપા કરીને પરિણામ જાહેર તારીખ પસંદ કરો',
        validationResultReleaseTime: 'કૃપા કરીને પરિણામ જાહેર સમય પસંદ કરો',
        quizCreated: 'ક્વિઝ સફળતાપૂર્વક બનાવાયું',
        quizCreateFailed: 'ક્વિઝ બનાવવામાં અસફળ',
        header: 'સંસ્થા ક્વિઝ',
        subHeader: 'અમારા સંસ્થાકીય ક્વિઝ સંગ્રહને બ્રાઉઝ કરો',
        copyLink: 'લિંક કોપી કરો',
        noDescription: 'કોઈ વર્ણન ઉપલબ્ધ નથી',
        totalQuestions: 'પ્રશ્નો',
        totalTime: 'મિનિટ',
        quizLinkCopied: 'ક્વિઝ લિંક ક્લિપબોર્ડ પર કોપી કરાયું!',
        sansthaQuizLists: 'સંસ્થા ક્વિઝ યાદીઓ',
        sanstha: 'સંસ્થા',
        quizNotFinished: 'ક્વિઝ હજુ સમાપ્ત થયું નથી',
        leaderboardNotAvailable: 'લીડરબોર્ડ હજુ ઉપલબ્ધ નથી!',
        quizStillRunning: 'આ ક્વિઝ હજુ ચાલી રહ્યું છે. કૃપા કરીને તે સમાપ્ત થયા પછી પાછા આવો.',
        endsOn: 'સમાપ્તિ તારીખ:',
        stayTuned: 'જોડાયેલા રહો! ક્વિઝ સમાપ્ત થયા પછી તરત જ પરિણામો ઉપલબ્ધ થશે.',
        gotIt: 'સમજાઈ ગયું',
        dailyQuizLists: 'દૈનિક ક્વિઝ યાદીઓ',
        dailyQuizChallenge: 'દૈનિક ક્વિઝ ચેલેન્જ',
        dailyQuizSubHeader: 'અમારા દૈનિક ક્યૂરેટેડ ક્વિઝ સાથે તમારા જ્ઞાનની કસોટી કરો',
        noDataAvailable: 'કોઈ ડેટા ઉપલબ્ધ નથી',
        allDifficulties: 'બધી કઠિનાઈઓ',
        questions: 'પ્રશ્નો',
        easy: 'સરળ',
        medium: 'મધ્યમ',
        hard: 'કઠિન',
        allCategories: 'બધી શ્રેણીઓ',
        beginChallenge: 'ચેલેન્જ શરૂ કરો',
        nextQuestion: 'આગળો પ્રશ્ન',
        noMoreQuestions: 'વધુ પ્રશ્નો નથી',
        noQuizzesAvailable: 'આ ક્ષણે કોઈ ક્વિઝ ઉપલબ્ધ નથી.',
        dailyKnowledgeChallenge: "દૈનિક ક્વિઝ",
        generalKnowledgeQuiz: 'સામાન્ય જ્ઞાન ક્વિઝ',
        noDetailAvailable: 'કોઈ વિગતો ઉપલબ્ધ નથી!',
        startQuizNow: 'હવે ક્વિઝ શરૂ કરો',
        quizEnded: 'આ ક્વિઝ સમાપ્ત થઈ ગઈ છે.',
        exploreMoreQuizzes: 'કૃપા કરીને વધુ ક્વિઝ શોધો અને ભાગ લો!',
        viewMoreQuizzes: 'વધુ ક્વિઝ જુઓ',
        noQuestionToday: 'આજ માટે કોઈ પ્રશ્ન ઉપલબ્ધ નથી!',
        refresh: 'રિફ્રેશ',
        alreadyCompletedToday: 'તમે પહેલેથી જ આજનું ક્વિઝ પૂર્ણ કરી લીધું છે',
        viewRules: 'નિયમો જુઓ',
        quizDetails: 'ક્વિઝ વિગતો',
        topicLabel: 'વિષય',
        generalKnowledge: 'સામાન્ય જ્ઞાન',
        difficultyLabel: 'કઠિનાઈ',
        availableUntil: 'ત્યાં સુધી ઉપલબ્ધ',
        notSet: 'સેટ નથી',
        rulesAndRegulations: 'નિયમો અને વિનિયમો',
        rule1: 'ઉત્તર આપતા પહેલા દરેક પ્રશ્ન કાળજીપૂર્વક વાંચો.',
        rule2: 'દરેક પ્રશ્ન માટે શક્ય તેટલો શ્રેષ્ઠ ઉત્તર પસંદ કરો.',
        rule3: 'ક્વિઝ સમાપ્ત થાય તે પહેલા તમારા ઉત્તર સબમિટ કરો.',
        rule4: 'અંકો ફક્ત સાચા ઉત્તરો માટે આપવામાં આવે છે.',
        rule5: 'લગાતાર સાચા ઉત્તરો તમારા સ્ટ્રીક બોનસને વધારે છે.',
        rule6: 'છેતરપિંડી અથવા બાહ્ય મદદનો ઉપયોગ કરવાથી તમને અયોગ્ય ઠેરવી શકાય છે.',
        completeProfile: 'પ્રોફાઇલ પૂર્ણ કરો',
        completeProfileToContinue: 'ચાલુ રાખવા માટે કૃપા કરીને તમારું પ્રોફાઇલ પૂર્ણ કરો.',
        goToProfile: 'પ્રોફાઇલ પર જાઓ',
        firstQuestionOnDate: 'પહેલો પ્રશ્ન {date} ના રોજ {time} વાગ્યે દેખાશે.',
        firstQuestionTomorrow: 'પહેલો પ્રશ્ન કાલે {time} વાગ્યે દેખાશે.',
        firstQuestionToday: 'પહેલો પ્રશ્ન આજે {time} વાગ્યે દેખાશે.',
        quizEndedMessage: 'આ ક્વિઝ સમાપ્ત થઈ ગયું છે.',
        noQuestionTodayMessage: 'આજે કોઈ પ્રશ્ન ઉપલબ્ધ નથી.',
        quizEndingToday: 'આજનું ક્વિઝ સમાપ્ત થવા જઈ રહ્યું છે.',
        startsIn: 'શરૂ થવામાં',
        days: 'દિવસ',
        hours: 'કલાક',
        minutes: 'મિનિટ',
        seconds: 'સેકંડ',
        importantNotice: 'મહત્વપૂર્ણ સૂચના',
        readBeforeStarting: 'શરૂ કરતા પહેલા વાંચો',
        ensureStableConnection: 'કૃપા કરીને સ્થિર ઇન્ટરનેટ કનેક્શન ખાતરી કરો. એકવાર શરૂ થયા પછી, ટાઈમર થોભાવી શકાતો નથી.',
        completeAllQuestions: 'સમય પૂર્ણ થવા પહેલા તમામ પ્રશ્નો પૂર્ણ કરો',
        noExternalResources: 'પરીક્ષા દરમિયાન બાહ્ય સ્રોતોની મંજૂરી નથી',
        submitBeforeExpiry: 'ટાઈમર પૂર્ણ થવા પહેલા જવાબો સબમિટ કરો',
        details: 'વિગતો',
        rules: 'નિયમો',
        results: 'પરિણામો',
        quizInformation: "ક્વિઝ માહિતી",
        subjectCategory: 'વિષય શ્રેણી',
        quizType: "ક્વિઝનો પ્રકાર",
        quizRules: "ક્વિઝના નિયમો",
        quizTips: "ક્વિઝ માટેની સૂચનાઓ",
        difficultyLevel: 'કઠિનાઈ સ્તર',
        totalQuestions: 'કુલ પ્રશ્નો',
        availableDate: 'ક્વિઝ સમાપ્ત થવાની તારીખ',
        time: 'સમય',
        dq_start_time: "દૈનિક ક્વિઝ શરૂ થવાનો સમય",
        readAllOptions: 'તમામ વિકલ્પો કાળજીપૂર્વક વાંચો',
        focusTimeManagement: 'સમય વ્યવસ્થાપન પર ધ્યાન આપો',
        solveEasyFirst: 'પહેલા સરળ પ્રશ્નો હલ કરો',
        resultsComingSoon: 'પરિણામો ટૂંક સમયમાં આવશે',
        resultsWillBeAvailable: 'પરીક્ષા પૂર્ણ થયા પછી પરિણામો ઉપલબ્ધ થશે.',
        nextQuestionOnDate: 'આગળો પ્રશ્ન {date} ના રોજ {time} વાગ્યે દેખાશે.',
        nextQuestionTomorrow: 'આગળો પ્રશ્ન કાલે {time} વાગ્યે દેખાશે.',
        nextQuestionToday: 'આગળો પ્રશ્ન આજે {time} વાગ્યે દેખાશે.',
        morning: 'સવારે',
        afternoon: 'બપોરે',
        evening: 'સાંજે',
        night: 'રાત્રે',
        sun: 'રવિ',
        jan: 'જાન્યુ',
        feb: 'ફેબ્રુ',
        mar: 'માર્ચ',
        apr: 'એપ્રિલ',
        may: 'મે',
        jun: 'જૂન',
        jul: 'જુલાઈ',
        aug: 'ઓગ',
        sep: 'સેપ્ટે',
        oct: 'ઓક્ટો',
        nov: 'નવેં',
        dec: 'ડિસેં',
        adminTitle: 'જૈનડાયરેક્ટ ક્વિઝ - એડમિન ડેશબોર્ડ',
        totalSanstha: 'કુલ સંસ્થાઓ',
        totalQuizzes: 'કુલ બનાવેલા ક્વિઝ',
        activeQuizzes: 'સક્રિય ક્વિઝ',
        totalParticipants: 'કુલ ભાગીદારો',
        userEngagement: 'વપરાશકર્તા એન્ગેજમેન્ટ વૃદ્ધિ',
        engagementChannels: 'એન્ગેજમેન્ટ ચેનલ ઓવરવ્યુ',
        whatsappMessages: 'મોકલેલા વ્હાટ્સએપ સંદેશાઓ',
        emailMessages: 'મોકલેલા ઈમેલ્સ',
        avgScore: 'સરેરાસ સ્કોર',
        dailyActiveUsers: 'દૈનિક સક્રિય ક્વિઝ લેનારાઓ',
        topQuizzes: 'પ્રયાસો મુજબ ટોચના 5 ક્વિઝ',
        platformUsageDistribution: 'પ્લેટફોર્મ ઉપયોગ વિતરણ',
        mostPopularQuizzes: 'તાજેતરના સૌથી લોકપ્રિય ક્વિઝ',
        newParticipants: 'નવા ભાગીદારો',
        totalEducators: 'શિક્ષકો',
        attempts: 'પ્રયાસો',
        report: 'રિપોર્ટ',
        viewDetails: 'વિગતો જુઓ',
        allSansthas: 'બધી સંસ્થાઓ',
        noLocation: 'કોઈ સ્થાન નથી',
        profile: 'પ્રોફાઈલ',
        messages: 'સંદેશાઓ',
        logout: 'લોગઆઉટ',
        shortAppName: 'જેડી ક્વિઝ',
        fullAppName: 'જૈનડાયરેક્ટ ક્વિઝ',
        title: 'ક્વિઝ',
        statistics: 'ક્વિઝ આંકડાકીય માહિતી',
        total_questions: 'કુલ પ્રશ્નો',
        total_points: 'કુલ ગુણ',
        total_time: 'કુલ સમય',
        duration: 'અવધિ',
        dates: 'તારીખો',
        start_date: 'શરૂઆત તારીખ',
        end_date: 'અંતિમ તારીખ',
        time: 'સમય',
        additional_info: 'વધારાની માહિતી',
        participants_limit: 'ભાગીદારોની મર્યાદા',
        unlimited: 'અમર્યાદિત',
        difficulty: 'કઠિનાઈ સ્તર',
        intermediate: 'મધ્યમ',
        quiz_not_started: 'ક્વિઝ હજી શરૂ થયું નથી',
        quiz_live: 'ક્વિઝ શરૂ કરો',
        quiz_ended: 'ક્વિઝ સમાપ્ત થયું',
        quizNotAvailable: 'ક્વિઝ વપરાશકર્તાઓ માટે ઉપલબ્ધ નથી',
        noQuestionsInQuiz: 'આ ક્વિઝમાં કોઈ પ્રશ્નો નથી',
        leaderboardPublishMode: 'લીડરબોર્ડ પબ્લિશ મોડ',
        selectOption: 'એક વિકલ્પ પસંદ કરો',
        autoPublish: 'ઓટો પબ્લિશ',
        manualPublish: 'મેન્યુઅલ પબ્લિશ',
        autoPublishHint: 'ક્વિઝ પૂર્ણ થયા પછી લીડરબોર્ડ આપોઆપ પ્રકાશિત થશે.',
        manualPublishHint: 'લીડરબોર્ડ એડમિન દ્વારા મેન્યુઅલી પબ્લિશ કરવામાં આવશે.',
        manualPublishBadge: 'લીડરબોર્ડને મેન્યુઅલી પબ્લિશ કરવું પડશે',

        enterPointsForRank: 'રેન્ક {rank} માટે પોઈન્ટ્સ દાખલ કરો',
        scoringManagement: 'ક્વિઝ રેન્કિંગ અને સ્કોરિંગ મેનેજમેન્ટ',
        scoringManagementSubtitle: 'રેન્કિંગ, જવાબો અને સ્કોરિંગ પેરામીટર્સ કન્ફિગર કરો',
        rankBonusPoints: 'રેન્ક બોનસ પોઈન્ટ્સ',
        rankBonusPointsDescription: 'આ વધારાના બોનસ પોઈન્ટ્સ છે જે ક્વિઝમાં તેમના અંતિમ રેન્કના આધારે વપરાશકર્તાઓને આપવામાં આવે છે. ઉચ્ચ રેન્કને વધુ બોનસ પોઈન્ટ્સ મળશે.',
        addMoreRank: '+ વધુ રેન્ક ઉમેરો',
        bonusPoints: 'બોનસ પોઈન્ટ્સ (વધારાના પુરસ્કારો)',
        bonusPointsDescription: 'ક્વિઝ દરમિયાન ખાસ શરતોના આધારે વપરાશકર્તાઓને વધારાના પોઈન્ટ્સ આપવા માટે બોનસ નિયમો સક્ષમ કરો.',
        fastestAnswer: 'સૌથી ઝડપી જવાબ (5 સેકંડની અંદર)',
        allAnswersCorrect: 'બધા જવાબો સાચા',
        consecutiveParticipation: 'આગામી ક્વિઝ ભાગીદારી (3+ દિવસ)',
        firstAttemptDay: 'દિવસનો પહેલો ક્વિઝ પ્રયાસ',
        comingSoon: '(ટૂંક સમયમાં આવશે)',
        negativeMarking: 'નેગેટિવ માર્કિંગ (પેનલ્ટી પોઈન્ટ્સ)',
        negativeMarkingDescription: 'દરેક ખોટા જવાબ માટે વપરાશકર્તાના સ્કોરમાંથી પોઈન્ટ્સ કાપો.',
        wrongAnswer: 'ખોટો જવાબ',
        saveConfiguration: 'કન્ફિગરેશન સાચવો',
        confirmNotification: 'નોટિફિકેશનની પુષ્ટિ',
        whatsappNotifyQuestion: 'શું તમે આ ક્વિઝ વિશે વપરાશકર્તાઓને સૂચિત કરવા માટે WhatsApp સંદેશ મોકલવા માંગો છો?',
        no: 'ના',
        yes: 'હા',
        // Leaderboard translations
        quizTitle: 'ક્વિઝ શીર્ષક',
        totalParticipants: 'કુલ ભાગ લેનારા',
        averageScore: 'સરેરાશ સ્કોર',
        yourRank: 'તમારી રેન્ક',
        date: 'તારીખ',
        dateRange: 'તારીખ શ્રેણી',
        dailyWinner: 'દૈનિક વિજેતા',
        weeklyWinner: 'સાપ્તાહિક વિજેતા',
        monthlyWinner: 'માસિક વિજેતા',
        finalWinner: 'અંતિમ વિજેતા',
        fastFinger: 'ઝડપી આંગળી',
        top5: 'ટોચના 5',
        top10: 'ટોચના 10',
        luckyWinner: 'ભાગ્યશાળી વિજેતા',
        queAnsHistory: 'પ્રશ્ન અને જવાબ ઇતિહાસ',
        ourSponsors: 'અમારા સ્પોન્સર્સ',
        sponsoredBy: 'સ્પોન્સર દ્વારા',
        quizQuestions: 'ક્વિઝ પ્રશ્નો',
        dailyQuiz: 'દૈનિક ક્વિઝ',
        correctAnswer: 'સાચો જવાબ',
        participantName: 'ભાગ લેનારનું નામ',
        location: 'સ્થાન',
        totalScore: 'કુલ સ્કોર',
        totalTime: 'કુલ સમય',
        mobile: 'મોબાઇલ',
        resultsNotPublished: 'પરિણામો પ્રકાશિત થયા નથી',
        leaderboardNotAvailable: 'લીડરબોર્ડ ઉપલબ્ધ નથી',
        backToDashboard: 'ડેશબોર્ડ પર પાછા જાઓ',
        noParticipantsFound: 'કોઈ ભાગ લેનાર મળ્યા નથી',
        firstRank: '1st રેન્ક',
        secondRank: '2nd રેન્ક',
        thirdRank: '3rd રેન્ક',
        searchByParticipantName: 'ભાગ લેનારના નામ દ્વારા શોધો',
        fastestFingerFirstResult: 'ઝડપી આંગળી પહેલો પરિણામ',
        top10Result: 'ટોચના 10 પરિણામ',
        top5Result: 'ટોચના 5 પરિણામ',
        luckyWinnerResult: 'ભાગ્યશાળી વિજેતા પરિણામ',
        luckyWinnersNotAvailable: 'ભાગ્યશાળી વિજેતાઓ ઉપલબ્ધ નથી',
        top5WinnersNotAvailable: 'ટોચના 5 વિજેતાઓ ઉપલબ્ધ નથી',
        top10WinnersNotAvailable: 'ટોચના 10 વિજેતાઓ ઉપલબ્ધ નથી',
        resultsWillBeAnnounced: 'પરિણામો જલ્દી જ જાહેર કરવામાં આવશે. કૃપા કરીને પછી તપાસો.',
        resultsNotPublishedYet: 'આ સમયગાળા માટે પરિણામો હજી પ્રકાશિત થયા નથી.',
        // EduLeadership translations
        downloadExcel: 'એક્સેલ ડાઉનલોડ કરો',
        downloadPDF: 'પીડીએફ ડાઉનલોડ કરો',
        viewQuizQuestions: 'ક્વિઝ પ્રશ્નો જુઓ',
        publishResults: 'પરિણામો પ્રકાશિત કરો',
        quizQuestions: 'ક્વિઝ પ્રશ્નો',
        dailyQuiz: 'દૈનિક ક્વિઝ',
        correctAnswer: 'સાચો જવાબ',
        firstRank: '1st રેન્ક',
        secondRank: '2nd રેન્ક',
        thirdRank: '3rd રેન્ક',
        fastestFingerFirstResult: 'ઝડપી આંગળી પહેલો પરિણામ',
        top10Result: 'ટોચના 10 પરિણામ',
        top5Result: 'ટોચના 5 પરિણામ',
        luckyWinnerResult: 'ભાગ્યશાળી વિજેતા પરિણામ',
        searchByParticipantName: 'ભાગ લેનારના નામ દ્વારા શોધો',
        participantName: 'ભાગ લેનારનું નામ',
        location: 'સ્થાન',
        totalScore: 'કુલ સ્કોર',
        totalTime: 'કુલ સમય',
        mobile: 'મોબાઇલ',
        trueFalse: "સાચું / ખોટું",
        showingEntries: '{first} થી {last} સુધી {totalRecords} એન્ટ્રીઝ દર્શાવે છે',
        weekStillRunning: 'આ અઠવાડિયું હજી ચાલી રહ્યું છે, તેથી પ્રકાશન અક્ષમ છે.',
        weekCanPublish: 'આ અઠવાડિયાના પરિણામો પ્રકાશિત કરી શકાય છે.',
        monthStillRunning: 'આ મહિનો હજી ચાલી રહ્યો છે, તેથી પ્રકાશન અક્ષમ છે.',
        monthCanPublish: 'આ મહિનાના પરિણામો પ્રકાશિત કરી શકાય છે.',
        rulesAndRegulation: "નિયમો અને નિયમાવલિ",
        addNewRule: 'નવો નિયમ ઉમેરો',
        minimumRulesRequired: 'ઓછામાં ઓછા 4 નિયમો જરૂરી છે',
        todaysParticipants: 'આજના સહભાગીઓ',
        weeklyParticipants: 'સાપ્તાહિક સહભાગીઓ',
        monthlyParticipants: 'માસિક સહભાગીઓ',
        totalParticipants: 'કુલ સહભાગીઓ',
    },
    mr: {
        questionBank: 'प्रश्न बँक',
        searchQuestions: 'प्रश्न शोधा...',
        confirmDelete: 'कृपया हटविण्याची पुष्टी करा',               //'हटविण्याची पुष्टी करा',
        deletePrompt: 'तुम्हाला खात्री आहे की हा प्रश्न हटवायचा आहे?',
        cancel: 'रद्द करा',
        delete: 'हटवा',
        deleted: 'हटवले',
        questionDeleted: 'प्रश्न हटवला गेला आहे',               //'प्रश्न यशस्वीरित्या हटवला',
        error: 'त्रुटी',
        failedToDelete: 'प्रश्न हटवण्यात समस्या आली',               //'प्रश्न हटवण्यात अयशस्वी',
        topic: 'विषय',
        subTopic: 'उपविषय',
        actions: 'क्रिया',
        question: 'प्रश्न',
        createNewQuestion: 'नवीन प्रश्न तयार करा',
        editQuestion: "प्रश्न संपादित करा",
        questionType: 'प्रश्न प्रकार',
        multipleChoice: 'बहुपर्यायी',
        questionText: 'प्रश्न मजकूर',
        enterQuestion: 'प्रश्न लिहा',                     //'तुमचा प्रश्न प्रविष्ट करा...',
        enterTopic: 'विषय लिहा',
        enterSubTopic: 'उपविषय लिहा',                         //'उपविषय प्रविष्ट करा...',
        answerOptions: 'उत्तर पर्याय',
        addOption: '+ पर्याय जोडा',
        selectCorrectAnswer: 'योग्य उत्तर निवडा',                  //'बरोबर उत्तर निवडा',
        option: 'पर्याय',
        submit: 'सबमिट करा',
        pleaseFill: 'कृपया सर्व आवश्यक फील्ड भरा.',
        failedToAdd: 'प्रश्न जोडणे शक्य झाले नाही',                  //'प्रश्न जोडण्यात अयशस्वी.',
        success: 'पूर्ण झाले',                                   //'यश',
        questionAdded: 'प्रश्न जोडण्यात आला आहे',                //'प्रश्न यशस्वीरित्या जोडला!',
        somethingWrong: 'काहीतरी चूक झाली.',
        createQuizBasic: 'क्विझ तयार करा',
        createDailyQuiz: 'दैनिक क्विझ तयार करा',
        updateDailyQuiz: 'दैनिक क्विझ अद्यतनित करा',
        updateQuestions: 'प्रश्न अद्यतनित करा',
        editQuiz: 'क्विझमध्ये बदल करा',                        //'क्विझ संपादित करा',
        openQuiz: 'क्विझ उघडा',
        quizTitle: 'क्विझ शीर्षक',
        quizTitlePlaceholder: 'क्विझ शीर्षक प्रविष्ट करा',
        quizTitleRequired: 'क्विझ शीर्षक आवश्यक आहे.',
        quizDescription: 'क्विझ वर्णन',
        quizDescriptionRequired: 'क्विझ वर्णन आवश्यक आहे.',
        topicPlaceholder: 'विषय प्रविष्ट करा',
        subTopicPlaceholder: 'उपविषय प्रविष्ट करा',
        startDate: 'सुरुवात तारीख',
        endDate: 'अंतिम तारीख',                            //'शेवट तारीख',
        startTime: 'सुरुवात वेळ',
        endTime: 'शेवट वेळ',
        quizVisibility: 'क्विझ दृश्यता',
        selectVisibility: 'दृश्यता निवडा',
        public: 'सार्वजनिक',
        private: 'खाजगी',
        save: 'सेव करा',
        editQuestions: 'प्रश्न संपादित करा',
        addQuestions: 'प्रश्न जोडा',
        quizUpdated: 'क्विझ अपडेट झाली',                     //'क्विझ अद्यतनित',
        quizCreated: 'क्विझ तयार',
        quizUpdatedDetail: 'क्विझ अपडेट करण्यात आली.',        //'क्विझ यशस्वीरित्या अद्यतनित झाले.',
        quizCreatedDetail: 'क्विझ तयार करण्यात आली.',                //'क्विझ यशस्वीरित्या तयार झाले.',
        saveQuizError: 'क्विझ सेव करताना त्रुटी. कृपया पुन्हा प्रयत्न करा.',
        createQuizError: 'क्विझ तयार करताना त्रुटी. कृपया पुन्हा प्रयत्न करा.',
        noQuizSelected: 'प्रश्न निवडले नाही',
        saveQuizBeforeEdit: 'कृपया प्रश्न संपादित करण्यापूर्वी क्विझ सेव करा.',
        toJoinGoTo: 'सामील होण्यासाठी पुढे जा',
        quizAppName: 'जैनडायरेक्ट क्विझ',
        preview: 'पूर्वावलोकन',
        addQuestionPlaceholder: 'प्रश्न जोडण्यासाठी क्लिक करा',
        addImageForQuestion: 'तुमच्या प्रश्नासाठी फोटो जोडा',
        addAudioForQuestion: 'तुमच्या प्रश्नासाठी ऑडिओ जोडा',
        addBackgroundImage: 'पार्श्वभूमी फोटो जोडा',
        addAudioForBackground: 'पार्श्वभूमीसाठी ऑडिओ जोडा',
        questionImage: 'प्रश्न फोटो',
        yourQuestion: 'तुमचा प्रश्न',
        addFromQuestionBank: 'प्रश्न बँकेतून प्रश्न जोडा',
        yourQuestionPlaceholder: 'तुमचा प्रश्न...',
        pickAnswer: 'उत्तर निवडा',
        shortAnswer: 'अल्प उत्तर',
        shortAnswerPlaceholder: 'तुमचे अल्प उत्तर येथे प्रविष्ट करा...',
        points: 'गुण',
        fasterAnswersGetMorePoints: 'लवकर उत्तर दिल्यास अधिक गुण मिळतात',         //'जलद उत्तरांना अधिक गुण मिळतात',
        timeLimit: 'वेळ मर्यादा',
        seconds: 'सेकंड',
        leaderboard: 'लिडरबोर्ड',
        generalQuizzes: 'सामान्य क्विझ',
        dailyQuizLeaderboard: 'दैनिक क्विझ लीडरबोर्ड',
        sansthaQuizLeaderboard: 'संस्था क्विझ लीडरबोर्ड',
        generalQuizSettings: 'सामान्य क्विझ सेटिंग्स',
        type: 'प्रकार',
        back: 'मागे',
        next: 'पुढे',
        confirmSave: 'सेव करण्याची पुष्टी करा',
        confirmSaveMessage: 'तुम्हाला खात्री आहे की हा प्रश्न क्विझमध्ये सेव करायचा आहे?',
        confirm: 'पुष्टी करा',
        selectAll: 'सर्व निवडा',
        noQuestionsInBank: 'बँकेत कोणतेही प्रश्न उपलब्ध नाहीत.',
        previous: 'मागील',
        page: 'पृष्ठ',
        of: 'पैकी',
        addQuiz: 'क्विझ जोडा',
        join_instruction: 'सामील होण्यासाठी जा:',
        add_image: 'प्रश्नासाठी फोटो जोडा',
        add_audio: 'प्रश्नासाठी ऑडिओ जोडा',
        add_bg_image: 'पार्श्वभूमी फोटो जोडा',
        add_bg_audio: 'पार्श्वभूमीसाठी ऑडिओ जोडा',
        your_question: 'तुमचा प्रश्न',
        add_from_bank: 'बँकेतून जोडा',
        placeholder_question: 'आपला प्रश्न लिहा...',
        add_option: '+ पर्याय जोडा',
        short_answer_placeholder: 'तुमचे अल्प उत्तर येथे प्रविष्ट करा...',
        faster_points: 'लवकर उत्तर दिल्यास अधिक गुण मिळतात',
        time_limit: 'वेळ मर्यादा',
        settings: 'सामान्य क्विझ सेटिंग्स',
        pick_answer: 'उत्तर निवडा',
        short_answer: 'अल्प उत्तर',
        question_bank: 'प्रश्न बँक',
        select_all: 'सर्व निवडा',
        no_questions: 'बँकेत कोणतेही प्रश्न उपलब्ध नाहीत.',
        next_page: 'पुढे',
        add_quiz: 'क्विझ जोडा',
        untitled_question: 'शीर्षकहीन प्रश्न',
        noQuestions: 'बँकेत कोणतेही प्रश्न उपलब्ध नाहीत.',
        searchQuestions: 'प्रश्न शोधा...',
        confirmDeleteMsg: 'तुम्हाला खात्री आहे की हा क्विझ हटवायचा आहे?',
        deleteSuccess: 'प्रश्न हटवला गेला',                                             //'प्रश्न यशस्वीरित्या हटवला',
        deleteError: 'प्रश्न हटवणे शक्य झाले नाही',                                                          // 'प्रश्न हटवण्यात अयशस्वी',
        createTitle: 'संस्था क्विझ तयार करा',
        editTitle: 'क्विझमध्ये बदल करा',                                                //'क्विझ संपादित करा',
        sansthaName: 'संस्था नाव',
        quizDescription: 'क्विझ वर्णन',
        uploadImage: 'क्विझसाठी फोटो अपलोड करा',
        timedQuiz: 'वेळेचा क्विझ',
        enabled: 'सक्रिय',                                                      //'सक्षम',
        disabled: 'निष्क्रिय',                                                      //'अक्षम',
        visibility: 'क्विझ दृश्यता',
        selectVisibility: 'दृश्यता निवडा',
        dragDrop: 'ड्रॅग आणि ड्रॉप करा किंवा फोटो निवडण्यासाठी क्लिक करा',
        required: '{field} आवश्यक आहे',
        successSave: 'क्विझ सेव करण्यात आली',                     //'क्विझ यशस्वीरित्या सेव केले!',
        errorSave: 'क्विझ सेव करताना समस्या आली',                        // 'क्विझ सेव करण्यात अयशस्वी.',
        imageSelected: 'फोटो निवडली',
        sansthaQuizzes: 'संस्था क्विझ',
        createSansthaQuiz: 'नवीन संस्था क्विझ तयार करा',
        uploadQuizImage: 'क्विझसाठी फोटो अपलोड करा',
        successQuizSaved: 'कक्विझ सेव करण्यात आली',
        errorQuizSave: 'क्विझ सेव करताना समस्या आली',               //'क्विझ सेव करण्यात अयशस्वी!',
        successCopy: 'क्विझ लिंक क्लिपबोर्डवर कॉपी केली!',
        copyQuizLink: 'क्विझ लिंक कॉपी करा',
        educatorDashboard: 'शिक्षक डॅशबोर्ड',
        totalQuizzes: 'एकूण क्विझ',
        totalAttempts: 'एकूण प्रयत्न',
        totalRegisteredUsers: 'કુલ નોંધાયેલા વપરાશકર્તાઓ',
        averageScore: 'सरासरी गुण',
        completionRate: 'पूर्णता दर',
        thisWeek: 'या आठवड्यात',
        recentQuizzes: 'अलीकडील क्विझ',
        dateCreated: 'तयार केल्याची तारीख',
        attempts: 'प्रयत्न',
        status: 'स्थिती',
        action: 'क्रिया',
        selectOne: 'एक निवडा',
        viewAllQuizzes: 'सर्व क्विझ पहा',
        viewAllQuizzesDesc: 'तुमच्या सर्व क्विझ ऍक्सेस करा आणि व्यवस्थापित करा.',
        quizAnalytics: 'क्विझ विश्लेषण',
        quizAnalyticsDesc: 'सविस्तर कामगिरीचे विश्लेषण',
        studentReports: 'विद्यार्थी अहवाल',
        studentReportsDesc: 'विद्यार्थी प्रगतीचे निरीक्षण करा',
        viewReports: 'अहवाल पहा',
        myQuizzes: 'माझे क्विझ',
        manageAndOrganize: 'तुमच्या मूल्यमापनाचे व्यवस्थापन आणि संघटन करा',
        createNewQuiz: '+ नवीन क्विझ तयार करा',
        searchPlaceholder: 'क्विझ शोधा...',
        allQuizzes: 'सर्व क्विझ',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
        completed: 'पूर्ण',
        loading: 'लोड होत आहे...',
        questions: 'प्रश्न',
        aboutThisQuiz: 'या क्विझबद्दल',
        editQuiz: 'क्विझ संपादित करा',
        copyLink: 'लिंक कॉपी करा',
        viewQuestions: 'प्रश्न पहा',
        deleteQuiz: 'क्विझ हटवा',
        delete: 'हटवा',
        showingQuizzes: '{count} क्विझ दाखवत आहे',
        pageOf: 'पृष्ठ {current} पैकी {total}',
        noQuizzesFoundTitle: 'कोणतेही क्विझ सापडले नाहीत',
        tryAdjustingSearch: 'तुमचा शोध किंवा फिल्टर समायोजित करण्याचा प्रयत्न करा',
        confirmDelete: 'हटवण्याची पुष्टी करा',
        areYouSureDelete: 'तुम्हाला खात्री आहे की तुम्ही हटवू इच्छिता',
        cancel: 'रद्द करा',
        deleting: 'हटवत आहे...',
        chooseReportType: 'अहवाल प्रकार निवडा',
        quizReport: 'क्विझ अहवाल',
        userReport: 'वापरकर्ता अहवाल',
        quizReportDesc: 'या क्विझसाठी अहवाल पहा (प्रति-प्रश्न वापरकर्ता प्रयत्न)',
        userReportDesc: 'प्रति-वापरकर्ता प्रश्न निकाल पहा (बरोबर/चूक)',
        previous: 'मागील',
        next: 'पुढे',
        noQuizzesFound: 'कोणतेही क्विझ सापडले नाहीत.',
        quizQuestions: 'क्विझ प्रश्न',
        noQuestionsFound: 'या क्विझसाठी कोणतेही प्रश्न सापडले नाहीत.',
        points: 'गुण',
        date: 'तारीख',
        close: 'बंद करा',
        showQuizInstruction: 'क्विझ सूचना दाखवा',
        hideQuizInstruction: 'क्विझ सूचना लपवा',
        howToCreateQuiz: 'क्विझ कसे तयार करावे?',
        quizTip1: 'एक स्पष्ट आणि छोटे क्विझ शीर्षक प्रविष्ट करा.',
        quizTip2: 'मल्टिपल चॉइससारखी योग्य श्रेणी निवडा.',
        quizTip3: 'शिकणऱ्यांसाठी एक संक्षिप्त वर्णन द्या.',
        quizTip4: 'क्विझ किती दिवस चालेल आणि सुरुवात/समाप्ती तारीख सेट करा.',
        quizTip5: 'सुट्ट्या असल्यास त्या दिवसांसाठी प्रश्न वगळण्यासाठी चिन्हांकित करा.',
        quizTip6: 'रोज किती प्रश्न दिसतील हे सेट करा.',
        quizTip7: 'कठीणपणा पातळी निवडा (सोपे / मध्यम / कठीण).',
        createQuiz: 'क्विझ तयार करा',
        enterQuizTitle: 'क्विझ शीर्षक प्रविष्ट करा',
        category: 'श्रेणी',
        selectHolidayDays: 'सुट्ट्यांचे दिवस निवडा',
        dailyQuestionCount: 'एका दिवसात तुम्ही किती प्रश्न सेट करता',
        selectNumber: 'संख्या निवडा',
        difficultyLevel: 'कठीणपणा पातळी',
        easy: 'सोपे',
        medium: 'मध्यम',
        hard: 'कठीण',
        updateQuiz: 'क्विझ अद्यतनित करा',
        createQuestions: 'प्रश्न तयार करा',
        saveQuestions: 'प्रश्न सेव करा',
        show: 'दाखवा',
        hide: 'लपवा',
        quizInstruction: 'क्विझ सूचना',
        howToCreateQuestion: '📘 प्रश्न कसा तयार करावा',
        description: 'वर्णन',
        daysQuizRun: 'क्विझ किती दिवस चालेल आणि सुरुवात/समाप्ती तारीख सेट करा.',
        markHolidays: 'सुट्ट्या असल्यास त्या चिन्हांकित करा जेणेकरून त्या दिवशी प्रश्न येणार नाहीत.',
        questionsPerDay: 'रोज किती प्रश्न दिसतील हे सेट करा.',
        questionBuilder: 'प्रश्न बिल्डर',
        addFromQuestionBank: '+ प्रश्न बँकेतून जोडा',
        removeQuestion: 'प्रश्न काढा',
        enterQuestion: 'तुमचा प्रश्न येथे प्रविष्ट करा...',
        addImageOfQuestion: 'प्रश्नाची फोटो जोडा',
        addAudioOfQuestion: 'प्रश्नाचा ऑडिओ जोडा',
        addVideoOfQuestion: 'प्रश्नाचा व्हिडिओ जोडा',
        options: 'पर्याय',
        addAnotherOption: '+ आणखी एक पर्याय जोडा',
        correctAnswer: 'बरोबर उत्तर',
        questionDate: 'प्रश्न तारीख',
        addNewQuestion: '+ नवीन प्रश्न जोडा',
        questionBank: 'प्रश्न बँक',
        selectQuestionsFromBank: 'बँकेतून प्रश्न निवडा',
        noQuestionsAvailable: 'बँकेत कोणतेही प्रश्न उपलब्ध नाहीत.',
        addSelected: 'निवडलेले जोडा',
        added: 'जोडले',
        selectedQuestionsAdded: 'निवडलेले प्रश्न क्विझ बिल्डरमध्ये जोडले.',
        failedToLoadBank: 'बँकेतून प्रश्न लोड करण्यात अयशस्वी.',
        noData: 'कोणताही डेटा नाही',
        failedToLoadQuizQuestions: 'क्विझ प्रश्न लोड करणे शक्य झाले नाही',
        remove: '✖',
        noAvailableQuizzes: 'कोणतेही उपलब्ध क्विझ नाहीत',
        quizzesWillAppear: 'नवीन क्विझ उपलब्ध झाल्यावर येथे दिसतील. कृपया प्रतीक्षा करा!',
        noDetailsAvailable: 'कोणतीही माहिती उपलब्ध नाही',
        marks: 'गुण',
        start: 'सुरुवात',
        end: 'समाप्ती',
        comingSoon: 'लवकरच येत आहे',
        startQuiz: 'क्विझ सुरू करा',
        failedToLoadQuizzes: 'क्विझ लोड करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
        daily_quiz_challenges: 'दैनिक क्विझ आव्हाने',
        test_your_knowledge: 'आमच्या दैनिक तयार केलेल्या क्विझसह तुमचे ज्ञान तपासा',
        search_placeholder: 'क्विझ शोधा...',
        todays_special: 'आजचे विशेष',
        start_quiz: 'क्विझ सुरू करा',
        all: 'सर्व',
        sort_by_latest: 'क्रमबद्ध करा: नवीनतम',
        sort_by_popular: 'क्रमबद्ध करा: लोकप्रिय',
        no_quizzes_found: 'कोणतेही क्विझ सापडले नाहीत!',
        prev: 'मागील',
        next_page: 'पुढे',
        active_users: 'सक्रिय वापरकर्ते',
        daily_winners: 'दैनिक विजेते',
        success_rate: 'यशस्वी दर',
        quizzes_available: 'उपलब्ध क्विझ',
        topicName: 'विषय नाव',
        addQuestionImage: 'प्रश्न फोटो जोडा',
        addQuestionAudio: 'प्रश्न ऑडिओ जोडा',
        defaultQuestion: 'तुमचा अद्भुत प्रश्न जोडण्यासाठी क्लिक करा',
        quizQuestion: 'क्विझ प्रश्न',
        timer: 'वेळ मर्यादा (सेकंद)',
        bonus: 'लवकर उत्तर दिल्यास अधिक गुण मिळतात',
        confirmMsg: 'तुम्हाला खात्री आहे की हा प्रश्न क्विझमध्ये सेव करायचा आहे?',
        mcq: 'बहुपर्यायी प्रश्न',
        quizzes: 'क्विझ',
        subTopic: 'उपविषय',
        quizDetail: 'क्विझ तपशील',
        noQuizzes: 'कोणतेही क्विझ उपलब्ध नाहीत.',
        viewQuestions: 'साठी प्रश्न',
        linkCopied: 'क्विझ लिंक क्लिपबोर्डवर कॉपी केली.',
        copyError: 'लिंक कॉपी करता आली नाही.',
        quizDeleted: 'क्विझ आणि संबंधित डेटा यशस्वीरित्या हटवला.',
        deleteError: 'क्विझ किंवा संबंधित डेटा हटवण्यात अयशस्वी.',
        home: 'मुख्यपृष्ठ',
        pages: 'पृष्ठे',
        userDashboard: 'वापरकर्ता डॅशबोर्ड',
        quizDashboard: 'क्विझ डॅशबोर्ड',
        sansthaQuiz: 'संस्था क्विझ',
        sansthaQuizzes: 'संस्था क्विझ',
        dailyQuizzes: 'दैनिक क्विझ',
        quizes: 'क्विझ',
        adminDashboard: 'अ‍ॅडमिन डॅशबोर्ड',
        addBrandOrSponsorImage: 'ब्रँड किंवा प्रायोजक फोटो जोडा',
        analyticsOverview: 'विश्लेषण आढावा',
        overallAnalytics: 'एकूण विश्लेषण',
        leaderboardPublishing: 'लिडरबोर्ड प्रकाशन',
        profile: 'प्रोफाइल',
        managedByMe: 'माझ्याद्वारे व्यवस्थापित',
        dailyQuizCreation: 'दैनिक क्विझ तयारी',
        switchToEducator: 'शिक्षक म्हणून स्विच करा',
        switchToParticipant: 'सहभागी म्हणून स्विच करा',
        language: 'भाषा',
        switchToHindi: 'हिंदीमध्ये स्विच करा',
        switchToEnglish: 'इंग्रजीमध्ये स्विच करा',
        weeklyQuizCompletion: 'साप्ताहिक क्विझ पूर्णता',
        quizCompletionStatus: 'क्विझ पूर्णता स्थिती',
        completed: 'पूर्ण',
        inProgress: 'प्रगतीत',
        notStarted: 'सुरू न झालेले',
        completions: 'पूर्णताए',
        january: 'जानेवारी',
        february: 'फेब्रुवारी',
        march: 'मार्च',
        april: 'एप्रिल',
        may: 'मे',
        june: 'जून',
        july: 'जुलै',
        sendMessages: 'संदेश पाठवा',
        manageUsers: 'वापरकर्ते व्यवस्थापित करा',
        roles: 'भूमिका',
        assignLuckyWinners: 'सौभाग्यवान विजेते नियुक्त करा',
        errorFillFields: 'कृपया सर्व आवश्यक फील्ड भरा.',
        errorInsert: 'प्रश्न जोडण्यात अयशस्वी.',
        errorUnexpected: 'काहीतरी चूक झाली.',
        successInsert: 'प्रश्न यशस्वीरित्या जोडला!',
        successUpdate: 'प्रश्न यशस्वीरित्या अद्यतनित करण्यात आला!',
        confirmEdit: 'संपादनाची पुष्टी करा',
        editPrompt: 'तुम्हाला हा प्रश्न संपादित करायचा आहे का?',
        yes: 'होय',
        enterClearQuestionText: 'स्पष्ट आणि पूर्ण प्रश्न प्रविष्ट करा',
        addOptions: 'उत्तर पर्याय जोडा',
        minimumTwoRequired: 'किमान 2 आवश्यक',
        markCorrectAnswer: 'बरोबर उत्तर निवडा',
        addImageOrAudioOptional: 'वैकल्पिकरित्या फोटो किंवा ऑडिओ अपलोड करा',
        setQuestionDateWithinQuizRange: 'प्रश्न तारीख क्विझ वेळापत्रकाच्या आत सेट करा',
        assignPoints: 'या प्रश्नासाठी गुण नियुक्त करा',
        useSimpleLanguage: 'अधिक समजण्यासाठी सोपी आणि स्पष्ट भाषा वापरा',
        durationInDays: 'कालावधी (दिवसांमध्ये)',
        enterDays: 'दिवसांची संख्या प्रविष्ट करा',
        luckyWinnersManagement: 'सौभाग्यवान विजेते व्यवस्थापन',
        dailyWinners: 'दैनिक विजेते',
        weeklyWinners: 'साप्ताहिक विजेते',
        selectDate: 'तारीख निवडा',
        searchParticipants: 'नाव किंवा आयडीनुसार सहभागी शोधा',
        quizName: 'क्विझ नाव',
        participantId: 'सहभागी आयडी',
        name: 'नाव',
        quizType: 'क्विझ प्रकार',
        score: 'गुण',
        participationDate: 'सहभागाची तारीख',
        performance: 'कामगिरी',
        winnerStatus: 'विजेता स्थिती',
        alreadyWinner: 'आधीच विजेता',
        gold: 'सोने',
        silver: 'चांदी',
        bronze: 'कांस्य',
        sendNotifications: 'सूचना पाठवा',
        clearSelection: 'निवड साफ करा',
        saveWinners: 'विजेते सेव करा',
        noParticipantsFound: 'साठी कोणतेही सहभागी सापडले नाहीत',
        noWinnersSelected: 'कृपया किमान एक विजेता निवडा.',
        noNewWinners: 'कृपया किमान एक नवीन विजेता निवडा.',
        winnersSaved: 'सौभाग्यवान विजेते यशस्वीरित्या सेव केले!',
        saveFailed: 'सेव अयशस्वी',
        whatsappError: 'व्हॉट्सअ‍ॅप त्रुटी',
        excellent: 'उत्कृष्ट',
        good: 'चांगले',
        average: 'सरासरी',
        saveWeeklyWinners: 'साप्ताहिक विजेते सेव करा',
        weeklyWinnersSaved: 'साप्ताहिक विजेते यशस्वीरित्या सेव केले!',
        saveError: 'साप्ताहिक विजेते सेव करताना त्रुटी',
        fetchError: 'सहभागी आणण्यात त्रुटी',
        noParticipantsSelected: 'कृपया किमान एक सहभागी निवडा',
        roleManagement: 'भूमिका व्यवस्थापन',
        roleManagementDesc: 'तुमच्या क्विझ सिस्टीमसाठी भूमिका व्यवस्थापित करा आणि तयार करा',
        addNewRole: 'नवीन भूमिका जोडा',
        roleName: 'भूमिका नाव',
        enterRoleName: 'भूमिका नाव प्रविष्ट करा',
        enterDescription: 'भूमिका वर्णन प्रविष्ट करा',
        permissions: 'परवानग्या',
        createRole: 'भूमिका तयार करा',
        currentRoles: 'सद्य भूमिका',
        searchRoles: 'भूमिका शोधा...',
        createdDate: 'तयार केल्याची तारीख',
        updatedDate: 'अद्यतनित तारीख',
        validationError: 'कृपया सर्व फील्ड भरा.',
        roleCreationFailed: 'भूमिका तयार करण्यात अयशस्वी',
        permissionMappingFailed: 'परवानगी मॅपिंग अयशस्वी',
        roleCreated: 'भूमिका यशस्वीरित्या तयार केली!',
        quizAccessControl: 'क्विझ व्यवस्थापन प्रवेश नियंत्रण',
        quizAccessControlDesc: 'जे वापरकर्ते क्विझ तयार आणि संपादित करू शकतात त्यांना व्यवस्थापित करा',
        addNewUser: 'नवीन वापरकर्ता जोडा',
        quizManagerRole: 'क्विझ व्यवस्थापक भूमिका',
        quizManagerRoleDesc: 'या भूमिकेसह वापरकर्ते क्विझ तयार, संपादित आणि हटवू शकतात',
        createQuizzes: 'नवीन क्विझ तयार करा',
        editQuizzes: 'अस्तित्वातील क्विझ संपादित करा',
        deleteQuizzes: 'क्विझ हटवा',
        manageSettings: 'क्विझ सेटिंग्स व्यवस्थापित करा',
        viewAnalytics: 'विश्लेषण पहा',
        assignPermissions: 'परवानग्या नियुक्त करा',
        currentManagers: 'सद्य क्विझ व्यवस्थापक',
        noManagers: 'कोणतेही क्विझ व्यवस्थापक उपलब्ध नाहीत',
        noEducatorsInSoftware: 'तुमच्या सॉफ्टवेअरमध्ये कोणताही शिक्षक नाही',
        userName: 'वापरकर्ता नाव',
        email: 'ईमेल',
        mobile: 'मोबाइल नंबर',
        role: 'भूमिका',
        accessLevel: 'प्रवेश पातळी',
        dateAdded: 'जोडल्याची तारीख',
        confirmAddManager: 'व्यवस्थापक जोडण्याची पुष्टी करा',
        confirmAddText: 'तुम्हाला खात्री आहे की व्यवस्थापक जोडायचे आहे?',
        yesDelete: 'होय, हटवा',
        invalidManager: 'अवैध व्यवस्थापक निवडला',
        deleteFailed: 'व्यवस्थापक हटवण्यात अयशस्वी',
        deleteSuccess: '{name} क्विझ व्यवस्थापकांमधून काढले',
        roleUpdateFailed: 'भूमिका अद्यतनित करण्यात अयशस्वी',
        roleUpdated: 'व्यवस्थापक भूमिका यशस्वीरित्या अद्यतनित केली',
        selectQuizAndDate: 'क्विझ आणि तारीख निवडा',
        chooseQuiz: 'क्विझ निवडा',
        selectAQuiz: 'क्विझ निवडा',
        viewLeaderboard: 'लिडरबोर्ड पहा',
        seeHowYouRank: 'तुमची रँकिंग इतरांशी तुलना करा आणि स्वतःला आव्हान द्या 💡',
        userNotLoggedIn: 'वापरकर्ता लॉग इन नाही',
        noScoresFound: '❌ या तारखेसाठी कोणतेही गुण सापडले नाहीत.',
        noQuizzesFound: '❌ कोणतेही क्विझ उपलब्ध नाहीत!',
        organizationQuizUrl: 'संस्था क्विझ URL',
        active: 'सक्रिय',
        quickAccess: 'जलद प्रवेश',
        scanQrCode: 'क्विझ पोर्टल ऍक्सेस करण्यासाठी QR कोड स्कॅन करा',
        createNewQuiz: 'नवीन क्विझ तयार करा',
        enterDescription: 'क्विझ वर्णन प्रविष्ट करा',
        quizDurationType: 'क्विझ कालावधी प्रकार',
        singleDay: 'एक दिवस',
        multiDay: 'बहु दिवस',
        enterTopic: 'विषय प्रविष्ट करा',
        subtopic: 'उपविषय',
        enterSubtopic: 'उपविषय प्रविष्ट करा',
        releaseResult: 'निकाल प्रकाशित करा',
        instant: 'तात्काळ',
        scheduled: 'नियोजित',
        resultReleaseDate: 'निकाल प्रकाशन तारीख',
        resultReleaseTime: 'निकाल प्रकाशन वेळ',
        createQuizBtn: 'क्विझ तयार करा',
        validationQuizTitle: 'कृपया क्विझ शीर्षक प्रविष्ट करा',
        validationTopic: 'कृपया विषय प्रविष्ट करा',
        validationDuration: 'कृपया क्विझ कालावधी प्रकार निवडा',
        validationStartDate: 'कृपया सुरुवात तारीख निवडा',
        validationStartTime: 'कृपया सुरुवात वेळ निवडा',
        validationEndDate: 'कृपया शेवट तारीख निवडा',
        validationEndTime: 'कृपया शेवट वेळ निवडा',
        validationReleaseResult: 'कृपया निकाल प्रकाशन पर्याय निवडा',
        validationResultReleaseDate: 'कृपया निकाल प्रकाशन तारीख निवडा',
        validationResultReleaseTime: 'कृपया निकाल प्रकाशन वेळ निवडा',
        quizCreated: 'क्विझ यशस्वीरित्या तयार केले',
        quizCreateFailed: 'क्विझ तयार करण्यात अयशस्वी',
        header: 'संस्था क्विझ',
        subHeader: 'आमच्या संस्थात्मक क्विझ संग्रहातून ब्राउझ करा',
        createSansthaQuiz: '+ संस्था क्विझ तयार करा',
        copyLink: 'लिंक कॉपी करा',
        edit: 'संपादित करा',
        noDescription: 'कोणतेही वर्णन उपलब्ध नाही',
        totalQuestions: 'प्रश्न',
        totalTime: 'मिनिटे',
        quizLinkCopied: 'क्विझ लिंक क्लिपबोर्डवर कॉपी केली!',
        sansthaQuizLists: 'संस्था क्विझ सूची',
        sanstha: 'संस्था',
        quizNotFinished: 'क्विझ अद्याप पूर्ण झाले नाही',
        leaderboardNotAvailable: 'लिडरबोर्ड अद्याप उपलब्ध नाही!',
        quizStillRunning: 'हा क्विझ अद्याप चालू आहे. कृपया समाप्तीनंतर परत या.',
        endsOn: 'समाप्ती:',
        stayTuned: 'जुळून रहा! निकाल क्विझ समाप्त झाल्यावर लवकरच उपलब्ध होईल.',
        gotIt: 'समजले',
        dailyQuizLists: 'दैनिक क्विझ सूची',
        dailyQuizChallenge: 'दैनिक क्विझ आव्हान',
        dailyQuizSubHeader: 'आमच्या दैनिक तयार केलेल्या क्विझसह तुमचे ज्ञान तपासा',
        noDataAvailable: 'कोणताही डेटा उपलब्ध नाही',
        allDifficulties: 'सर्व कठीणपणा',
        beginChallenge: 'आव्हान सुरू करा',
        nextQuestion: 'पुढील प्रश्न',
        noMoreQuestions: 'आणखी प्रश्न नाहीत',
        startTime: 'सुरुवात वेळ',
        prev: 'मागील',
        noQuizzesAvailable: 'सध्या कोणतेही क्विझ उपलब्ध नाहीत.',
        dailyKnowledgeChallenge: "दैनिक प्रश्नमंजुषा",
        generalKnowledgeQuiz: 'सामान्य ज्ञान क्विझ',
        noDetailAvailable: 'कोणताही तपशील उपलब्ध नाही!',
        startQuizNow: 'क्विझ आता सुरू करा',
        quizEnded: 'हा क्विझ समाप्त झाला आहे.',
        exploreMoreQuizzes: 'कृपया अधिक क्विझ एक्स्प्लोर आणि अटेंड करा!',
        viewMoreQuizzes: 'अधिक क्विझ पहा',
        noQuestionToday: 'आज कोणताही प्रश्न उपलब्ध नाही!',
        refresh: 'रिफ्रेश',
        alreadyCompletedToday: 'तुम्ही आजचा क्विझ आधीच पूर्ण केला आहे',
        viewRules: 'नियम पहा',
        quizDetails: 'क्विझ तपशील',
        topicLabel: 'विषय',
        generalKnowledge: 'सामान्य ज्ञान',
        difficultyLabel: 'कठीणपणा',
        availableUntil: 'पर्यंत उपलब्ध',
        notSet: 'सेट नाही',
        rulesAndRegulations: 'नियम व नियमावली',
        rule1: 'प्रत्येक प्रश्नाचे उत्तर देण्यापूर्वी काळजीपूर्वक वाचा.',
        rule2: 'प्रत्येक प्रश्नासाठी सर्वोत्तम शक्य उत्तर निवडा.',
        rule3: 'क्विझ संपण्यापूर्वी तुमची उत्तरे सबमिट करा.',
        rule4: 'बरोबर उत्तरांसाठीच गुण मिळतात.',
        rule5: 'सलग बरोबर उत्तरे तुमचे स्ट्रीक बोनस वाढवतात.',
        rule6: 'कॉपी करणे किंवा बाह्य मदत वापरणे निषिद्ध आहे.',
        completeProfile: 'प्रोफाइल पूर्ण करा',
        completeProfileToContinue: 'कृपया सुरू ठेवण्यासाठी तुमचे प्रोफाइल पूर्ण करा.',
        goToProfile: 'प्रोफाइलवर जा',
        firstQuestionOnDate: 'पहिला प्रश्न {date} रोजी {time} वाजता दिसेल.',
        firstQuestionTomorrow: 'पहिला प्रश्न उद्याय {time} वाजता दिसेल.',
        firstQuestionToday: 'पहिला प्रश्न आज {time} वाजता दिसेल.',
        quizEndedMessage: 'हा क्विझ समाप्त झाला आहे.',
        noQuestionTodayMessage: 'आज कोणताही प्रश्न उपलब्ध नाही.',
        quizEndingToday: 'आजचा क्विझ समाप्त होणार आहे.',
        nextQuestionOnDate: 'पुढील प्रश्न {date} रोजी {time} वाजता दिसेल.',
        nextQuestionTomorrow: 'पुढील प्रश्न उद्याय {time} वाजता दिसेल.',
        nextQuestionToday: 'पुढील प्रश्न आज {time} वाजता दिसेल.',
        morning: 'सकाळ',
        afternoon: 'दुपार',
        evening: 'संध्याकाळ',
        night: 'रात्र',
        startsIn: 'यामध्ये सुरू होतो',
        days: 'दिवस',
        hours: 'तास',
        minutes: 'मिनिटे',
        seconds: 'सेकंद',
        importantNotice: 'महत्वाची सूचना',
        readBeforeStarting: 'सुरू करण्यापूर्वी वाचा',
        ensureStableConnection: 'कृपया स्थिर इंटरनेट कनेक्शन सुनिश्चित करा. एकदा सुरू झाल्यानंतर, टायमर थांबवता येणार नाही.',
        completeAllQuestions: 'वेळ संपण्यापूर्वी सर्व प्रश्न पूर्ण करा',
        noExternalResources: 'परीक्षेदरम्यान बाह्य संसाधनांची परवानगी नाही',
        submitBeforeExpiry: 'टायमर संपण्यापूर्वी उत्तरे सबमिट करा',
        details: 'तपशील',
        rules: 'नियम',
        results: 'परिणाम',
        quizInformation: "प्रश्नमंजुषेची माहिती",
        subjectCategory: 'विषय श्रेणी',
        quizType: "प्रश्नमंजुषेचा प्रकार",
        quizRules: "प्रश्नमंजुषेचे नियम",
        quizTips: "प्रश्नमंजुषेसाठी सूचना",
        difficultyLevel: 'कठीणपणाची पातळी',
        totalQuestions: 'एकूण प्रश्न',
        availableDate: 'क्विझ समाप्त होण्याची तारीख',
        time: 'वेळ',
        dq_start_time: "दैनिक क्विझ सुरू होण्याची वेळ",
        readAllOptions: 'सर्व पर्याय काळजीपूर्वक वाचा',
        focusTimeManagement: 'वेळ व्यवस्थापनावर लक्ष केंद्रित करा',
        solveEasyFirst: 'आधी सोपे प्रश्न सोडवा',
        resultsComingSoon: 'परिणाम लवकरच येत आहेत',
        resultsWillBeAvailable: 'परीक्षा संपल्यानंतर परिणाम उपलब्ध होतील.',
        mon: 'सोम',
        tue: 'मंगळ',
        wed: 'बुध',
        thu: 'गुरु',
        fri: 'शुक्र',
        sat: 'शनि',
        sun: 'रवि',
        jan: 'जान',
        feb: 'फेब्रु',
        mar: 'मार्च',
        apr: 'एप्रिल',
        may: 'मे',
        jun: 'जून',
        jul: 'जुलै',
        aug: 'ऑग',
        sep: 'सप्टें',
        oct: 'ऑक्टो',
        nov: 'नोव्हें',
        dec: 'डिसें',
        adminTitle: 'जैनडायरेक्ट क्विझ - अ‍ॅडमिन डॅशबोर्ड',
        totalSanstha: 'एकूण संस्था',
        totalQuizzes: 'एकूण तयार केलेले क्विझ',
        activeQuizzes: 'सक्रिय क्विझ',
        totalParticipants: 'एकूण सहभागी',
        userEngagement: 'वापरकर्ता सहभाग वाढ',
        engagementChannels: 'सहभाग चॅनेल्स आढावा',
        whatsappMessages: 'पाठवलेले व्हॉट्सअ‍ॅप संदेश',
        emailMessages: 'पाठवलेले ईमेल',
        avgScore: 'सरासरी गुण',
        dailyActiveUsers: 'दैनिक सक्रिय क्विझ उत्तरदाते',
        topQuizzes: 'प्रयत्नांनुसार शीर्ष 5 क्विझ',
        platformUsageDistribution: 'प्लॅटफॉर्म वापर वितरण',
        mostPopularQuizzes: 'अलीकडील सर्वात लोकप्रिय क्विझ',
        newParticipants: 'नवीन सहभागी',
        totalEducators: 'शिक्षक',
        attempts: 'प्रयत्न',
        viewDetails: 'तपशील पहा',
        noDescription: 'कोणतेही वर्णन नाही',
        allSansthas: 'सर्व संस्था',
        searchPlaceholder: 'शोधा...',
        noLocation: 'कोणतेही स्थान नाही',
        report: 'अहवाल',
        messages: 'संदेश',
        logout: 'लॉगआउट',
        shortAppName: 'JD क्विझ',
        fullAppName: 'जैनडायरेक्ट क्विझ',
        title: 'क्विझ',
        organization: 'संस्था नाव',
        description: 'वर्णन',
        statistics: 'क्विझ आकडेवारी',
        total_questions: 'एकूण प्रश्न',
        total_points: 'एकूण गुण',
        total_time: 'एकूण वेळ',
        duration: 'कालावधी',
        dates: 'तारखा',
        start_date: 'सुरुवात तारीख',
        end_date: 'शेवट तारीख',
        time: 'वेळ',
        start: 'सुरुवात',
        end: 'समाप्ती',
        additional_info: 'अतिरिक्त माहिती',
        participants_limit: 'सहभागी मर्यादा',
        unlimited: 'अमर्यादित',
        difficulty: 'कठीणपणा पातळी',
        intermediate: 'मध्यम',
        quiz_not_started: 'क्विझ अद्याप सुरू झाले नाही',
        quiz_live: 'क्विझ सुरू करा',
        quiz_ended: 'क्विझ समाप्त झाले',
        quizNotAvailable: 'क्विझ वापरकर्त्यांसाठी उपलब्ध नाही',
        noQuestionsInQuiz: 'या क्विझमध्ये कोणतेही प्रश्न नाहीत',
        leaderboardPublishMode: 'लिडरबोर्ड प्रकाशन मोड',
        selectOption: 'पर्याय निवडा',
        autoPublish: 'स्वयं प्रकाशन',
        manualPublish: 'मॅन्युअल प्रकाशन',
        autoPublishHint: 'क्विझ समाप्त झाल्यावर लिडरबोर्ड स्वयं प्रकाशित होईल.',
        manualPublishHint: 'लिडरबोर्ड प्रशासकाद्वारे मॅन्युअली प्रकाशित केले जाईल.',
        manualPublishBadge: 'लिडरबोर्ड मॅन्युअली प्रकाशित करावे लागेल',

        enterPointsForRank: 'रँक {rank} साठी गुण प्रविष्ट करा',
        scoringManagement: 'क्विझ रँकिंग आणि स्कोरिंग व्यवस्थापन',
        scoringManagementSubtitle: 'रँकिंग, उत्तरे आणि स्कोरिंग पॅरामीटर्स कॉन्फिगर करा',
        rankBonusPoints: 'रँक बोनस गुण',
        rankBonusPointsDescription: 'हे अतिरिक्त बोनस गुण आहेत जे क्विझमध्ये त्यांच्या अंतिम रँकच्या आधारे वापरकर्त्यांना दिले जातात. उच्च रँकला अधिक बोनस गुण मिळतील.',
        addMoreRank: '+ अधिक रँक जोडा',
        bonusPoints: 'बोनस गुण (अतिरिक्त बक्षिसे)',
        bonusPointsDescription: 'क्विझ दरम्यान विशेष अटींच्या आधारे वापरकर्त्यांना अतिरिक्त गुण देण्यासाठी बोनस नियम सक्षम करा.',
        fastestAnswer: 'सर्वात जलद उत्तर (5 सेकंदात)',
        allAnswersCorrect: 'सर्व उत्तरे बरोबर',
        consecutiveParticipation: 'सलग क्विझ सहभागिता (3+ दिवस)',
        firstAttemptDay: 'दिवसाचा पहिला क्विझ प्रयत्न',
        comingSoon: '(लवकरच येत आहे)',
        negativeMarking: 'निगेटिव्ह मार्किंग (दंड गुण)',
        negativeMarkingDescription: 'प्रत्येक चुकीच्या उत्तरासाठी वापरकर्त्याच्या स्कोअरमधून गुण कापा.',
        wrongAnswer: 'चुकीचे उत्तर',
        saveConfiguration: 'कॉन्फिगरेशन जतन करा',
        confirmNotification: 'सूचना दृढीकरण',
        whatsappNotifyQuestion: 'तुम्हाला या क्विझबद्दल वापरकर्त्यांना सूचित करण्यासाठी WhatsApp संदेश पाठवायचा आहे का?',
        no: 'नाही',
        yes: 'होय',
        // Leaderboard translations
        quizTitle: 'क्विझ शीर्षक',
        totalParticipants: 'एकूण सहभागी',
        averageScore: 'सरासरी गुण',
        yourRank: 'तुमची रॅंक',
        date: 'तारीख',
        dateRange: 'तारीख श्रेणी',
        dailyWinner: 'दैनिक विजेता',
        weeklyWinner: 'साप्ताहिक विजेता',
        monthlyWinner: 'मासिक विजेता',
        finalWinner: 'अंतिम विजेता',
        fastFinger: 'वेगवान बोट',
        top5: 'शीर्ष 5',
        top10: 'शीर्ष 10',
        luckyWinner: 'नशीबवान विजेता',
        queAnsHistory: 'प्रश्न आणि उत्तर इतिहास',
        ourSponsors: 'आमचे प्रायोजक',
        sponsoredBy: 'प्रायोजित द्वारे',
        quizQuestions: 'क्विझ प्रश्न',
        dailyQuiz: 'दैनिक क्विझ',
        correctAnswer: 'योग्य उत्तर',
        participantName: 'सहभागीचे नाव',
        location: 'स्थान',
        totalScore: 'एकूण गुण',
        totalTime: 'एकूण वेळ',
        mobile: 'मोबाईल',
        resultsNotPublished: 'परिणाम प्रकाशित केले नाहीत',
        leaderboardNotAvailable: 'लिडरबोर्ड उपलब्ध नाही',
        backToDashboard: 'डॅशबोर्डवर परत जा',
        noParticipantsFound: 'कोणतेही सहभागी सापडले नाहीत',
        firstRank: '1st रॅंक',
        secondRank: '2nd रॅंक',
        thirdRank: '3rd रॅंक',
        searchByParticipantName: 'सहभागीच्या नावानुसार शोधा',
        fastestFingerFirstResult: 'वेगवान बोट पहिला परिणाम',
        top10Result: 'शीर्ष 10 परिणाम',
        top5Result: 'शीर्ष 5 परिणाम',
        luckyWinnerResult: 'नशीबवान विजेता परिणाम',
        luckyWinnersNotAvailable: 'नशीबवान विजेते उपलब्ध नाहीत',
        top5WinnersNotAvailable: 'शीर्ष 5 विजेते उपलब्ध नाहीत',
        top10WinnersNotAvailable: 'शीर्ष 10 विजेते उपलब्ध नाहीत',
        resultsWillBeAnnounced: 'परिणाम लवकरच जाहीर केले जातील. कृपया नंतर तपासा.',
        resultsNotPublishedYet: 'या कालावधीसाठी परिणाम अजून प्रकाशित केले गेले नाहीत.',
        // EduLeadership translations
        downloadExcel: 'एक्सेल डाउनलोड करा',
        downloadPDF: 'पीडीएफ डाउनलोड करा',
        viewQuizQuestions: 'क्विझ प्रश्न पहा',
        publishResults: 'परिणाम प्रकाशित करा',
        quizQuestions: 'क्विझ प्रश्न',
        dailyQuiz: 'दैनिक क्विझ',
        correctAnswer: 'योग्य उत्तर',
        firstRank: '1st रॅंक',
        secondRank: '2nd रॅंक',
        thirdRank: '3rd रॅंक',
        fastestFingerFirstResult: 'वेगवान बोट पहिला परिणाम',
        top10Result: 'शीर्ष 10 परिणाम',
        top5Result: 'शीर्ष 5 परिणाम',
        luckyWinnerResult: 'नशीबवान विजेता परिणाम',
        searchByParticipantName: 'सहभागीच्या नावानुसार शोधा',
        participantName: 'सहभागीचे नाव',
        location: 'स्थान',
        totalScore: 'एकूण गुण',
        totalTime: 'एकूण वेळ',
        mobile: 'मोबाईल',
        trueFalse: "बरोबर / चुकीचे",
        showingEntries: '{first} पासून {last} पर्यंत {totalRecords} प्रविष्टी दाखवत आहे',
        weekStillRunning: 'हा आठवडा अजून सुरू आहे, त्यामुळे प्रकाशन अक्षम आहे.',
        weekCanPublish: 'या आठवड्याचे परिणाम प्रकाशित केले जाऊ शकतात.',
        monthStillRunning: 'हा महिना अजून सुरू आहे, त्यामुळे प्रकाशन अक्षम आहे.',
        monthCanPublish: 'या महिन्याचे परिणाम प्रकाशित केले जाऊ शकतात.',
        rulesAndRegulation: "नियम व अटी",
        addNewRule: 'नवीन नियम जोडा',
        minimumRulesRequired: 'किमान 4 नियम आवश्यक आहेत',
        todaysParticipants: 'आजचे सहभागी',
        weeklyParticipants: 'साप्ताहिक सहभागी',
        monthlyParticipants: 'मासिक सहभागी',
        totalParticipants: 'एकूण सहभागी',
    },
};
// Add more languages as needed

// Load saved language from localStorage
const savedLang = localStorage.getItem('lang') || 'en';

// Supported locales
const supportedLocales = ['en', 'hi', 'kn', 'gu', 'mr'];

// Validate locale - fallback to 'en' if not supported
const validLocale = supportedLocales.includes(savedLang) ? savedLang : 'en';

const i18n = createI18n({
    locale: validLocale, // use saved language or default to English
    fallbackLocale: 'en',
    messages,
    legacy: false,
    missingWarn: false,
    fallbackWarn: false
});

export default i18n;
